import $$ from 'dom7';

import HomePage from '../pages/home.f7.html';
import LoginPage from '../pages/login.f7.html';
import RegisterPage from '../pages/register.f7.html';
import TransactionPage from '../pages/transaction.f7.html';
import InvestPage from '../pages/invest.f7.html';
import InvestDashboardPage from '../pages/invest-dashboard.f7.html';
import ReturnPage from '../pages/returns.f7.html';
import InvestWithdrawPage from '../pages/invest-withdraw.f7.html';
import EarningPage from '../pages/earning.f7.html';
import MyTeamPage from '../pages/my-team.f7.html';
import PinPage from '../pages/pin.f7.html';
import KycPage from '../pages/kyc.f7.html';

import SettingsPage from '../pages/settings.f7.html';
import FundWalletPage from '../pages/fund-wallet.f7.html';
import NotFoundPage from '../pages/404.f7.html';
var baseURL = "https://api.digitalmoneyexpress.com/v2/";
var country = localStorage.getItem('country');

// Currency configuration map
let INR = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});
let INR2 = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
const isPlay = false;

/* ── Plan badge ────────────────────────────────────────────────────────────────
   Renders an investment's plan as a tier-styled pill (silver / gold / diamond),
   matching the plan chooser on the invest screen. Emblems use `currentColor`
   rather than gradient fills on purpose: a list repeats this badge many times and
   duplicated SVG gradient ids would collide across the document. Any plan code the
   admin adds later falls back to the house gold treatment. */
var PLAN_TIERS = ['silver', 'gold', 'diamond'];
var PLAN_BADGE_ICON = {
  silver:  '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.8l7.4 4.27v8.53L12 19.87 4.6 15.6V7.07z" opacity=".9"/></svg>',
  gold:    '<svg viewBox="0 0 24 24" fill="currentColor"><g transform="skewX(-10)"><rect x="4.5" y="12.5" width="9.5" height="5" rx="1.1" opacity=".75"/><rect x="13" y="12.5" width="9.5" height="5" rx="1.1" opacity=".9"/><rect x="8.8" y="6.6" width="9.5" height="5" rx="1.1"/></g></svg>',
  diamond: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6.4 3.6h11.2l3.3 4.9L12 20.4 3.1 8.5z"/></svg>',
  fallback:'<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="7"/></svg>'
};
function planTierOf(code) {
  var k = String(code || '').toLowerCase();
  return PLAN_TIERS.indexOf(k) !== -1 ? k : '';
}
// `row` is an investmentList row. Returns '' when the row carries no plan at all.
function planBadge(row, extraClass) {
  var name = row.planName || row.planCode || '';
  if (!name) return '';
  var tier = planTierOf(row.planCode);
  var icon = PLAN_BADGE_ICON[tier] || PLAN_BADGE_ICON.fallback;
  // "Gold Plan" → "Gold"; the badge context already reads as a plan.
  var label = String(name).replace(/\s*plan\s*$/i, '');
  return '<span class="pbadge' + (tier ? ' pbadge--' + tier : '') + (extraClass ? ' ' + extraClass : '') + '">' +
    '<span class="pbadge__ico">' + icon + '</span>' +
    '<span class="pbadge__txt">' + label + '</span>' +
  '</span>';
}

var routes = [
  {
    path: '/',
    component: HomePage,
    name: 'Home',
    on: {
      pageInit: function (e, page) {
        var app = this.app;
        //get helpline Number
        app.methods.getSettings(function(data) {
          $$('.helpLinenumber').html(data.help);
          $$('.call-link').attr('href', 'tel:' + data.help);
          $$('.whatsapp-link').attr('href', 'https://wa.me/' + String(data.help).replace(/[^0-9]/g, ''));
          $$('.telegram-link').attr('href', data.telegram);
        });
        //on open of how to use popup
        $$('.sheet-loan--htu').on('popup:open', function (e, popup) {
          app.dialog.progress('Loading...');
          app.methods.getSettings(function(data) {
            app.dialog.close();
            app.popup.open('.sheet-loan--htu');
            var player = new videojs('vid1', {
              controls: true,
              autoplay: false,
              preload: 'auto',
              fluid: true,
              responsive: true,
              sources: [{src: data.ytVideo, type: 'video/youtube'}],
              "techOrder": ["youtube"],
            });
          });
        });
        $$('.skip-if-watched').off('click').on('click', function() {
          localStorage.setItem('howToUse', 'true');
          app.popup.close('.sheet-loan--htu');
        });
        //swiper slider
        var swiper = app.swiper.create('.swiper-container', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
            $$('.profile-name').html(data.name);
            $$('.loggeninProfileUI').attr('src','https://ui-avatars.com/api/?background=201a0e&color=dfc288&length=2&rounded=true&bold=true&font-size=0.42&name='+encodeURIComponent(data.name));
            $$('.profile-username').html(data.username || '—');
            $$('.profile-email').html(data.email);
            $$('.profile-phone').html(data.phone);
            $$('.profile-dob').html(data.dob);
            $$('.profile-country').html(data.country || '—');
            $$('.profile-dialcode').html(data.dialCode || data.dial_code || data.countryCode || data.phonecode || '—');
            // KYC status pill in the profile popup — DISABLED for now (KYC feature hidden)
            /*
            app.methods.request(baseURL + 'kyc.php', { kycStatus: 1, token: localStorage.getItem('authToken') }, 'json',
              function() {},
              function(res) {
                if (!res || res.status !== 'success') return;
                var st = res.kycStatus === 'not_submitted' ? 'none' : (res.kycStatus || 'none');
                var map = {
                  approved: { txt: 'Verified', sub: 'Your identity is verified — withdrawals enabled' },
                  pending:  { txt: 'Under review', sub: 'Your documents are being reviewed' },
                  rejected: { txt: 'Rejected', sub: 'Verification failed — tap to resubmit' },
                  none:     { txt: 'Not started', sub: 'Verify your identity to enable withdrawals' }
                };
                var m = map[st] || map.none;
                $$('.pp__kyc-status').removeClass('pp__kyc-status--approved pp__kyc-status--pending pp__kyc-status--rejected pp__kyc-status--none').addClass('pp__kyc-status--' + st);
                $$('.pp__kyc-status-txt').html(m.txt);
                $$('.pp__kyc-sub--text').html(m.sub);
              },
              function() {});
            */
            $$('.profile-link').attr('href','#');
            $$('.profile-link').addClass('popup-open');
            $$('.profile-link').attr('data-popup','#profile-popup');
            //dashboard
            //check if isPlay is true
            if(isPlay) {
              var link = 'https://app.digitalmoneyexpress.com/';
              $$('.item__link--transaction').attr('href',link);
              $$('.item__link--deposit').attr('href',link);
              $$('.item__link--withdraw').attr('href',link);
              $$('.item__link--team').attr('href',link);
              $$('.item__link--rewards').attr('href',link);
              $$('.item__link--portfolio').attr('href',link);
              $$('.item_link--pin').attr('href',link);
              $$('.item__link--fund').attr('href',link);
              $$('.invest-btn--home').attr('href',link);
              $$('.hp__promo-btn').attr('href',link).addClass('external').attr('target','_system');
              $$('.wallet__link').addClass('external');
              $$('.wallet__link').attr('target','_system');
              $$('.invest__card').addClass('hidden');
              $$('.game__card').addClass('hidden');
            } else {
              $$('.item__link--transaction').attr('href','/transaction/investment/');
              $$('.item__link--deposit').attr('href','/invest/');
              $$('.item__link--withdraw').attr('href','/invest-withdraw/');
              $$('.item__link--team').attr('href','/my-team/');
              $$('.item__link--rewards').attr('href','/earning/');
              $$('.item__link--portfolio').attr('href','/invest-dashboard/');
              $$('.item_link--pin').attr('href','/pin/');
              $$('.item__link--fund').attr('href','/fund-wallet/');
              $$('.invest-btn--home').attr('href','/invest/');
              $$('.hp__promo-btn').attr('href','/invest/');
              $$('.invest__card').removeClass('hidden');
              $$('.game__card').removeClass('hidden');
              $$('.item_link--transfer').attr('href','/money-transfer/');
            }
            // Show the last known portfolio value immediately — avoids a $0.00 flash on load
            // and keeps a sensible value if the API call errors (its error handler is a no-op).
            (function() {
              var cv  = parseFloat(localStorage.getItem('homePortfolioVal'));   // total invested
              var cxq = parseFloat(localStorage.getItem('homeXautQty'));        // cached total XAUt
              var cr  = parseFloat(localStorage.getItem('homeGoldRate'));        // current rate
              if (!isNaN(cv) && cxq > 0) {
                var mv = (!isNaN(cr) && cr > 0) ? cxq * cr : cv;
                $$('.home__wallet--amount').html(INR2.format(mv));
                $$('.hp__holdings-val').html(cxq.toFixed(4) + ' <small>XAUt</small>');
              }
            })();
            //get investment details
            app.methods.getUserDataInvest(function(data) {
              if(data.status == 'success') {
                $$('.hp__earnings-val').html(INR2.format(data.investment));
                $$('.invest-btn--home').attr('href','/invest-dashboard/');
                // Portfolio value: prefer `investment`, fall back to `wallet`; only update on a valid number
                var portfolioVal = parseFloat(data.investment);
                if (isNaN(portfolioVal)) portfolioVal = parseFloat(data.wallet);
                var currentRate = parseFloat(data.goldRate) || 0;      // current XAUt market rate
                var avgBuyPrice = parseFloat(data.avgGoldRate) || 0;   // average buying price of 1 XAUt
                if (!isNaN(portfolioVal)) {
                  // cache the good values so the next load shows them instantly / survives errors
                  localStorage.setItem('homePortfolioVal', portfolioVal);
                  if (currentRate > 0) localStorage.setItem('homeGoldRate', currentRate);
                  // Use pre-computed total from backend (most accurate).
                  // avgGoldRate is a simple average — NOT weighted — so invested/avgGoldRate gives
                  // wrong XAUt for multiple investments at different gold prices.
                  var xautQty = parseFloat(data.totalXautHoldings) || 0;
                  if (xautQty === 0 && data.data && data.data.length) {
                    for (var ii = 0; ii < data.data.length; ii++) {
                      var inv = data.data[ii];
                      if (String(inv.status) === '1') {
                        var units = parseFloat(inv.xautUnits) || 0;
                        if (units === 0) {
                          var invRate = parseFloat(inv.purchaseGoldRate) || 0;
                          if (invRate > 0) units = (parseFloat(inv.amount) || 0) / invRate;
                        }
                        xautQty += units;
                      }
                    }
                  }
                  if (xautQty === 0 && avgBuyPrice > 0) xautQty = portfolioVal / avgBuyPrice;
                  if (xautQty > 0) localStorage.setItem('homeXautQty', xautQty);
                  // True weighted-average buy price (invested ÷ actual holdings), used for P&L %
                  var effectiveAvg = xautQty > 0 ? portfolioVal / xautQty : avgBuyPrice;
                  $$('.hp__holdings-val').html(parseFloat(xautQty).toFixed(4) + ' <small>XAUt</small>');
                  // Portfolio value = current MARKET value (holdings × current rate), with P/L vs avg buy price.
                  // The chart component refines this with the live CoinGecko price; both show the MARKET value so
                  // it never flips back to the invested amount.
                  // Prefer the shared live price (matches the chart component + Portfolio page);
                  // fall back to the backend goldRate until the first CoinGecko fetch caches one.
                  var liveRate = (window.sharedGoldPrice && window.sharedGoldPrice(0)) || 0;
                  var mktRate = liveRate > 0 ? liveRate : currentRate;
                  if (mktRate > 0 && xautQty > 0) {
                    var marketVal = xautQty * mktRate;
                    var pl = marketVal - portfolioVal;
                    var plPct = effectiveAvg > 0 ? (mktRate / effectiveAvg - 1) * 100 : 0;
                    var up = pl >= 0;
                    $$('.home__wallet--amount').html(INR2.format(marketVal));
                    $$('.hp__pf-growth-val').html(Math.abs(plPct).toFixed(2) + '%');
                    $$('.hp__pf-gain-abs').html((up ? '+' : '-') + INR2.format(Math.abs(pl)));
                    $$('.hp__pf-gain-period').html(up ? 'Market Profit' : 'Market Loss');
                    $$('.hp__pf-growth svg').css('transform', up ? 'none' : 'rotate(180deg)');
                    $$('.hp__pf-growth')[up ? 'removeClass' : 'addClass']('hp__pf-growth--down');
                    $$('.hp__pf-gain-abs')[up ? 'removeClass' : 'addClass']('hp__pf-gain-abs--down');
                  } else {
                    $$('.home__wallet--amount').html(INR2.format(portfolioVal));
                  }
                  // Digital Gold card — holdings + current market value (only when an investment is active)
                  var hasActive = false;
                  if (data.data && data.data.length) {
                    for (var ai = 0; ai < data.data.length; ai++) {
                      if (String(data.data[ai].status) === '1') { hasActive = true; break; }
                    }
                  }
                  if (hasActive) {
                    var marketValue = currentRate > 0 ? (xautQty * currentRate) : portfolioVal;
                    $$('.hp__gold-amt').html(parseFloat(xautQty).toFixed(4) + ' <small>XAUt</small>');
                    $$('.hp__gold-value-num').html(INR2.format(marketValue));
                  }
                }
              }
            });
            // Earnings & network statistics
            app.methods.request(
              baseURL + 'earning.php',
              { getEarnings: true, token: localStorage.getItem('authToken') },
              'json',
              function() {},
              function(res) {
                if (res.status == 'success') {
                  var d = res.data || {};
                  $$('.hp__earn-value').html(INR2.format(d.todayRoi));          // Today's Earnings
                  $$('.hp-commission').html(INR2.format(d.totalCommission));
                  $$('.hp-direct-referral').html(INR2.format(d.directReferral));
                  $$('.hp-direct-members').html(d.directMembers);
                  $$('.hp-team-members').html(d.teamMembers);
                  $$('.hp-team-business').html(INR2.format(d.teamBusiness));
                  $$('.hp-team-bonus').html(INR2.format(d.teamRoiBonus));
                  // NOTE: the portfolio chart's gain row (growth %, abs, period) is the live MARKET
                  // profit/loss vs the buying price — it's computed in the home.f7.html chart, not here.
                }
              },
              function() {}
            );
          } else {
            app.dialog.close();
            //remove authToken
            localStorage.removeItem('authToken');
            localStorage.setItem('isloggedIN', 'false');
            // clear cached portfolio so a new/guest user doesn't see the previous user's value
            localStorage.removeItem('homePortfolioVal');
            localStorage.removeItem('homeGoldRate');
            $$('.home__wallet--amount').html(INR2.format(0));
            //check if isPlay is true
            if(isPlay) {
              var link = 'https://app.digitalmoneyexpress.com/';
              $$('.item__link--locker').attr('href',link);
              $$('.item__link--transaction').attr('href',link);
              $$('.item__link--deposit').attr('href',link);
              $$('.item__link--withdraw').attr('href',link);
              $$('.wallet__link').addClass('external');
              $$('.wallet__link').attr('target','_system');
            } else {
              
            }
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').off('click').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').off('click').on('click', function() {
          var shareLink = 'https://app.digitalmoneyexpress.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join DigiMoney Express',
              text: 'Use my referral code to join DigiMoney Express!',
              url: '' + shareLink
            }).catch(() => {});
          } else {
            console.log('Web Share API not supported in this browser.');
            //copy the link to clipboard
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(shareLink).then(function() {
                app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
              });
            }
          }
        });
        // $$('.item_link--transfer').on('click', function() {
        //   app.toast.show({
        //     text: 'Money transfer to another person is not available right now!',
        //     closeTimeout: 3000,
        //   });
        // });
        $$('.home__wallet--recharge, .home__wallet--ticket, .home__wallet--transfer').off('click').on('click', function() {
          //show a toast that coming soon
          app.toast.show({
            text: 'This feature is coming soon!',
            closeTimeout: 3000,
          });
        });
        $$('.wallet_info').off('click').on('click', function() {
          app.dialog.alert('Wallet is a virtual account where you can store your money, you can deposit, withdraw, transfer and use it \
          for various services like recharges, bill payments, etc. You can also earn cashback on every transaction you make from your wallet. \
          Cashback balance only can be used for recharges, bill payments, etc. and cannot be withdrawn to your bank account.', 'Wallet Info');
        });
      }
    }
  },
  {
    path: '/login/',
    component: LoginPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              setTimeout(function() {
                app.views.main.router.navigate({name: 'Home'});
              }, 1000);
            }
          }
        );
        $$('.lgNum').off('click').on('click',function(){
          if (!$$('#userLogin')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            login();
          }
        });
        //user login
        function login() {
          var formdata = $('#userLogin').serialize();
          var data = formdata+'&checkLogin=true';
          app.methods.request(
            baseURL+'ajaxAuthentication.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                localStorage.setItem('phone', data.phone);
                app.popup.open('.sheet-OTP--verification');
                window.startOtpCooldown('.sheet-OTP--verification', 180);
                // check if phone is numeric or not
                //mask phone number only show last 4 digits
                if(isNaN(data.phone)) {
                  $$('.otpText').html('We have sent a 6-digit OTP to your email address ' +data.phone);
                } else {
                  var phone = data.phone;
                  var masked = phone.replace(/.(?=.{4})/g, '*');
                  $$('.sheet-OTP--verification--phonenumber').html(masked);
                }
              }
              else if(data.code == 'deactivated') {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
              else if(data.code == 'not-verified') {
                localStorage.setItem('phone', data.phone);
                app.popup.open('.sheet-OTP--verification');
                window.startOtpCooldown('.sheet-OTP--verification', 180);
                if(isNaN(data.phone)) {
                  $$('.otpText').html('We have sent a 6-digit OTP to your email address ' +data.phone);
                } else {
                  var phone = data.phone;
                  var masked = phone.replace(/.(?=.{4})/g, '*');
                  $$('.sheet-OTP--verification--phonenumber').html(masked);
                }
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
        // ── Mobile-number reset intl-tel-input (kept for future use) ──
        // $$('.sheet-forget--pass').on('popup:open', function (e, popup) {
        //   (function() {
        //     var fpTelInput = document.getElementById('fp-username');
        //     var fpDialCode = document.getElementById('countryCodeReset');
        //     if (fpTelInput && window.intlTelInput) {
        //       const iti = window.intlTelInput(fpTelInput, {
        //         initialCountry: 'auto',
        //         geoIpLookup: function(callback) {
        //           fetch('https://ipapi.co/json/')
        //             .then(function(res) { return res.json(); })
        //             .then(function(data) { callback(data.country_code); })
        //             .catch(function() { callback('in'); });
        //         },
        //         separateDialCode: true,
        //         preferredCountries: ['in', 'bd', 'us', 'gb', 'ae', 'sg'],
        //         useFullscreenPopup: false,
        //       });
        //       const syncDialCode = () => {
        //         const data = iti.getSelectedCountryData();
        //         if (fpDialCode) fpDialCode.value = (data.iso2 || 'in').toUpperCase();
        //       };
        //       fpTelInput.addEventListener('countrychange', syncDialCode);
        //       syncDialCode();
        //       window._lp_iti = iti;
        //     }
        //   })();
        // });
        //forget password
        $(document).off('click', '.fpBTN');
        $(document).on('click','.fpBTN',function(){
          if (!$$('#fp-username')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            Forgetpassword();
          }
        });
        function Forgetpassword() {
          // Identifier is an email or username; backend resolves it and sends OTP to the registered email.
          var username = $$('#fp-username').val();
          app.methods.request(
            baseURL+'ajaxAuthentication.php',
            {forgetPass: true, username: username},
            'json',
            function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.close('.sheet-forget--pass');
                app.popup.open('.sheet-forget--otp');
                window.startOtpCooldown('.sheet-forget--otp', 180);
                localStorage.setItem('phone', data.phone);
                if(isNaN(data.phone)) {
                  $$('.resetPassText').html('We have sent a 6-digit OTP to your email address ' +data.phone);
                } else {
                  var phone = data.phone;
                  var masked = phone.replace(/.(?=.{4})/g, '*');
                  $$('.sheet-forget--otp--phonenumber').html(masked);
                }
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
        //new password show/hide toggle
        $(document).off('click', '#npassToggle');
        $(document).on('click', '#npassToggle', function() {
          var npass = document.getElementById('npass');
          if (!npass) return;
          var isPw = npass.type === 'password';
          npass.type = isPw ? 'text' : 'password';
          var icon = this.querySelector('i');
          if (icon) icon.textContent = isPw ? 'eye_slash' : 'eye';
        });
        //change password
        $(document).off('click', '.fpBTNotp');
        $(document).on('click','.fpBTNotp',function(e){
          e.preventDefault();
          if (!$$('#changePass')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            changePass();
          }
        });
        function changePass() {
          var formdata = $('#changePass').serialize();
          var data = formdata+'&phone='+localStorage.getItem('phone')+'&changePass=true';
          app.methods.request(
            baseURL+'ajaxAuthentication.php',
            data,
            'json',
            function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.close('.sheet-forget--otp');
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      }
    }
  },
  {
    path: '/register/referral/:referralCode',
    component: RegisterPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        //get referral code from url
        var referralCode = page.route.params.referralCode;
        $$('#referral').val(referralCode);
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.views.main.router.navigate({name: 'Home'});
            }
          }
        );
        $$('#dob').on('input', function() {
          let val = $$('#dob').val();
          // Remove all non-digits
          val = val.replace(/\D/g, '');
          // Format as dd/mm/yyyy
          if (val.length > 2 && val.length <= 4) {
            val = val.slice(0,2) + '/' + val.slice(2);
          } else if (val.length > 4) {
            val = val.slice(0,2) + '/' + val.slice(2,4) + '/' + val.slice(4,8);
          }
          $$('#dob').val(val);
        });
        //user registration
        $$('.btnSignup').off('click').on('click',function(){
          if (!$$('#userSignup')[0].checkValidity()) {
            console.log('Check Validity!');
          } else {
            signup();
          }
        });
        $('#gender').select2({minimumResultsForSearch: -1, width: '100%'});
        $('#gender').closest('.rp__select-row').addClass('rp__select-row--s2');
        //user signup
        function signup() {
          var formdata = $('#userSignup').serialize();
          var data = formdata+'&userSignup=true';
          app.methods.request(
            baseURL+'ajaxAuthentication.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                localStorage.setItem('phone',data.phone);
                app.popup.open('.sheet-OTP--verification');
                window.startOtpCooldown('.sheet-OTP--verification', 180);
                if(isNaN(data.phone)) {
                  $$('.otpText').html('We have sent a 6-digit OTP to your email address ' +data.phone);
                } else {
                  var phone = data.phone;
                  var masked = phone.replace(/.(?=.{4})/g, '*');
                  $$('.sheet-OTP--verification--phonenumber').html(masked);
                }
              }
              else if(data.code == 'exist') {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      }
    }
  },
  {
    path: '/transaction/:type',
    component: TransactionPage,
    name: TransactionPage,
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        var type = page.route.params.type;
        // ─── Tabbed history: Investment Payments · Commissions · Withdrawals ───
        var thToken = localStorage.getItem('authToken');
        var thTab = (type === 'commission' || type === 'commissions') ? 'commissions'
                  : (type === 'withdrawal' || type === 'withdrawals') ? 'withdrawals'
                  : 'payments';
        var thFilter = 'all';
        var thCache = {};
        function thEsc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
        function thStatus(s){ s = String(s); if (s === '1') return { k:'success', l:'Success' }; if (s === '0') return { k:'pending', l:'Pending' }; return { k:'failed', l:'Failed' }; }
        // Payment dates arrive as "DD/MM/YYYY HH:MM:SS"; reformat to the "7th October, 2026"
        // style the backend already sends for commissions/withdrawals. Non-matching / already
        // formatted strings pass through untouched.
        var TH_MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        function thFmtDate(s){
          if (!s) return '';
          var m = String(s).match(/^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})/);
          if (!m) return String(s);
          var day = parseInt(m[1], 10), mon = parseInt(m[2], 10), year = m[3];
          if (mon < 1 || mon > 12 || day < 1 || day > 31) return String(s);
          var suf = (day % 10 === 1 && day !== 11) ? 'st'
                  : (day % 10 === 2 && day !== 12) ? 'nd'
                  : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
          return day + suf + ' ' + TH_MONTHS[mon - 1] + ', ' + year;
        }
        var TH_ICON = {
          out: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>',
          in:  '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>'
        };
        function thNormalize(tab, data) {
          var out = [];
          if (tab === 'payments') {
            // investment payments = each investment's payment record (invest.php investInfo → data.data[].payment)
            (data.data || []).forEach(function(item){
              var pay = item.payment || {};
              var ps = String(pay.status != null && pay.status !== '' ? pay.status : item.status);
              var sk = ps === '1' ? 'success' : (ps === '0' ? 'pending' : 'failed');
              var sl = ps === '1' ? 'Paid' : (ps === '0' ? 'Pending' : 'Failed');
              var m = String(pay.method || '').toLowerCase();
              var methodLabel = m === 'bank' ? 'Bank Transfer'
                              : m === 'upi' ? 'UPI'
                              : m === 'crypto' ? ('USDT' + (pay.network ? ' · ' + String(pay.network).toUpperCase() : ''))
                              : m === 'pin' ? 'PIN Redemption'
                              : 'Payment';
              var ref = m === 'pin' ? (pay.pinCode || pay.txnID || '')
                      : m === 'crypto' ? (pay.txnID || '')
                      : (pay.utr || pay.txnID || '');
              var extra = '';
              if ((m === 'bank' || m === 'upi') && parseFloat(pay.amountINR) > 0) {
                extra = '≈ ₹' + Number(parseFloat(pay.amountINR)).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + (pay.usdInrRate ? ' @ ₹' + pay.usdInrRate + '/$' : '');
              }
              out.push({
                title: 'Investment Payment',
                amount: parseFloat(item.amount) || 0,
                sk: sk, sl: sl,
                date: thFmtDate(pay.date || item.date || ''),
                sub: methodLabel,                       // clean method label (meta row)
                ref: ref,                               // txn / utr / pin → REF tag (footer)
                investID: item.investID || '',          // → #INV chip (footer)
                extra: extra,                           // INR conversion note (footer chip)
                dir: 'out'
              });
            });
          } else if (tab === 'withdrawals') {
            (data.withdrawHistory || []).forEach(function(item){
              var sm = thStatus(item.status);
              var pm = item.payoutMethod || {};
              var pmethod = String(pm.method || '').toLowerCase();
              var methodLabel, dest = '';
              if (pmethod === 'bank') {
                methodLabel = 'Bank Transfer';
                var ac = String(pm.bankAC || pm.accountNumber || '');
                dest = (pm.bankName || 'Bank') + (ac ? ' ••' + ac.slice(-4) : '');
              } else if (pmethod === 'upi') {
                methodLabel = 'UPI'; dest = pm.upiId || '';
              } else if (pmethod === 'crypto') {
                methodLabel = 'USDT' + (pm.network ? ' ' + String(pm.network).toUpperCase() : '');
                var addr = String(pm.address || '');
                dest = addr.length > 14 ? (addr.slice(0, 6) + '…' + addr.slice(-4)) : addr;
              } else { methodLabel = 'Withdrawal'; }
              var WD_TYPE_LABEL = { commission: 'Commission Withdrawal', principal: 'Capital Return' };
              var typeLabel = WD_TYPE_LABEL[String(item.withdrawType)] || 'Investment Withdrawal';
              var sub = methodLabel + (dest ? ' · ' + dest : '') + (item.investID ? ' · #' + item.investID : '');
              var rawAmt = parseFloat(item.amount) || 0;
              // Fee is server-supplied; the fallback percentage is a display-only last resort.
              var rawFee = parseFloat(item.fee);
              if (isNaN(rawFee)) rawFee = rawAmt * ((window.planConfig ? window.planConfig.cached().withdrawFeePct : 5) / 100);
              var earlyFee = parseFloat(item.earlyExitFee) || 0;
              if (earlyFee > 0) sub += ' · incl. ' + INR2.format(earlyFee) + ' early exit';
              var rawNet = parseFloat(item.netAmount || item.amountAfterFee) || (rawAmt - rawFee);
              var parts = [];
              var inrRate = parseFloat(item.usdToInrRate) || 0;
              if (inrRate > 0 && rawNet > 0) {
                var netInr = rawNet * inrRate;
                parts.push('≈ ₹' + netInr.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + ' @ ₹' + inrRate + '/$');
              } else if (parseFloat(item.amountInInr) > 0 && rawAmt > 0) {
                // fallback: scale the gross INR by the net/gross ratio
                var scaledInr = parseFloat(item.amountInInr) * (rawNet / rawAmt);
                parts.push('≈ ₹' + scaledInr.toLocaleString('en-IN', { maximumFractionDigits: 2 }) + (item.usdToInrRate ? ' @ ₹' + item.usdToInrRate + '/$' : ''));
              }
              if (item.remarks) parts.push(item.remarks);
              out.push({
                title: typeLabel,
                amount: rawAmt,
                fee: rawFee,
                netAmt: rawNet,
                sk: sm.k, sl: sm.l,
                date: (item.txnID ? item.txnID + ' · ' : '') + (item.date || ''),
                sub: sub,
                extra: parts.join('  ·  '),
                dir: 'out',
                type: 'withdrawal'
              });
            });
          } else { // commissions → earning.php commissionHistory=1 → data.history[]
            // Types 7/8/9 are the Plan 2.0 income programs.
            var TH_CTYPE = {
              '1':'Direct Referral', '2':'Commission', '3':'Team ROI Bonus',
              '4':'Leadership Salary', '5':'Refund',
              '7':'Express Warrior', '8':'Royalty Income', '9':'One-Time Reward'
            };
            var chRows = (data.data && data.data.history) || data.history || data.commissionHistory || data.commissions || [];
            chRows.forEach(function(item){
              var t = String(item.type);
              // prefer our known mapping; backend typeLabel can be a generic placeholder like "Type #5"
              var title = TH_CTYPE[t] || item.typeLabel || 'Commission';
              // source is parsed per type — accept an object (preferred) or a pre-formatted string
              var src = item.source;
              var parts = [];
              if (src && typeof src === 'object') {
                if (src.fromUserID != null && src.fromUserID !== '') parts.push('From #' + src.fromUserID);
                if (src.investmentAmount != null && src.investmentAmount !== '') parts.push('Invested ' + INR2.format(parseFloat(src.investmentAmount) || 0));
                if (src.rank != null && src.rank !== '') parts.push('Rank ' + src.rank);
                if (src.period != null && src.period !== '') parts.push(String(src.period));
                if (src.qualifyingVolume != null && src.qualifyingVolume !== '') parts.push('Qualifying ' + INR2.format(parseFloat(src.qualifyingVolume) || 0));
                // include the reason only when it adds info beyond the title (e.g. "Direct Referral 5%")
                if (src.reason && String(src.reason).toLowerCase() !== String(title).toLowerCase()) parts.push(String(src.reason));
              } else if (src) {
                parts.push(String(src));
              }
              if (item.reason && String(item.reason).toLowerCase() !== String(title).toLowerCase() && parts.indexOf(String(item.reason)) === -1) parts.push(String(item.reason));
              var extra = (item.updatedBalance != null && item.updatedBalance !== '')
                ? 'Balance after · ' + INR2.format(parseFloat(item.updatedBalance) || 0) : '';
              var isRefund = (t === '5');
              out.push({
                title: title,
                amount: parseFloat(item.amount) || 0,
                sk: 'success', sl: isRefund ? 'Refunded' : 'Credited',
                date: item.date,
                sub: parts.join(' · '),
                extra: extra,
                dir: 'in'
              });
            });
          }
          return out;
        }
        function thRender() {
          var items = thCache[thTab] || [];
          var counts = { all: items.length, success: 0, pending: 0, failed: 0 };
          for (var c = 0; c < items.length; c++) counts[items[c].sk] = (counts[items[c].sk] || 0) + 1;
          $$('.th__filter[data-status="all"] .th__filter-c').html(counts.all);
          $$('.th__filter[data-status="success"] .th__filter-c').html(counts.success);
          $$('.th__filter[data-status="pending"] .th__filter-c').html(counts.pending);
          $$('.th__filter[data-status="failed"] .th__filter-c').html(counts.failed);
          var list = thFilter === 'all' ? items : items.filter(function(it){ return it.sk === thFilter; });
          if (!list.length) {
            $$('.th__list').html('<div class="th__empty"><div class="th__empty-ico"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg></div><h3 class="th__empty-title">No records found</h3><p class="th__empty-sub">Nothing here for this filter yet.</p></div>');
            return;
          }
          var html = '';
          for (var j = 0; j < list.length; j++) {
            var it = list[j];
            if (it.type === 'withdrawal') {
              html +=
                '<div class="th__item th__wd-card th__item--out">' +
                  '<div class="th__wd-head">' +
                    '<span class="th__item-ico th__item-ico--out">' + TH_ICON['out'] + '</span>' +
                    '<div class="th__wd-info">' +
                      '<span class="th__wd-name">' + thEsc(it.title) + '</span>' +
                      (it.sub ? '<span class="th__wd-dest">' + thEsc(it.sub) + '</span>' : '') +
                    '</div>' +
                    '<span class="th__badge th__badge--' + it.sk + '"><span class="th__badge-dot"></span>' + it.sl + '</span>' +
                  '</div>' +
                  '<div class="th__wd-breakdown">' +
                    '<div class="th__wd-col">' +
                      '<span class="th__wd-lbl">Requested</span>' +
                      '<span class="th__wd-val">−' + INR2.format(it.amount) + '</span>' +
                    '</div>' +
                    '<div class="th__wd-sep"></div>' +
                    '<div class="th__wd-col">' +
                      '<span class="th__wd-lbl">Fee (10%)</span>' +
                      '<span class="th__wd-val th__wd-val--fee">−' + INR2.format(it.fee) + '</span>' +
                    '</div>' +
                    '<div class="th__wd-sep"></div>' +
                    '<div class="th__wd-col th__wd-col--net">' +
                      '<span class="th__wd-lbl th__wd-lbl--net">You Receive</span>' +
                      '<span class="th__wd-val th__wd-val--net">' + INR2.format(it.netAmt) + '</span>' +
                    '</div>' +
                  '</div>' +
                  '<div class="th__wd-foot">' +
                    (it.extra ? '<span class="th__item-extra">' + thEsc(it.extra) + '</span>' : '<span></span>') +
                    '<span class="th__wd-date">' + thEsc(it.date) + '</span>' +
                  '</div>' +
                '</div>';
            } else {
              var thFoot =
                (it.ref ? '<span class="th__ref"><span class="th__ref-tag">REF</span><span class="th__ref-id">' + thEsc(it.ref) + '</span></span>' : '') +
                (it.investID ? '<span class="th__chip">#' + thEsc(it.investID) + '</span>' : '') +
                (it.extra ? '<span class="th__chip th__chip--bal">' + thEsc(it.extra) + '</span>' : '') +
                (it.date ? '<span class="th__item-date">' + thEsc(it.date) + '</span>' : '');
              html += '<div class="th__item th__item--' + it.dir + '">' +
                '<span class="th__item-ico th__item-ico--' + it.dir + '">' + TH_ICON[it.dir] + '</span>' +
                '<div class="th__item-body">' +
                  '<div class="th__item-top"><span class="th__item-title">' + thEsc(it.title) + '</span>' +
                    '<span class="th__item-amt th__item-amt--' + it.dir + '">' + (it.dir === 'in' ? '+' : '-') + INR2.format(it.amount) + '</span></div>' +
                  '<div class="th__item-meta"><span class="th__badge th__badge--' + it.sk + '"><span class="th__badge-dot"></span>' + it.sl + '</span>' +
                    (it.sub ? '<span class="th__item-sub">' + thEsc(it.sub) + '</span>' : '') + '</div>' +
                  (thFoot ? '<div class="th__item-foot">' + thFoot + '</div>' : '') +
                '</div></div>';
            }
          }
          $$('.th__list').html(html);
        }
        function thLoad(tab) {
          if (thCache[tab]) { thRender(); return; }
          $$('.th__list').html('<div class="th__loading"><span class="th__spin-ring"></span> Loading…</div>');
          function done(data) { thCache[tab] = (data && data.status == 'success') ? thNormalize(tab, data) : []; if (tab === thTab) thRender(); }
          function fail() { thCache[tab] = []; if (tab === thTab) $$('.th__list').html('<div class="th__empty"><div class="th__empty-ico th__empty-ico--err"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l22 22"/><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"/><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"/><path d="M10.71 5.05A16 16 0 0 1 22.58 9"/><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg></div><h3 class="th__empty-title">Couldn\'t load history</h3><p class="th__empty-sub">Please check your connection and try again.</p></div>'); }
          if (tab === 'payments') {
            $.post(baseURL + 'invest.php', { investInfo: true, token: thToken }, null, 'json').done(done).fail(fail);
          } else if (tab === 'withdrawals') {
            $.post(baseURL + 'invest.php', { withdrawalHistory: true, token: thToken }, null, 'json').done(done).fail(fail);
          } else {
            $.post(baseURL + 'earning.php', { commissionHistory: 1, page: 1, limit: 100, token: thToken }, null, 'json').done(done).fail(fail);
          }
        }
        $$('.th__tab').off('click').on('click', function() {
          thTab = $$(this).attr('data-tab');
          thFilter = 'all';
          $$('.th__tab').removeClass('th__tab--on'); $$(this).addClass('th__tab--on');
          $$('.th__filter').removeClass('th__filter--on');
          $$('.th__filter[data-status="all"]').addClass('th__filter--on');
          thLoad(thTab);
        });
        $$('.th__filter').off('click').on('click', function() {
          thFilter = $$(this).attr('data-status');
          $$('.th__filter').removeClass('th__filter--on'); $$(this).addClass('th__filter--on');
          thRender();
        });
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          app.dialog.close();
          if (data.isLoggedin != 'true') { app.views.main.router.navigate({ name: 'Home' }); return; }
          $$('.th__tab').removeClass('th__tab--on');
          $$('.th__tab[data-tab="' + thTab + '"]').addClass('th__tab--on');
          thLoad(thTab);
        });
      }
    }
  },
  {
    path: '/invest/',
    component: InvestPage,
    name: 'invest',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        var hasPendingInvest = false; // blocks new investment while the last one is processing
        // initialize box-scope
        var boxes = document.querySelectorAll('.box');

        for(let i = 0; i < boxes.length; i++) {
          let box = boxes[i];
          app.methods.initDropEffect(box);
          app.methods.initImageUpload(box);
        }
        app.methods.initFileUpload();
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            if (data.country) localStorage.setItem('country', data.country);
            // ── Bank & UPI display gating (DISABLED — Bank/UPI hidden for now)
            // var showIN = (String(data.country || '').toUpperCase() === 'IN');
            // $$('.pay__method[data-method="bank"]').css('display', showIN ? '' : 'none');
            // $$('.pay__method[data-method="upi"]').css('display', showIN ? '' : 'none');
            // Block a new investment while the most recent one is still processing (status 0)
            app.methods.getUserDataInvest(function(inv) {
              if (inv && inv.status == 'success' && inv.data && inv.data.length && String(inv.data[0].status) === '0') {
                hasPendingInvest = true;
                $$('.iv__pending').css('display', 'flex');
                $$('.iv__plans, .iv__card, .iv__returns, .iv__submit, .iv__tc').css('display', 'none');
              }
            });
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        // Amount input, quick chips and live returns are handled inside the
        // invest.f7.html component (vanilla DOM). It sets data-amount on .investNowBTN.
        $$('.popup-close-tc').off('click').on('click', function() {
          app.popup.close('.sheet--invest-tc');
        });
        /* ════════ Multi-method payment (Bank · UPI · Crypto · PIN) ════════ */
        var USD_INR_FALLBACK = 95;               // used if live FX is unavailable
        var payINRValue = 0, payINRRate = 0, upiPayId = '', upiPayName = 'Digi Money Express';
        var cryptoWalletsList = [], selectedCryptoWallet = null;  // active BEP-20 wallets + the one the user picked

        function cryptoQRsrc(v) {
          if (!v) return '';
          return /^https?:\/\//.test(v) ? v : ('https://files.digitalmoneyexpress.com/' + v);
        }
        function upiQRsrc(v) {
          if (!v) return '';
          return /^https?:\/\//.test(v) ? v : ('https://files.digitalmoneyexpress.com/' + v);
        }
        function payRow(label, value, copyable) {
          if (value == null || value === '') value = '—';
          var copyBtn = copyable
            ? '<button type="button" class="pay__row-copy copy-icon" data-copy="' + value + '" aria-label="Copy"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg></button>'
            : '';
          return '<div class="pay__row"><span class="pay__row-lbl">' + label + '</span><span class="pay__row-val">' + value + copyBtn + '</span></div>';
        }
        // Build a single BEP-20 wallet card (reuses .pay__wallet styling)
        function cryptoWalletCard(w) {
          var qr = cryptoQRsrc(w.qr);
          var addr = w.address || '';
          var name = w.label ? (w.label + (w.coin ? ' · ' + w.coin : '')) : (w.coin || 'USDT');
          return '<div class="pay__wallet">' +
              '<div class="pay__wallet-name">' + name + '</div>' +
              (qr ? '<img class="pay__wallet-qr" src="' + qr + '" alt="QR" />' : '') +
              '<div class="pay__wallet-label">Wallet Address · ' + (w.network || 'BEP-20') + '</div>' +
              '<div class="pay__wallet-addr">' +
                '<span class="cryptoAddr">' + (addr || '—') + '</span>' +
                '<button type="button" class="pay__wallet-copy copy-icon" data-copy="' + addr + '" aria-label="Copy address">' +
                  '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>';
        }

        // Render every active BEP-20 wallet returned by the API (TRC-20 ignored)
        function renderCryptoWallets(data) {
          var wallets = [];
          if (data && Object.prototype.toString.call(data.cryptoWallets) === '[object Array]') {
            for (var i = 0; i < data.cryptoWallets.length; i++) {
              var w = data.cryptoWallets[i] || {};
              var net = String(w.network || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
              if (net.indexOf('TRC') === 0) continue;   // ignore TRC-20 wallets
              if (!w.address) continue;
              wallets.push({ network: w.network || 'BEP-20', coin: w.coin || 'USDT', label: w.label || '', address: w.address, qr: w.qr });
            }
          }
          // Backward-compat: single BEP-20 wallet from flat fields when no list is present
          if (!wallets.length) {
            var addr = data.bep20 || data.usdtBEP20 || data.bep20Address || data.bep20_address || '';
            if (addr) wallets.push({ network: 'BEP-20', coin: 'USDT', label: '', address: addr, qr: data.bep20QR || data.bep20_qr || data.bep20QRIMG });
          }

          cryptoWalletsList = wallets;
          selectedCryptoWallet = wallets[0] || null;

          var $list = $$('.cryptoWalletList');
          if (!wallets.length) {
            $list.html('<div class="pay__wallet"><div class="pay__wallet-label">Wallet Address · BEP-20</div><div class="pay__wallet-addr"><span class="cryptoAddr">—</span></div></div>');
            return;
          }

          // One tab + one panel per wallet; user taps the wallet they paid to.
          var multi = wallets.length > 1;
          var tabs = '', panels = '';
          for (var j = 0; j < wallets.length; j++) {
            if (multi) {
              tabs += '<button type="button" class="pay__wtab' + (j === 0 ? ' pay__wtab--on' : '') + '" data-widx="' + j + '">Wallet ' + (j + 1) + '</button>';
            }
            panels += '<div class="pay__wpanel" data-widx="' + j + '"' + (j === 0 ? '' : ' style="display:none;"') + '>' + cryptoWalletCard(wallets[j]) + '</div>';
          }
          $list.html(
            (multi ? '<div class="pay__wtab-hint">Select the wallet you sent your USDT to</div><div class="pay__wtabs">' + tabs + '</div>' : '') +
            '<div class="pay__wpanels">' + panels + '</div>'
          );
        }
        function refreshPayableINR(amount) {
          function render(rate) {
            payINRRate = rate;
            payINRValue = amount * rate;
            $$('.usdInrRate').html(rate.toFixed(2));
            $$('.payableINR').html('₹' + payINRValue.toLocaleString('en-IN', { maximumFractionDigits: 0 }));
          }
          $.getJSON('https://open.er-api.com/v6/latest/USD', function(d) {
            render((d && d.rates && d.rates.INR) ? d.rates.INR : USD_INR_FALLBACK);
          }).fail(function() { render(USD_INR_FALLBACK); });
        }

        // Open payment popup, reset to method-picker state
        $$('.investNowBTN').off('click').on('click', function() {
          if (hasPendingInvest) {
            app.toast.show({ text: 'Your previous investment is still being processed. Please wait until it is activated.', closeTimeout: 3000 });
            return;
          }
          var amount = parseFloat($$(this).attr('data-amount')) || 0;
          // Plan 2.0: an investment cannot be created without a plan — the API rejects it.
          if (!$$(this).attr('data-plan')) {
            app.toast.show({ text: 'Please choose an investment plan.', closeTimeout: 3000 });
            return;
          }
          app.popup.open('.sheet--invest-payment');
          $$('.investAmount').html(INR2.format(amount));
          $$('.cryptoAmount').html(INR2.format(amount));
          $$('.goldQTY').html('XAUt Digital Gold · 999.9 fine');
          $$('.pay__method').removeClass('pay__method--on');
          $$('.pay__panel').css('display', 'none');
          $$('.pay__prompt').css('display', 'block');
          $$('#txn-ref').val('');
          $$('#pin-invest').val('');
          if ($$('#paymentReceipt').length) { $$('#paymentReceipt')[0].value = ''; }
          $$('.pay__upload-name').html('');
          refreshPayableINR(amount);
        });

        // Method selection — reveal panels whose data-for includes the method
        $$('.pay__method').off('click').on('click', function() {
          var method = this.getAttribute('data-method');
          var methodDown = this.getAttribute('data-unavailable') === 'true';
          $$('.pay__method').removeClass('pay__method--on');
          $$(this).addClass('pay__method--on');
          $$('.pay__prompt').css('display', 'none');
          var panels = $$('.pay__panel');
          // Panels to suppress when method is down (no point showing INR amount or proof upload)
          var suppressWhenDown = ['bank upi', 'bank upi crypto'];
          for (var p = 0; p < panels.length; p++) {
            var forAttr = panels[p].getAttribute('data-for') || '';
            var forList = forAttr.split(' ');
            var matches = forList.indexOf(method) !== -1;
            if (matches && methodDown && suppressWhenDown.indexOf(forAttr) !== -1) {
              panels[p].style.display = 'none';
            } else {
              panels[p].style.display = matches ? 'block' : 'none';
            }
          }
          $$('#payRefLabel').html(method === 'crypto' ? 'Transaction Hash' : 'UTR / Reference Number');
          if (method === 'fund') {
            $$('.pay__fund-bal').html('Loading…');
            app.methods.request(
              baseURL + 'fund.php',
              { token: localStorage.getItem('authToken'), fundBalance: 1 },
              'json',
              function() {},
              function(res) {
                if (res && res.status === 'success') {
                  $$('.pay__fund-bal').html(INR2.format(res.balance));
                  $$('.pay__fund-min').html(res.minTransfer != null ? INR2.format(res.minTransfer) : '—');
                  $$('.pay__fund-max').html(res.maxTransfer != null ? INR2.format(res.maxTransfer) : '—');
                } else {
                  $$('.pay__fund-bal').html('—');
                }
              },
              function() { $$('.pay__fund-bal').html('Network error'); }
            );
          }
        });

        // Crypto network toggle (only BEP-20 is active; TRC-20 tab hidden)
        $$('.pay__net-tab').off('click').on('click', function() {
          $$('.pay__net-tab').removeClass('pay__net-tab--on');
          $$(this).addClass('pay__net-tab--on');
        });

        // Wallet tab toggle — delegated (tabs are injected by renderCryptoWallets)
        $(document).off('click', '.pay__wtab').on('click', '.pay__wtab', function() {
          var idx = parseInt(this.getAttribute('data-widx'), 10) || 0;
          $$('.pay__wtab').removeClass('pay__wtab--on');
          $$(this).addClass('pay__wtab--on');
          $$('.pay__wpanel').css('display', 'none');
          $$('.pay__wpanel[data-widx="' + idx + '"]').css('display', '');
          selectedCryptoWallet = cryptoWalletsList[idx] || null;
        });

        // Screenshot filename
        $$('#paymentReceipt').on('change', function() {
          var f = this.files && this.files[0];
          $$('.pay__upload-name').html(f ? ('✓ ' + f.name) : '');
        });

        // Pay with UPI — open the user's UPI app via UPI intent (upi://pay)
        $$('.payWithUPI').off('click').on('click', function() {
          if (!upiPayId) {
            app.toast.show({ text: 'UPI is not available right now.', closeTimeout: 2500 });
            return;
          }
          var amt = (payINRValue > 0 ? payINRValue : 0).toFixed(2);
          var tn = 'TXN' + Date.now();
          var url = 'upi://pay?pa=' + encodeURIComponent(upiPayId) +
                    '&pn=' + encodeURIComponent(upiPayName || 'Digi Money Express') +
                    '&am=' + amt + '&cu=INR' +
                    '&tn=' + encodeURIComponent(tn);
          // hand the upi:// scheme to the OS so it opens the UPI app chooser
          try {
            window.open(url, '_system');
          } catch (e) {
            window.location.href = url;
          }
        });
        function verifyReferralCode() {
          var referralCode = $$('input[name="referralCode"]').val().trim();
          app.methods.request(
            baseURL+'invest.php',
            {verifyReferralCode: true, referralCode: referralCode, token: localStorage.getItem('authToken')},
            'json',
            function() { app.dialog.progress('Verifying Referral Code...'); },
            function(data) {
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet--invest-payment');
                $$('.investAmount').html(INR2.format($$('.investNowBTN').attr('data-amount')));
                var goldPrice = parseFloat(data.goldPrice); //this price is for 1gm
                // calculate quantity in gm for 999 pure gold
                var finalPrice = $$('.investNowBTN').attr('data-amount') - ($$('.investNowBTN').attr('data-amount') * 18 / 100); //subtract GST from amount
                var goldQty = finalPrice / goldPrice;
                $$('.goldQTY').html(goldQty.toFixed(3) + ' gm of 999 (24K) pure GOLD');
                $$('.currentGoldPrice').html(goldPrice.toFixed(2));
                $$('.payableAmount').html(INR2.format($$('.investNowBTN').attr('data-amount'))+' (Inc. GST)');
                $$('.sponsorName').html(data.sponsorName);
              } else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
        $$('.popup-close-payment').off('click').on('click', function() {
          app.popup.close('.sheet--invest-payment');
        });
        
        app.methods.getBank(function(data) {
          app.dialog.close();
          // ── Bank & UPI display gating (DISABLED — Bank/UPI hidden for now)
          // var ctry = (localStorage.getItem('country') || '').toUpperCase();
          // var showIN = (ctry === 'IN');
          // $$('.pay__method[data-method="bank"]').css('display', showIN ? '' : 'none');
          // $$('.pay__method[data-method="upi"]').css('display', showIN ? '' : 'none');

          // ── Bank details (DISABLED — Bank method hidden for now)
          /* if (data.isBank == '1') {
            $$('.getBankdet').html(
              payRow('Beneficiary', data.beneficiary, false) +
              payRow('Bank Name', data.acc_name, false) +
              payRow('Account Number', data.acc_num, true) +
              payRow('IFSC Code', data.acc_ifsc, true)
            );
            $$('.pay__method[data-method="bank"]').removeAttr('data-unavailable');
          } else {
            $$('.pay__method[data-method="bank"]').attr('data-unavailable', 'true');
            $$('.getBankdet').html(
              '<div class="pay__method-down">' +
                '<div class="pay__method-down-ico">' +
                  '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="9.5"/><line x1="5.3" y1="5.3" x2="18.7" y2="18.7"/></svg>' +
                '</div>' +
                '<div class="pay__method-down-title">Bank Transfer Unavailable</div>' +
                '<div class="pay__method-down-sub">Bank deposits are temporarily disabled. Please use USDT or another available method.</div>' +
              '</div>'
            );
          } */

          // ── UPI details (DISABLED — UPI method hidden for now)
          /* if (data.isUPI == '1') {
            upiPayId = data.upi_id || '';
            upiPayName = data.beneficiary || data.acc_name || 'Digi Money Express';
            var upiHTML = payRow('UPI ID', data.upi_id, true);
            if (data.upi_qrIMG) {
              upiHTML += '<div class="pay__qr-wrap"><img src="' + upiQRsrc(data.upi_qrIMG) + '" alt="UPI QR"/><div class="pay__qr-id">' + (data.upi_id || '') + '</div></div>';
            }
            $$('.getUPIdet').html(upiHTML);
            $$('.payWithUPI').css('display', '');
            $$('.pay__method[data-method="upi"]').removeAttr('data-unavailable');
          } else {
            upiPayId = '';
            $$('.pay__method[data-method="upi"]').attr('data-unavailable', 'true');
            $$('.getUPIdet').html(
              '<div class="pay__method-down">' +
                '<div class="pay__method-down-ico">' +
                  '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="9.5"/><line x1="5.3" y1="5.3" x2="18.7" y2="18.7"/></svg>' +
                '</div>' +
                '<div class="pay__method-down-title">UPI Unavailable</div>' +
                '<div class="pay__method-down-sub">UPI deposits are temporarily disabled. Please use USDT or another available method.</div>' +
              '</div>'
            );
            $$('.payWithUPI').css('display', 'none');
          } */

          // Crypto (USDT): render every active BEP-20 wallet (TRC-20 ignored)
          renderCryptoWallets(data);
          // copy handler (jQuery delegation — reliable for injected buttons)
          $(document).off('click', '.copy-icon');
          $(document).on('click', '.copy-icon', function(e) {
            e.preventDefault();
            var text = this.getAttribute('data-copy');
            if (text == null) return; // referral copy-icons (no data-copy) are handled by their own direct binding
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(text).then(function() { app.toast.show({ text: 'Copied!', closeTimeout: 1500 }); });
            } else {
              var t = document.createElement('input'); t.value = text; document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t);
              app.toast.show({ text: 'Copied!', closeTimeout: 1500 });
            }
          });
          return; // ↓ legacy combined-card rendering kept below but unreachable
          // Copy to clipboard handler
          $$(document).off('click', '.copy-icon');
          $$(document).on('click', '.copy-icon', function(e) {
            e.preventDefault();
            var text = $$(this).attr('data-copy');
            if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
            } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
            }
          });
        });
        // Plan 2.0: `plan` is REQUIRED on every investment-creation call. Returns the
        // selected plan code, or '' when nothing is selected (caller must abort).
        function selectedPlanCode() {
          return $$('.investNowBTN').attr('data-plan') || '';
        }
        // Shared submission for all methods
        function submitInvestData(formData) {
          app.methods.post(
            baseURL+'invest.php',
            formData,
            'json',
            function() { app.dialog.progress('Processing your investment…'); },
            function(data) {
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.close('.sheet--invest-payment');
                app.popup.open('.sheet-loan--applied');
                $$('.sheet-loan--applied__title').html(INR2.format($$('.investNowBTN').attr('data-amount'))+' Investment Requested!');
                $$('.sheet-loan--applied__text').html('Your investment request has been submitted. We\'ll verify it and activate your investment shortly.');
                var view = app.views.current;
                view.router.navigate('/invest-dashboard/');
              } else {
                app.toast.show({ text: data.msg || 'Something went wrong, please try again.', closeTimeout: 3000 });
              }
            },
            function() {
              app.dialog.close();
              app.toast.show({ text: 'Something went wrong, please try again!', closeTimeout: 3000 });
            }
          );
        }

        // Bank / UPI / Crypto — payment proof submission
        $$('.submitInvest').off('click');
        $$('.submitInvest').off('click').on('click', function() {
          var method = $$('.pay__method--on').attr('data-method') || '';
          if (['bank','upi','crypto'].indexOf(method) === -1) {
            app.toast.show({ text: 'Please select a payment method.', closeTimeout: 2500 });
            return;
          }
          if (method === 'crypto' && !selectedCryptoWallet) {
            app.toast.show({ text: 'Please select the wallet you sent your payment to.', closeTimeout: 2500 });
            return;
          }
          var ref = ($$('#txn-ref').val() || '').trim();
          var file = ($$('#paymentReceipt')[0] && $$('#paymentReceipt')[0].files[0]) || null;
          var amount = $$('.investNowBTN').attr('data-amount');
          var plan = selectedPlanCode();
          if (!plan) {
            app.toast.show({ text: 'Please choose an investment plan.', closeTimeout: 2500 });
            return;
          }
          if (!ref || ref.length < 6) {
            app.toast.show({ text: method === 'crypto' ? 'Please enter the transaction hash.' : 'Please enter your UTR / reference number.', closeTimeout: 2500 });
            return;
          }
          if (!file) {
            app.toast.show({ text: 'Please upload your payment screenshot.', closeTimeout: 2500 });
            return;
          }
          var validImageTypes = ['image/gif','image/jpeg','image/png','image/jpg'];
          if ($.inArray(file.type, validImageTypes) < 0) {
            app.toast.show({ text: 'Please upload a valid image (JPG/PNG).', closeTimeout: 2500 });
            return;
          }
          var fd = new FormData();
          fd.append('submitInvest', true);
          fd.append('token', localStorage.getItem('authToken'));
          fd.append('method', method);
          if (method === 'crypto') {
            fd.append('network', $$('.pay__net-tab--on').attr('data-net') || 'bep20');
            // Which receiving wallet the user actually paid to
            if (selectedCryptoWallet) {
              fd.append('walletAddress', selectedCryptoWallet.address || '');
              fd.append('walletLabel', selectedCryptoWallet.label || '');
            }
          }
          // India users paying via Bank/UPI settle in INR — send the FX rate used
          var payIsIN = (String(localStorage.getItem('country') || '').toUpperCase() === 'IN');
          if (payIsIN && (method === 'bank' || method === 'upi')) {
            fd.append('usdInrRate', (payINRRate || USD_INR_FALLBACK).toFixed(2));
            fd.append('amountINR', (payINRValue || 0).toFixed(0));
          }
          fd.append('paymentIMG', file);
          fd.append('utr', ref);
          fd.append('amount', amount);
          fd.append('plan', plan);

          submitInvestData(fd);
        });

        // PIN — instant redemption
        $$('.submitInvestPin').off('click');
        $$('.submitInvestPin').off('click').on('click', function() {
          var pin = ($$('#pin-invest').val() || '').trim();
          var amount = $$('.investNowBTN').attr('data-amount');
          var plan = selectedPlanCode();
          if (!plan) {
            app.toast.show({ text: 'Please choose an investment plan.', closeTimeout: 2500 });
            return;
          }
          if (!pin) {
            app.toast.show({ text: 'Please enter a valid PIN.', closeTimeout: 2500 });
            return;
          }
          var fd = new FormData();
          fd.append('submitInvest', true);
          fd.append('token', localStorage.getItem('authToken'));
          fd.append('method', 'pin');
          fd.append('pin', pin);
          fd.append('amount', amount);
          fd.append('plan', plan);
          submitInvestData(fd);
        });

        // Fund Wallet — invest using fund wallet balance
        $$('.submitInvestFund').off('click');
        $$('.submitInvestFund').off('click').on('click', function() {
          var amount = parseFloat($$('.investNowBTN').attr('data-amount')) || 0;
          var plan = selectedPlanCode();
          if (!plan) {
            app.toast.show({ text: 'Please choose an investment plan.', closeTimeout: 2500 });
            return;
          }
          if (!amount) {
            app.toast.show({ text: 'Investment amount is missing.', closeTimeout: 2500 });
            return;
          }
          var fd = new FormData();
          fd.append('submitInvest', true);
          fd.append('token', localStorage.getItem('authToken'));
          fd.append('method', 'fund');
          fd.append('amount', amount);
          fd.append('plan', plan);
          app.methods.post(
            baseURL + 'invest.php', fd, 'json',
            function() { app.dialog.progress('Processing…'); },
            function(data) {
              app.dialog.close();
              if (data && data.status === 'success') {
                app.popup.close('.sheet--invest-payment');
                app.toast.show({ text: data.msg || 'Investment placed successfully.', closeTimeout: 3000 });
                app.views.main.router.navigate({ name: 'invest-dashboard' });
              } else {
                app.toast.show({ text: (data && data.msg) || 'Could not process investment.', closeTimeout: 3000 });
              }
            },
            function() {
              app.dialog.close();
              app.toast.show({ text: 'Connection error, please try again.', closeTimeout: 3000 });
            }
          );
        });
      }
    }
  },
  {
    path: '/invest-dashboard/',
    component: InvestDashboardPage,
    name: 'invest-dashboard',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').off('click').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').off('click').on('click', function() {
          var shareLink = 'https://app.digitalmoneyexpress.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join DigiMoney Express',
              text: 'Use my referral code to join DigiMoney Express!',
              url: '' + shareLink
            }).catch(() => {});
          } else {
            console.log('Web Share API not supported in this browser.');
            //copy the link to clipboard
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(shareLink).then(function() {
                app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
              });
            }
          }
        });
        //get investment details
        app.methods.getUserDataInvest(function(data) {
          if(data.status == 'success') {
            //each function
            $$('.all-invest--list').empty();
            $.each(data.data, function(i, item) {
              if(item.status == '0') {
                var status = 'Processing';
                var statusColor = 'text-color-orange';
                var img = 'https://cdn-icons-png.flaticon.com/512/15092/15092613.png';
                var date = 'Invested on '+item.date;
                var creditTXT = 'Your investment of <b class="text-color-green">'+INR.format(item.amount)+'</b> is being processed, please wait for it to be activated soon.';
              } else if(item.status == '1') {
                var status = 'Active';
                var statusColor = 'text-color-green';
                var img = 'assets/icons/profit.gif';
                var date = 'Activated on '+item.dateStart;
                var dateStart = item.dateStart;
                // safe parse start date into a valid Date, supporting various formats
                function safeParseDate(d) {
                  if (!d) return new Date();
                  if (d instanceof Date) return d;
                  var dt = new Date(d);
                  if (!isNaN(dt.getTime())) return dt;
                  // try replacing - with / and parse
                  var s = String(d).replace(/-/g, '/');
                  var parts = s.split('/');
                  // handle DD/MM/YYYY -> convert to YYYY-MM-DD for reliable parse
                  if (parts.length === 3 && parts[0].length === 2) {
                    var rearr = parts[2] + '-' + parts[1] + '-' + parts[0];
                    dt = new Date(rearr);
                    if (!isNaN(dt.getTime())) return dt;
                  }
                  dt = new Date(s);
                  return isNaN(dt.getTime()) ? new Date() : dt;
                }
                var parsedStart = safeParseDate(dateStart);
                var creditTXT = '';
              } else {
                var status = 'Closed';
                var statusColor = 'text-color-red-deep';
                var img = 'assets/icons/error.png';
                var date = 'Closed on '+item.dateExpire;
                var creditTXT = '';
              }
              var statusClass = item.status == '1' ? 'active' : (item.status == '0' ? 'processing' : 'closed');
              // Plan 2.0: each row carries its own plan + cap multiple (they differ per plan).
              var rowCapMult = parseFloat(item.capMultiple);
              var rowCapLbl = isNaN(rowCapMult) ? 'Max Return' : ('Max Return · ' + parseFloat(rowCapMult.toFixed(2)) + '×');
              // Headline the LIFETIME payout. `estimatedReturn` is the legacy alias for
              // `credit` — the ROI cap alone — so it understates the total by the principal.
              var rowTotal = parseFloat(item.maxTotalReturn);
              if (isNaN(rowTotal)) {
                var rowCredit = parseFloat(item.credit);
                if (isNaN(rowCredit)) rowCredit = parseFloat(item.estimatedReturn) || 0;
                rowTotal = rowCredit + (parseFloat(item.amount) || 0);
              }
              var rowLock = (item.principalLocked === true) ? 'Principal locked'
                          : (item.principalLocked === false ? 'Principal open' : '');
              $$('.all-invest--list').append(
                '<a href="#" class="pf__inv item-investment" data-id="'+item.investID+'">' +
                  '<div class="pf__inv-top">' +
                    '<span class="pf__inv-top-l">' +
                      '<span class="pf__inv-status pf__inv-status--'+statusClass+'"><span class="pf__inv-status-dot"></span>'+status+'</span>' +
                      planBadge(item) +
                    '</span>' +
                    '<span class="pf__inv-ref">#'+item.investID+'</span>' +
                  '</div>' +
                  '<div class="pf__inv-grid">' +
                    '<div><div class="pf__inv-col-lbl">Invested</div><div class="pf__inv-amount">'+INR.format(item.amount)+'</div></div>' +
                    '<div><div class="pf__inv-col-lbl">'+rowCapLbl+'</div><div class="pf__inv-credit">'+INR.format(rowTotal)+'</div></div>' +
                  '</div>' +
                  (rowLock ? '<div class="pf__inv-lock">'+rowLock+'</div>' : '') +
                  (creditTXT ? '<div class="pf__inv-note">'+creditTXT+'</div>' : '') +
                  '<div class="pf__inv-foot">' +
                    '<span class="pf__inv-date">'+date+'</span>' +
                    '<span class="pf__inv-more">Tap to show more details<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg></span>' +
                  '</div>' +
                '</a>'
              );
              //check in this each loop if first item is closed or not
              if(i == 0) {
                if(item.status == '2' || item.status == '1') {
                  $$('.item__link--invest-new').removeClass('disabled no-invest__toast').attr('href', '/invest/');
                } else {
                  $$('.item__link--invest-new').addClass('disabled no-invest__toast');
                }
              }
            });
            //empty state when no investments
            if(!data.data || data.data.length === 0) {
              $$('.all-invest--list').html(
                '<div class="pf__empty">' +
                  '<div class="pf__empty-ico"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4z"/></svg></div>' +
                  '<h3 class="pf__empty-title">No investments yet</h3>' +
                  '<p class="pf__empty-sub">Start your XAUt Digital Gold journey today.</p>' +
                  '<a href="/invest/" class="pf__empty-cta">Invest Now</a>' +
                '</div>'
              );
            }
            // goldRate = current market rate; avgGoldRate = average buying price of 1 XAUt
            var currentRate = parseFloat(data.goldRate) || 0;
            var avgBuyPrice = parseFloat(data.avgGoldRate) || 0;
            var invested = parseFloat(data.investment) || 0;
            // Use pre-computed total from backend (most accurate).
            // avgGoldRate is a simple average — NOT weighted — so invested/avgGoldRate gives
            // wrong XAUt for multiple investments at different gold prices.
            var xautQty = parseFloat(data.totalXautHoldings) || 0;
            if (xautQty === 0 && data.data && data.data.length) {
              for (var di = 0; di < data.data.length; di++) {
                var dInv = data.data[di];
                if (String(dInv.status) === '1') {
                  var dUnits = parseFloat(dInv.xautUnits) || 0;
                  if (dUnits === 0) {
                    var dRate = parseFloat(dInv.purchaseGoldRate) || 0;
                    if (dRate > 0) dUnits = (parseFloat(dInv.amount) || 0) / dRate;
                  }
                  xautQty += dUnits;
                }
              }
            }
            if (xautQty === 0 && avgBuyPrice > 0) xautQty = invested / avgBuyPrice;
            // True weighted-average buy price (invested ÷ actual holdings), used for P&L %
            var effectiveAvgPf = xautQty > 0 ? invested / xautQty : avgBuyPrice;
            $$('.gold-quantity').html(parseFloat(xautQty).toFixed(4) + ' XAUt');
            // Populate static stats (invested + avg buy price don't change with market)
            $$('.pf__stat-invested').html(INR2.format(invested));
            if (effectiveAvgPf > 0) $$('.pf__stat-avg-buy').html(INR2.format(effectiveAvgPf));
            // baseline rate — refined to live CoinGecko price below
            $$('.gold-price').html(INR2.format(currentRate));
            $$('.invest__wallet--amount').html(INR2.format(invested));
            // Live market value + profit/loss vs total invested
            (function() {
              function applyMarket(livePrice) {
                if (!(xautQty > 0) || !(invested > 0)) return;
                var marketVal = xautQty * livePrice;
                var pl = marketVal - invested;
                var plPct = effectiveAvgPf > 0 ? (livePrice / effectiveAvgPf - 1) * 100 : 0;
                var up = pl >= 0;
                $$('.invest__wallet--amount').html(INR2.format(marketVal));
                $$('.gold-price').html(INR2.format(livePrice));
                $$('.pf__pl-pct').html(Math.abs(plPct).toFixed(2) + '%');
                $$('.pf__pl-abs').html((up ? '+' : '-') + INR2.format(Math.abs(pl)));
                $$('.pf__pl-lbl').html(up ? 'Market Profit' : 'Market Loss');
                $$('.pf__hero-pl-arrow').css('transform', up ? 'none' : 'rotate(180deg)');
                $$('.pf__hero-pl').removeClass('pf__hero-pl--down');
                if (!up) $$('.pf__hero-pl').addClass('pf__hero-pl--down');
                // holding row right-side P/L mirrors the main badge
                $$('.pf__holding-pct').html(Math.abs(plPct).toFixed(2) + '%');
                $$('.pf__holding-abs').html((up ? '+' : '-') + INR2.format(Math.abs(pl)));
                $$('.pf__hero-holding-pl-arrow').css('transform', up ? 'none' : 'rotate(180deg)');
                $$('.pf__hero-holding')[up ? 'removeClass' : 'addClass']('pf__hero-holding--down');
              }
              // current rate comes from the live market (CoinGecko), routed through the
              // shared price cache so this matches the Home card exactly; falls back to
              // the last shared price, then the backend's goldRate.
              fetch('https://api.coingecko.com/api/v3/simple/price?ids=tether-gold&vs_currencies=usd')
                .then(function(r){ return r.json(); })
                .then(function(d){
                  var info = d && d['tether-gold'];
                  var p = window.sharedGoldPrice ? window.sharedGoldPrice(info && info.usd ? info.usd : 0) : (info && info.usd);
                  applyMarket(p > 0 ? p : (currentRate || 4300));
                })
                .catch(function(){
                  var p = window.sharedGoldPrice ? window.sharedGoldPrice(0) : 0;
                  applyMarket(p > 0 ? p : (currentRate || 4300));
                });
            })();
            //enable quick actions (were stuck disabled)
            $$('.item_link--returns').attr('href', '/returns/');
            // Daily-profit total preview on the access card
            $.post(baseURL + 'invest.php', { returnHistory: true, token: localStorage.getItem('authToken') }, null, 'json')
              .done(function(rd) {
                if (!rd || rd.status !== 'success' || !rd.returnHistory || !rd.returnHistory.length) return;
                var t = 0;
                for (var ri = 0; ri < rd.returnHistory.length; ri++) {
                  if (String(rd.returnHistory[ri].status) === '1' && String(rd.returnHistory[ri].type) === '1') t += parseFloat(rd.returnHistory[ri].amount) || 0;
                }
                $$('.rt-dash-total').html(INR2.format(t));
              });
            $$('.item__link--withdraw').removeClass('disabled').attr('href', '/invest-withdraw/');
            $$('.item__link--earning').removeClass('disabled').attr('href', '/earning/');
            $$('.item__link--history').attr('href', '/transaction/investment');
          } else {
            //show no investment
            $$('.all-invest--list').html(
              '<div class="pf__empty">' +
                '<div class="pf__empty-ico"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4z"/></svg></div>' +
                '<h3 class="pf__empty-title">No investments yet</h3>' +
                '<p class="pf__empty-sub">Start your XAUt Digital Gold journey today.</p>' +
                '<a href="/invest/" class="pf__empty-cta">Invest Now</a>' +
              '</div>'
            );
          }
        });
        $$(document).off('click', '.no-invest__toast').on('click', '.no-invest__toast', function(e) {
          if (e && e.preventDefault) e.preventDefault();
          app.toast.show({
            text: 'Your previous investment is still being processed. Please wait until it is activated before investing again.',
            closeTimeout: 3000,
          });
        });
        $(document).off('click', '.item-investment');
        $(document).on('click', '.item-investment', function(e) {
          e.preventDefault();
          var investID = $(this).attr('data-id');
          if (!investID) {
            app.toast.show({
              text: 'Investment ID not found!',
              closeTimeout: 3000,
            });
            return;
          }
          app.methods.getUserDataInvest(function(data) {
            if (data.status == 'success') {
              var itemData = data.data.find(function(item){ return item.investID === investID; });
              if (!itemData) {
                app.toast.show({ text: 'Investment details not found!', closeTimeout: 3000 });
                return;
              }
              var st = String(itemData.status);
              var status = st === '0' ? 'Processing' : (st === '1' ? 'Active' : 'Closed');
              var statusClass = st === '0' ? 'processing' : (st === '1' ? 'active' : 'closed');
              // raw numbers (pre-format) for calculations
              var rawAmount = parseFloat(itemData.amount) || 0;
              // Three DIFFERENT numbers that are easy to confuse:
              //   credit / estimatedReturn → the ROI cap alone  (amount × (capMultiple − 1))
              //   maxTotalReturn           → the lifetime payout (ROI cap + principal)
              //   totalReturn / roiEarned  → ROI earned SO FAR, not any kind of maximum
              var rawRoiCap = parseFloat(itemData.credit);
              if (isNaN(rawRoiCap)) rawRoiCap = parseFloat(itemData.estimatedReturn);
              var rawReturn = parseFloat(itemData.maxTotalReturn);
              if (isNaN(rawRoiCap) && !isNaN(rawReturn)) rawRoiCap = Math.max(0, rawReturn - rawAmount);
              if (isNaN(rawRoiCap)) rawRoiCap = 0;
              if (isNaN(rawReturn)) rawReturn = rawRoiCap + rawAmount;
              var rawBalance = parseFloat(itemData.wallet) || 0;           // current withdrawable balance for this investment
              var rawWithdrawn = parseFloat(itemData.withdrawn) || 0;
              var rawRemaining = Math.max(0, rawReturn - rawWithdrawn);
              var wdPct = rawReturn > 0 ? Math.min(100, Math.round((rawWithdrawn / rawReturn) * 100)) : 0;
              // ROI earned so far (`totalReturn` is the legacy alias for `roiEarned`).
              var rawEarned = parseFloat(itemData.roiEarned);
              if (isNaN(rawEarned)) rawEarned = parseFloat(itemData.totalReturn);
              if (isNaN(rawEarned)) rawEarned = rawBalance + rawWithdrawn;
              // Plan 2.0: daily ROI is a property of the plan, not the amount. Prefer the
              // rate the backend recorded for this investment; fall back to the live plan list.
              var planRef = window.planConfig ? window.planConfig.plan(itemData.planCode || itemData.planID) : null;
              var rawRoi = parseFloat(itemData.dailyRoi);
              if (isNaN(rawRoi) && planRef) rawRoi = planRef.dailyRoi;
              if (isNaN(rawRoi) && rawAmount > 0) rawRoi = (parseFloat(itemData.dailyReturn) || 0) / rawAmount * 100;
              var roiPct = isNaN(rawRoi) ? null : rawRoi.toFixed(2);
              var capMult = parseFloat(itemData.capMultiple);
              if (isNaN(capMult) && planRef) capMult = planRef.capMultiple;
              if (isNaN(capMult) && rawAmount > 0 && rawReturn > 0) capMult = rawReturn / rawAmount;
              var capMultLbl = isNaN(capMult) ? '' : (parseFloat(capMult.toFixed(2)) + '×');
              var planName = itemData.planName || itemData.planCode || (planRef ? planRef.name : '');
              var fRoiCap = INR2.format(rawRoiCap);
              // Progress runs against the ROI cap, not the lifetime total — measured against
              // the total it would stall at 50% on a 2× plan and never fill.
              var capPct = parseFloat(itemData.roiEarnedPercent);
              if (isNaN(capPct)) capPct = rawRoiCap > 0 ? (rawEarned / rawRoiCap) * 100 : 0;
              capPct = Math.min(100, Math.round(capPct));
              // Headline the total return as a % of principal (200% on a 2× plan), never
              // `returnPercentage`, which is the ROI portion alone (100%).
              var totalPct = parseFloat(itemData.totalReturnPercentage);
              if (isNaN(totalPct) && rawAmount > 0) totalPct = (rawReturn / rawAmount) * 100;
              // dates — Plan 2.0 removed the fixed term, so there is no maturity/expiry date
              var dStart = itemData.dateStart || (itemData.date ? String(itemData.date).split(' ')[0] : '—');
              // formatted values
              var fAmount = INR2.format(rawAmount);
              var fReturn = INR2.format(rawReturn);
              var fEarned = INR2.format(rawEarned);
              var fBalance = INR2.format(rawBalance);
              var fDaily = INR2.format(parseFloat(itemData.dailyReturn) || 0);
              var fWithdrawn = rawWithdrawn > 0 ? INR2.format(rawWithdrawn) : 'N/A';
              var fRemaining = INR2.format(rawRemaining);
              // `remainingDays` is now the estimated calendar days to reach the CAP
              // (not a maturity countdown), calculated against the configured payout days.
              var remainingDays = parseFloat(itemData.remainingDays);
              var fToCap = (!isNaN(remainingDays) && remainingDays > 0)
                ? ('~' + Math.round(remainingDays).toLocaleString() + ' days')
                : '—';
              // XAUt gold details
              var rawXautUnits = parseFloat(itemData.xautUnits) || 0;
              var rawPurchaseRate = parseFloat(itemData.purchaseGoldRate) || 0;
              var fXautUnits = rawXautUnits > 0 ? rawXautUnits.toFixed(6) + ' XAUt' : '—';
              var fPurchaseRate = rawPurchaseRate > 0 ? INR2.format(rawPurchaseRate) + ' / XAUt' : '—';
              function iddRow(lbl, val, cls){ return '<div class="idd__row"><span class="idd__row-lbl">'+lbl+'</span><span class="idd__row-val '+(cls||'')+'">'+val+'</span></div>'; }

              var detailsPopup = app.popup.create({
                content:
                '<div class="popup idd-popup">' +
                  '<div class="idd">' +
                    '<div class="idd__topbar">' +
                      '<span class="idd__status idd__status--'+statusClass+'"><span class="idd__status-dot"></span>'+status+'</span>' +
                      planBadge(itemData) +
                      '<span class="idd__ref">#'+itemData.investID+'</span>' +
                      '<a href="#" class="idd__close popup-close" aria-label="Close"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></a>' +
                    '</div>' +
                    '<div class="idd__scroll">' +
                      '<div class="idd__hero">' +
                        '<div class="idd__hero-col"><div class="idd__hero-lbl">Invested</div><div class="idd__hero-amount">'+fAmount+'</div></div>' +
                        '<svg class="idd__hero-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
                        '<div class="idd__hero-col idd__hero-col--right"><div class="idd__hero-lbl">Max Return'+(capMultLbl ? ' · '+capMultLbl : '')+'</div><div class="idd__hero-return">'+fReturn+'</div></div>' +
                      '</div>' +
                      '<div class="idd__cap">' +
                        '<div class="idd__cap-head"><span>ROI Earned <b>'+fEarned+'</b> of '+fRoiCap+'</span><span class="idd__cap-pct">'+capPct+'%</span></div>' +
                        '<div class="idd__cap-track"><span class="idd__cap-bar" style="width:'+capPct+'%"></span></div>' +
                      '</div>' +
                      '<div class="idd__rows">' +
                        iddRow('Daily ROI', roiPct != null ? (roiPct + '%') : '—', 'idd__gold') +
                        iddRow('Max Return', fRoiCap + ' ROI + ' + fAmount + ' capital') +
                        (!isNaN(totalPct) ? iddRow('Total Return', parseFloat(totalPct.toFixed(2)) + '% of principal') : '') +
                        iddRow('ROI Remaining', INR2.format(
                          !isNaN(parseFloat(itemData.roiRemaining))
                            ? parseFloat(itemData.roiRemaining)
                            : Math.max(0, rawRoiCap - rawEarned))) +
                        iddRow('Daily Return', fDaily) +
                        iddRow('XAUt Holdings', fXautUnits, 'idd__gold') +
                        iddRow('Gold Rate at Purchase', fPurchaseRate) +
                        iddRow('Current Balance', fBalance, 'idd__gold') +
                        // Only render the plan-rule rows the backend actually sent —
                        // never infer "locked" from a missing field.
                        (itemData.canWithdrawRoi != null
                          ? iddRow('ROI Withdrawable', itemData.canWithdrawRoi ? 'Yes' : 'Locked until cycle completes') : '') +
                        (itemData.principalRedeemable != null || itemData.principalLocked != null
                          ? iddRow('Principal', itemData.principalRedeemable ? 'Released' : (itemData.principalLocked ? 'Locked until cycle completes' : 'Withdrawable any time')) : '') +
                        iddRow('Est. Time to Cap', fToCap) +
                        iddRow('Start Date', dStart) +
                        iddRow('Withdrawn', fWithdrawn) +
                      '</div>' +
                      '<div class="idd__wd">' +
                        '<div class="idd__wd-title">Withdrawal Summary</div>' +
                        '<div class="idd__wd-track"><span class="idd__wd-bar" style="width:'+wdPct+'%"></span></div>' +
                        '<div class="idd__wd-labels">' +
                          '<span class="idd__wd-pct">'+wdPct+'% withdrawn</span>' +
                          '<span class="idd__wd-cap">Max '+fReturn+'</span>' +
                        '</div>' +
                        '<div class="idd__wd-stats">' +
                          '<div class="idd__wd-stat"><span class="idd__wd-stat-lbl">Withdrawn</span><span class="idd__wd-stat-val idd__wd-withdrawn">'+fWithdrawn+'</span></div>' +
                          '<div class="idd__wd-stat idd__wd-stat--mid"><span class="idd__wd-stat-lbl">Remaining</span><span class="idd__wd-stat-val idd__wd-remaining">'+fRemaining+'</span></div>' +
                          '<div class="idd__wd-stat idd__wd-stat--right"><span class="idd__wd-stat-lbl">Total Cap</span><span class="idd__wd-stat-val">'+fReturn+'</span></div>' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                    '<div class="idd__footer">' +
                      '<button class="idd__done popup-close">Done</button>' +
                    '</div>' +
                  '</div>' +
                '</div>',
                swipeToClose: false,   // fullscreen popup → close via button/backdrop; keeps .idd__scroll free to scroll
                backdrop: true,
                on: {
                  closed: function () { this.destroy(); }   // dynamically created → remove from DOM on close (no leak on re-open)
                }
              });
              detailsPopup.open();
            } else {
              app.toast.show({
                text: 'Investment details not found!',
                closeTimeout: 3000,
              });
            }
          });
        });
      }
    }
  },
  {
    path: '/earning/',
    component: EarningPage,
    name: 'earning',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //copy-icon copy referral code
        $$('.copy-icon').off('click').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            // fallback for older browsers
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').off('click').on('click', function() {
          var shareLink = 'https://app.digitalmoneyexpress.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join DigiMoney Express',
              text: 'Use my referral code to join DigiMoney Express!',
              url: '' + shareLink
            }).catch(() => {});
          } else {
            console.log('Web Share API not supported in this browser.');
            //copy the link to clipboard
            if (navigator && navigator.clipboard) {
              navigator.clipboard.writeText(shareLink).then(function() {
                app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
              });
            }
          }
        });
        //get eraning from server
        app.methods.request(
          baseURL+'earning.php',
          {getEarnings: true, token: localStorage.getItem('authToken')},
          'json',
          function() { app.dialog.progress('Loading Earnings...'); },
          function(data) {
            app.dialog.close();
            if(data.status == 'success') {
              var d = data.data || {};
              $$('.network__wallet--amount, .ep-total-earnings').html(INR2.format(d.totalEarnings));
              $$('.ep-total-commission').html(INR2.format(d.totalCommission));
              $$('.ep-my-investment').html(INR2.format(d.myInvestment));
              $$('.ep-team-business').html(INR2.format(d.teamBusiness));
              $$('.total-members, .ep-team-members').html(d.teamMembers);
              $$('.total-direct-referrals, .ep-direct-members').html(d.directMembers);
              $$('.ep-daily-roi').html(INR2.format(d.dailyRoi));
              $$('.ep-direct-referral, .team-commission').html(INR2.format(d.directReferral));
              $$('.ep-team-roi-bonus, .direct-commission').html(INR2.format(d.teamRoiBonus));
              $$('.ep-leadership-salary').html(INR2.format(d.leadershipSalary));
              // The three Plan 2.0 income programs. totalCommission already includes
              // these — they are shown as a breakdown, never added on top.
              $$('.ep-warrior-income').html(INR2.format(d.warriorIncome));
              $$('.ep-royalty-income').html(INR2.format(d.royaltyIncome));
              $$('.ep-onetime-reward').html(INR2.format(d.oneTimeReward));

              // Show each stream as a share of the whole, so the mix is readable without
              // mental arithmetic. Scaled against the LARGEST stream (not the sum) so the
              // biggest bar always fills — a 3%-of-total row is otherwise invisible.
              (function () {
                var parts = [
                  ['.ep-daily-roi', d.dailyRoi, 'Daily ROI', 'gold'],
                  ['.ep-direct-referral', d.directReferral, 'Direct Referral', 'blue'],
                  ['.ep-team-roi-bonus', d.teamRoiBonus, 'Team ROI Bonus', 'green'],
                  ['.ep-leadership-salary', d.leadershipSalary, 'Leadership Salary', 'purple'],
                  ['.ep-warrior-income', d.warriorIncome, 'Express Warrior', 'gold'],
                  ['.ep-royalty-income', d.royaltyIncome, 'Royalty Income', 'purple'],
                  ['.ep-onetime-reward', d.oneTimeReward, 'One-Time Reward', 'green']
                ];
                var vals = parts.map(function (p) { return parseFloat(p[1]) || 0; });
                var sum = vals.reduce(function (a, b) { return a + b; }, 0);
                var max = Math.max.apply(null, vals);
                parts.forEach(function (p, i) {
                  var row = $$(p[0]).closest('.ep__break-row');
                  if (!row.length) return;
                  var share = sum > 0 ? (vals[i] / sum) * 100 : 0;
                  row.find('.ep__break-fill').css('width', (max > 0 ? (vals[i] / max) * 100 : 0) + '%');
                  row.find('.ep__break-pct').html(share > 0 ? (share.toFixed(share < 10 ? 1 : 0) + '% of total') : '');
                });
                // Summary card: name the biggest stream and draw the whole mix as one
                // stacked bar, so the page shows the gist without opening the popup.
                var topI = vals.indexOf(max);
                $$('.ep-top-src').html(
                  (sum > 0 && max > 0) ? (parts[topI][2] + ' · ' + INR2.format(max)) : 'Nothing earned yet'
                );
                var mix = '';
                parts.forEach(function (p, i) {
                  if (!(vals[i] > 0)) return;
                  mix += '<span class="ep__mix-seg--' + p[3] + '" style="width:' + ((vals[i] / sum) * 100) + '%"></span>';
                });
                $$('.ep__mix').html(mix);
              })();
              // Team ROI Bonus cap progress (multiple of self investment — admin-editable)
              var cap = parseFloat(d.teamRoiCap) || 0;
              var remaining = parseFloat(d.teamRoiRemaining) || 0;
              var earned = Math.max(0, cap - remaining);
              var pct = cap > 0 ? Math.min(100, (earned / cap) * 100) : 0;
              $$('.ep-roi-cap').html(INR2.format(cap));
              $$('.ep-roi-remaining').html(INR2.format(remaining));
              $$('.ep-roi-earned').html(INR2.format(earned));
              $$('.ep-roi-bar').css('width', pct + '%');
              if(d.teamMembers > 0) {
                $$('.item__link--earning-team').attr('href', '/my-team/');
              }
            } else {
              app.toast.show({
                text: data.msg,
                closeTimeout: 3000,
              });
            }
          },
          function() {
            app.dialog.close();
            app.toast.show({
              text: 'No internet connection!',
              closeTimeout: 3000,
            });
          }
        );
        // ── Team ROI Bonus status (getTeamRoiStatus) → earning card + #team-roi-popup ──
        (function() {
          var trToken = localStorage.getItem('authToken');
          // The Team ROI cap multiple is admin-editable (`team_roi_cap_mult`) — read it.
          var trCapMult = 5;
          if (window.planConfig) {
            window.planConfig.get(function (cfg) {
              trCapMult = cfg.teamRoiCapMult;
              $$('.tr-cap-mult, .ep-cap-mult').html(parseFloat(trCapMult.toFixed(2)) + '×');
            });
          }
          // Every Team ROI rate and criterion is admin-editable and was revised in
          // Plan 2.0 — render the ladder from the API's requirements[] / levels[].
          // Nothing about the ladder (rates, criteria, or its depth) is assumed here.
          function trNum(v){ return parseFloat(v) || 0; }
          function trEligOf(v){ return (v === true || v == 1 || v == '1' || String(v).toLowerCase() === 'true'); }
          function trEsc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
          // Compact level span for a band: [5,6,7,8,9,10] → "Levels 5–10"; [4] → "Level 4".
          function trBandLabel(levels) {
            var ls = (levels || []).map(Number).filter(function(n){ return !isNaN(n); }).sort(function(a,b){ return a-b; });
            if (!ls.length) return 'Levels';
            if (ls.length === 1) return 'Level ' + ls[0];
            return 'Levels ' + ls[0] + '–' + ls[ls.length - 1];
          }
          function trReqs(d) {
            var reqs = d.requirements || [];
            if (!reqs.length) {
              $$('.troi__reqs').html('<div class="troi__loading">No qualification data available.</div>');
              return;
            }
            var haveD = parseInt(d.directCount, 10) || 0, haveB = trNum(d.teamBusiness);
            var html = '';
            reqs.forEach(function(r) {
              var dReq = trNum(r.minDirects), bReq = trNum(r.minTeamBusiness);
              var yourD = r.yourDirects != null ? trNum(r.yourDirects) : haveD;
              var yourB = r.yourTeamBusiness != null ? trNum(r.yourTeamBusiness) : haveB;
              var met = trEligOf(r.qualified);
              var dPct = dReq > 0 ? Math.min(100, (yourD / dReq) * 100) : 100;
              var bPct = bReq > 0 ? Math.min(100, (yourB / bReq) * 100) : 100;
              // `label` is display-ready; fall back to a band label built from levels[].
              var bandName = trBandLabel(r.levels);
              var rankChip = (r.rank != null) ? '<span class="troi__req-rankchip">Rank ' + trEsc(r.rank) + '</span>' : '';
              var rateTxt = (r.rate != null) ? (trNum(r.rate) + '% of level ROI')
                          : (r.label ? trEsc(r.label) : '');
              html += '<div class="troi__req' + (met ? ' troi__req--met' : '') + '">' +
                '<div class="troi__req-head">' +
                  rankChip +
                  '<div class="troi__req-left"><span class="troi__req-rank">' + trEsc(bandName) + '</span>' +
                    '<span class="troi__req-rate">' + rateTxt + '</span></div>' +
                  '<span class="troi__req-badge' + (met ? ' troi__req-badge--met' : '') + '">' + (met ? '✓ Unlocked' : 'Locked') + '</span>' +
                '</div>' +
                (dReq > 0 || bReq > 0
                  ? '<div class="troi__req-criteria">' +
                      '<div class="troi__req-crit"><span class="troi__req-crit-lbl">Direct Referrals</span><span class="troi__req-crit-val">' + yourD + ' <span class="troi__req-crit-need">/ ' + dReq + '</span></span></div>' +
                      '<div class="troi__req-crit-sep"></div>' +
                      '<div class="troi__req-crit"><span class="troi__req-crit-lbl">Team Business</span><span class="troi__req-crit-val">' + INR2.format(yourB) + ' <span class="troi__req-crit-need">/ ' + INR2.format(bReq) + '</span></span></div>' +
                    '</div>' +
                    '<div class="troi__req-bar-row"><div class="troi__req-track"><span class="troi__req-fill" style="width:' + Math.min(dPct, bPct) + '%"></span></div></div>'
                  : '<div class="troi__req-criteria"><div class="troi__req-crit"><span class="troi__req-crit-lbl">No criteria — unlocked automatically</span></div></div>') +
              '</div>';
            });
            $$('.troi__reqs').html(html);
          }
          function trLevels(d) {
            var levels = d.levels || [];
            if (!levels.length) { $$('.troi__levels').html('<div class="troi__loading">No level data available.</div>'); return; }
            var html = '';
            levels.forEach(function(lv) {
              var elig = trEligOf(lv.eligible);
              // The per-level rate is carried by the API — every rate changed in Plan 2.0,
              // and the ladder's depth is configurable, so nothing here is derived locally.
              var rate = trNum(lv.rate);
              // Payout basis is the level's daily ROI today — NOT investment volume.
              var roiToday = trNum(lv.todayRoi != null ? lv.todayRoi : lv.dailyRoi);
              var bonus = (lv.estimatedBonus != null) ? trNum(lv.estimatedBonus)
                        : (elig ? roiToday * (rate / 100) : 0);
              html += '<div class="troi__lvl ' + (elig ? 'troi__lvl--on' : 'troi__lvl--off') + '">' +
                '<div class="troi__lvl-l">L' + lv.level + '</div>' +
                '<div class="troi__lvl-mid"><div class="troi__lvl-rate">' + rate + '% of L' + lv.level + ' ROI</div>' +
                  '<div class="troi__lvl-meta">' + (lv.memberCount || 0) + ' members · ' + (lv.activeInvestors || 0) + ' active · ROI ' + INR2.format(roiToday) + '</div></div>' +
                '<div class="troi__lvl-r"><div class="troi__lvl-bonus">' + (bonus > 0 ? '+' : '') + INR2.format(bonus) + '</div>' +
                  '<div class="troi__lvl-elig ' + (elig ? 'on' : 'off') + '">' + (elig ? 'Eligible' : 'Locked') + '</div></div>' +
              '</div>';
            });
            $$('.troi__levels').html(html);
          }
          function trRender(d) {
            var rank = parseInt(d.rank, 10) || 0;
            $$('.tr-rank-label').html(d.rankLabel || (rank > 0 ? ('Rank ' + rank) : 'Unranked'));
            $$('.tr-directs').html(parseInt(d.directCount, 10) || 0);
            $$('.tr-business').html(INR2.format(trNum(d.teamBusiness)));
            $$('.tr-investment').html(INR2.format(trNum(d.myInvestment)));
            var cap = trNum(d.teamRoiCap), earned = trNum(d.teamRoiEarned), rem = trNum(d.teamRoiRemaining);
            var cpct = cap > 0 ? Math.min(100, (earned / cap) * 100) : 0;
            $$('.tr-cap').html(INR2.format(cap));
            $$('.tr-earned').html(INR2.format(earned));
            $$('.tr-remaining').html(INR2.format(rem));
            $$('.tr-cap-bar').css('width', cpct + '%');
            $$('.tr-cap-note').html(d.capReached ? 'Cap reached · top up to continue' : (Math.round(cpct) + '% of ' + parseFloat(trCapMult.toFixed(2)) + '× cap used'));
            // Today's payout basis: a share of the team's daily ROI earned today (capped like the cron)
            $$('.tr-today-roi').html(INR2.format(trNum(d.todayTeamRoi != null ? d.todayTeamRoi : d.todayRoi)));
            // Has today's Team ROI bonus already been processed/credited (cron runs daily)?
            var estToday = trNum(d.estimatedBonusToday != null ? d.estimatedBonusToday : d.estimatedBonus);
            var bonusToday = trNum(d.bonusAmountToday != null ? d.bonusAmountToday : d.bonusCreditedToday);
            var paidToday = (d.bonusProcessedToday === true || d.bonusProcessedToday == 1 ||
                             d.bonusPaidToday === true || d.bonusPaidToday == 1 ||
                             d.paidToday === true || d.paidToday == 1);
            var ckIco = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
            var clkIco = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><circle cx="12" cy="12" r="9"/><polyline points="12 8 12 12 15 14"/></svg>';
            if (paidToday) {
              $$('.tr-bonus-headline').html('Bonus Credited Today');
              $$('.tr-bonus-today').html(INR2.format(bonusToday));
              $$('.tr-bonus-sub').html(bonusToday > 0
                ? 'Today\'s Team ROI bonus has been credited to your wallet.'
                : 'Today\'s payout has run — no team ROI was generated today.');
              $$('.tr-bonus-status').removeClass('troi__today-status--pending').addClass('troi__today-status--paid');
              $$('.tr-bonus-status .troi__today-status-ico').html(ckIco);
              $$('.tr-bonus-status-txt').html('Credited');
            } else {
              $$('.tr-bonus-headline').html('Estimated Bonus Today');
              $$('.tr-bonus-today').html(INR2.format(estToday));
              $$('.tr-bonus-sub').html('Your share of your team\'s daily ROI — credits when today\'s payout runs.');
              $$('.tr-bonus-status').removeClass('troi__today-status--paid').addClass('troi__today-status--pending');
              $$('.tr-bonus-status .troi__today-status-ico').html(clkIco);
              $$('.tr-bonus-status-txt').html('Pending');
            }
            // Progress to the next band the member hasn't qualified for. Driven entirely
            // by requirements[] — the number of bands and their criteria are configurable.
            var hd = parseInt(d.directCount, 10) || 0, hb = trNum(d.teamBusiness);
            var reqList = d.requirements || [];
            var target = null, tprog = 0;
            for (var nr = 0; nr < reqList.length; nr++) {
              var c = reqList[nr];
              if (trEligOf(c.qualified)) continue;
              var cd = trNum(c.minDirects), cb = trNum(c.minTeamBusiness);
              var yd = c.yourDirects != null ? trNum(c.yourDirects) : hd;
              var yb = c.yourTeamBusiness != null ? trNum(c.yourTeamBusiness) : hb;
              var prog = Math.min(cd > 0 ? (yd / cd) * 100 : 100, cb > 0 ? (yb / cb) * 100 : 100);
              tprog = Math.max(0, Math.min(100, prog));
              target = c;
              break;
            }
            if (!target) {
              $$('.tr-next-label').html('All criteria met');
              $$('.tr-next-pct').html('100%'); $$('.tr-next-bar').css('width', '100%');
            } else {
              $$('.tr-next-label').html(target.rank != null ? ('Rank ' + trEsc(target.rank)) : trBandLabel(target.levels));
              $$('.tr-next-pct').html(Math.round(tprog) + '%');
              $$('.tr-next-bar').css('width', tprog + '%');
            }
            trReqs(d); trLevels(d);
          }
          app.methods.request(
            baseURL + 'earning.php',
            { getTeamRoiStatus: 1, token: trToken },
            'json',
            function() {},
            function(res) {
              if (res && res.status == 'success') { trRender((res.data && res.data.rank != null) ? res.data : res); }
              else { $$('.troi__reqs, .troi__levels').html('<div class="troi__loading">Couldn\'t load Team ROI status.</div>'); }
            },
            function() { $$('.troi__reqs, .troi__levels').html('<div class="troi__loading">No internet connection.</div>'); }
          );
        })();
        // ── Income programs (getIncomePrograms) → Express Warrior · Royalty · One-Time Reward ──
        // One endpoint serves all three; they share the same qualifying team volume,
        // whose rule label and downline depth are admin policy (`rule` / `volumeDepth`).
        // Each has an admin on/off switch — a disabled program's UI stays hidden entirely,
        // otherwise members see a section that will never pay them.
        (function() {
          var ipToken = localStorage.getItem('authToken');
          function ipNum(v){ return parseFloat(v) || 0; }
          function ipEsc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
          function ipDate(s) {
            if (!s) return '';
            var d = new Date(String(s).replace(/-/g, '/'));
            if (isNaN(d.getTime())) return ipEsc(s);
            return d.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
          }
          function ipRow(cls, check, title, sub, val, valSub) {
            return '<div class="ipg__tier ' + cls + '">' +
              '<span class="ipg__tier-check">' + check + '</span>' +
              '<div class="ipg__tier-body"><div class="ipg__tier-vol">' + title + '</div>' +
                (sub ? '<div class="ipg__tier-sub">' + sub + '</div>' : '') + '</div>' +
              '<span class="ipg__tier-val">' + val + (valSub ? '<small>' + valSub + '</small>' : '') + '</span>' +
            '</div>';
          }

          // ── Express Warrior ──────────────────────────────────────────────────
          // NOT a daily percentage. A member who qualifies early still waits for the
          // window to close, because the payout base is their team's total ROI across
          // the whole window. Say so explicitly — this drives support questions.
          function ipWarrior(w) {
            if (!w || w.enabled === false) { $$('.ep-card-warrior, .ep-row-warrior').css('display', 'none'); return; }
            $$('.ep-card-warrior').css('display', '');

            var act = w.active || null;
            var tiers = w.tiers || [];
            $$('.wr-note').html(w.note ? ipEsc(w.note) : '');

            if (act && act.monthlyAmount != null) {
              $$('.wr-active').css('display', 'block');
              $$('.wr-amount').html(INR2.format(ipNum(act.monthlyAmount)));
              $$('.wr-target').html(INR2.format(ipNum(act.targetVolume)));
              $$('.wr-rate').html(ipNum(act.roiPct) + '%');
              $$('.wr-base').html(INR2.format(ipNum(act.roiBase)));
              $$('.wr-paid').html(INR2.format(ipNum(act.totalPaid != null ? act.totalPaid : w.totalPaid)));

              var mp = ipNum(act.monthsPaid), rm = ipNum(act.rewardMonths), ml = ipNum(act.monthsLeft);
              $$('.wr-months-txt').html(rm > 0 ? ('Month ' + Math.min(mp + (ml > 0 ? 1 : 0), rm) + ' of ' + rm) : '—');
              $$('.wr-months-pct').html(rm > 0 ? (mp + '/' + rm + ' paid') : '');
              $$('.wr-months-bar').css('width', (rm > 0 ? Math.min(100, (mp / rm) * 100) : 0) + '%');
              $$('.wr-headline').html(INR2.format(ipNum(act.monthlyAmount)) + '/mo');
              $$('.wr-state').html('Paid every month until ' + ipDate(act.expiresOn));
              $$('.wr-active-pill').removeClass('ipg__pill--pending ipg__pill--closed').addClass('ipg__pill--running').html('Paying');
              $$('.wr-sub').html('Month ' + mp + ' of ' + rm + ' · ' + INR2.format(ipNum(act.monthlyAmount)) + ' a month');
              $$('.wr-alert').css('display', 'none');
            } else {
              // Qualified-but-waiting is the state members misread as "broken".
              var pend = tiers.filter(function(t){ return t.pending === true; })[0];
              $$('.wr-active').css('display', pend ? 'block' : 'none');
              if (pend) {
                $$('.wr-amount').html('—');
                $$('.wr-target').html(INR2.format(ipNum(pend.targetVolume)));
                $$('.wr-rate').html(ipNum(pend.roiPct) + '%');
                $$('.wr-base').html('—');
                $$('.wr-paid').html(INR2.format(ipNum(w.totalPaid)));
                $$('.wr-months-txt').html('Not started');
                $$('.wr-months-pct').html('');
                $$('.wr-months-bar').css('width', '0%');
                $$('.wr-active-pill').removeClass('ipg__pill--running ipg__pill--closed').addClass('ipg__pill--pending').html('Qualified');
                var startsOn = ipDate(pend.startsOn || (w.active && w.active.startsOn));
                $$('.wr-alert').css('display', 'block').html(
                  'You have qualified. Your monthly amount is calculated from your team\'s total ROI across the full qualification window, so it is set on <b>' +
                  (startsOn || 'the window close date') + '</b> — the first payment follows then.'
                );
                $$('.wr-headline').html('Qualified');
                $$('.wr-state').html('Amount is calculated on ' + (startsOn || 'the window close date'));
                $$('.wr-sub').html('Qualified — your amount is set when the window closes');
              } else {
                $$('.wr-amount').html(INR2.format(0));
                $$('.wr-headline').html(INR2.format(ipNum(w.totalPaid)));
                $$('.wr-state').html('No active Warrior award');
                $$('.wr-sub').html('Hit a team business target within its window to qualify');
              }
            }

            if (!tiers.length) { $$('.wr-tiers').html('<div class="troi__loading">No Warrior targets configured.</div>'); return; }
            var html = '';
            tiers.forEach(function(t) {
              var running = (t.running === true), pending = (t.pending === true);
              var achieved = (t.achieved === true);
              var windowOpen = (t.windowOpen === true);
              var missed = !achieved && !windowOpen;      // deadline passed — never claimable
              var cls, check, sub, val, valSub;
              if (running) {
                cls = 'ipg__tier--running'; check = '✓';
                sub = 'Paying · month ' + ipNum(t.monthsPaid) + ' of ' + ipNum(t.rewardMonths);
                val = INR2.format(ipNum(t.monthlyAmount)); valSub = 'per month';
              } else if (pending) {
                cls = 'ipg__tier--pending'; check = '✓';
                sub = 'Qualified — amount calculated on ' + (ipDate(t.startsOn) || 'the window close date');
                val = '—'; valSub = 'pending';
              } else if (achieved) {
                cls = 'ipg__tier--done'; check = '✓';
                sub = 'Completed · ' + INR2.format(ipNum(t.totalPaid)) + ' paid in total';
                val = INR2.format(ipNum(t.monthlyAmount)); valSub = 'per month';
              } else if (missed) {
                cls = 'ipg__tier--closed'; check = '';
                sub = '<span class="ipg__tier-sub--off">Window closed — this target can no longer be claimed</span>';
                val = ipNum(t.roiPct) + '%'; valSub = 'of team ROI';
              } else {
                cls = 'ipg__tier--locked'; check = '';
                sub = INR2.format(ipNum(t.needed)) + ' more team business · by ' + (ipDate(t.deadline) || '—');
                val = ipNum(t.roiPct) + '%'; valSub = 'of team ROI';
              }
              html += ipRow(cls, check,
                INR2.format(ipNum(t.targetVolume)) + ' in ' + ipNum(t.withinMonths) + ' months',
                sub + ' · pays for ' + ipNum(t.rewardMonths) + ' months', val, valSub);
            });
            $$('.wr-tiers').html(html);
          }

          // ── Royalty ──────────────────────────────────────────────────────────
          // A shared pool, never "you receive 2%". Tiers stack.
          function ipRoyalty(r, qvol) {
            if (!r || r.enabled === false) { $$('.ep-card-royalty, .ep-row-royalty').css('display', 'none'); return; }
            $$('.ep-card-royalty').css('display', '');
            $$('.ry-paid').html(INR2.format(ipNum(r.totalPaid)));
            $$('.ry-headline').html(INR2.format(ipNum(r.totalPaid)));
            $$('.ry-qvol').html(INR2.format(qvol));
            $$('.ry-period').html(r.lastPeriod ? ipEsc(r.lastPeriod) : '—');
            if (r.note) $$('.ry-note').html(ipEsc(r.note));

            var tiers = r.tiers || [];
            var qCount = tiers.filter(function(t){ return t.qualified === true; }).length;
            $$('.ry-sub').html(qCount > 0
              ? ('Sharing in ' + qCount + ' royalty pool' + (qCount > 1 ? 's' : ''))
              : 'A share of company turnover, split between qualifiers');

            if (!tiers.length) { $$('.ry-tiers').html('<div class="troi__loading">No royalty tiers configured.</div>'); return; }
            var html = '';
            tiers.forEach(function(t) {
              var ok = (t.qualified === true);
              var need = ipNum(t.needed);
              html += ipRow(ok ? 'ipg__tier--done' : 'ipg__tier--locked', ok ? '✓' : '',
                INR2.format(ipNum(t.targetVolume)) + ' team business',
                ok ? 'Sharing in this pool' : (need > 0 ? (INR2.format(need) + ' more to qualify') : ''),
                ipNum(t.ctoPct) + '%', 'pool share');
            });
            $$('.ry-tiers').html(html);
          }

          // ── One-Time Reward ──────────────────────────────────────────────────
          // Each milestone pays exactly once per member, for life.
          function ipReward(rw) {
            if (!rw || rw.enabled === false) { $$('.ep-card-reward, .ep-row-reward').css('display', 'none'); return; }
            $$('.ep-card-reward').css('display', '');
            $$('.rw-paid').html(INR2.format(ipNum(rw.totalPaid)));

            var pendTotal = ipNum(rw.pendingTotal), pendCount = parseInt(rw.pendingCount, 10) || 0;
            if (pendTotal > 0) {
              $$('.rw-pending').css('display', 'block').html(
                '<b>' + INR2.format(pendTotal) + '</b> owed to you across ' + pendCount +
                ' milestone' + (pendCount === 1 ? '' : 's') + ' — it pays on the next reward run.'
              );
              $$('.rw-headline').html(INR2.format(pendTotal) + ' due');
              $$('.rw-sub').html(INR2.format(pendTotal) + ' owed · pays on the next reward run');
            } else {
              $$('.rw-pending').css('display', 'none');
              $$('.rw-headline').html(INR2.format(ipNum(rw.totalPaid)));
              $$('.rw-sub').html('Milestone rewards, paid once each');
            }

            var tiers = rw.tiers || [];
            if (!tiers.length) { $$('.rw-tiers').html('<div class="troi__loading">No reward milestones configured.</div>'); return; }
            var html = '';
            tiers.forEach(function(t) {
              var claimed = (t.claimed === true), pending = (t.pending === true);
              var need = ipNum(t.needed);
              var cls = claimed ? 'ipg__tier--done' : (pending ? 'ipg__tier--pending' : 'ipg__tier--locked');
              var sub = claimed ? 'Paid' :
                        pending ? '<span class="ipg__tier-sub--warn">Reached — awaiting the next reward run</span>' :
                        (need > 0 ? (INR2.format(need) + ' more to reach') : '');
              html += ipRow(cls, (claimed || pending) ? '✓' : '',
                INR2.format(ipNum(t.targetVolume)) + ' team business', sub,
                INR2.format(ipNum(t.reward)), 'one-time');
            });
            $$('.rw-tiers').html(html);
          }

          app.methods.request(
            baseURL + 'earning.php',
            { getIncomePrograms: 1, token: ipToken },
            'json',
            function() {},
            function(res) {
              var d = (res && res.status == 'success') ? (res.data || res) : null;
              if (!d) {
                $$('.ep-card-warrior, .ep-card-royalty, .ep-card-reward').css('display', 'none');
                return;
              }
              var qvol = ipNum(d.qualifyingVolume);
              // How team business is measured is admin policy — render the rule label and
              // the counted depth rather than assuming "60/40" or "20 levels".
              // volumeDepth 0 means the ENTIRE downline, not zero levels.
              if (d.rule) $$('.ls-rule, .rw-rule').html(ipEsc(d.rule));
              var depth = parseInt(d.volumeDepth, 10);
              if (!isNaN(depth)) {
                $$('.ls-depth').html(depth === 0 ? 'your entire downline' : ('your first ' + depth + ' levels'));
              }
              ipWarrior(d.warrior);
              ipRoyalty(d.royalty, qvol);
              ipReward(d.reward);
            },
            function() { $$('.ep-card-warrior, .ep-card-royalty, .ep-card-reward').css('display', 'none'); }
          );
        })();
        // ── Monthly Leadership Salary (getLeadershipStatus) → earning card + #leadership-popup ──
        (function() {
          var lsToken = localStorage.getItem('authToken');
          function lsNum(v){ return parseFloat(v) || 0; }
          function lsEsc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
          function lsCalcRow(lbl, sub, val, cls, mod) {
            return '<div class="lsal__calc-row' + (mod ? ' ' + mod : '') + '"><span class="lsal__calc-lbl">' + lbl + (sub ? '<small>' + sub + '</small>' : '') + '</span><span class="lsal__calc-val' + (cls ? ' ' + cls : '') + '">' + val + '</span></div>';
          }
          function lsCalc(c, qvol) {
            if (!c) { $$('.lsal__calc').html('<div class="troi__loading">No calculation data.</div>'); return; }
            // The strong-leg cap is an admin policy — read the percentage rather than
            // baking "60/40" into the labels.
            var strongPct = lsNum(c.strongLegPct);
            var weakPct = strongPct > 0 ? (100 - strongPct) : 0;

            // Leg split visual on the Rewards page: how the raw volume divides between
            // the strongest leg and everything else, before the cap is applied.
            var strongRaw = lsNum(c.strongestLeg), otherRaw = lsNum(c.otherLegsSum);
            var totalRaw = strongRaw + otherRaw;
            $$('.ls-strong-val').html(INR2.format(strongRaw));
            $$('.ls-other-val').html(INR2.format(otherRaw));
            $$('.ls-split-strong').css('width', (totalRaw > 0 ? (strongRaw / totalRaw) * 100 : 0) + '%');
            $$('.ls-split-other').css('width', (totalRaw > 0 ? (otherRaw / totalRaw) * 100 : 0) + '%');
            // Fill only the percentage spans — rewriting the whole note would destroy
            // the .ls-depth span that the income-programs response populates separately.
            if (strongPct > 0) {
              $$('.ls-strong-pct').html(strongPct + '%');
              $$('.ls-weak-pct').html(weakPct + '%');
            }
            // One-line verdict on the summary card, so the common failure mode
            // (everything sitting in a single leg) is visible without opening the popup.
            var strongShare = totalRaw > 0 ? (strongRaw / totalRaw) * 100 : 0;
            var qv = lsNum(c.qualifyingVolume != null ? c.qualifyingVolume : qvol);
            var state;
            if (totalRaw <= 0) state = 'no team volume yet';
            else if (otherRaw <= 0) state = 'all volume in one leg — nothing qualifies';
            else if (lsNum(c.reduction) > 0) state = Math.round(strongShare) + '% in your strongest leg — capped';
            else state = 'legs are within the cap';
            $$('.ep-qual-state')
              .removeClass('ep__state--ok ep__state--warn')
              .addClass((qv > 0 && lsNum(c.reduction) <= 0) ? 'ep__state--ok' : 'ep__state--warn')
              .html(state);
            var html = '';
            html += lsCalcRow('Strongest leg', c.strongestLegName || '', INR2.format(lsNum(c.strongestLeg)));
            html += lsCalcRow('Other legs' + (weakPct > 0 ? ' (' + weakPct + '% side)' : ''), '', INR2.format(lsNum(c.otherLegsSum)));
            html += lsCalcRow('Max allowed from strong leg', strongPct > 0 ? (strongPct + '% cap') : 'cap', INR2.format(lsNum(c.maxAllowed)));
            html += lsCalcRow('Counted from strongest', '', INR2.format(lsNum(c.strongestCounted)));
            if (c.capApplied) html += lsCalcRow('Strong-leg cap reduction', '', '−' + INR2.format(lsNum(c.reduction)), 'lsal__calc-val--cut');
            html += lsCalcRow('Qualifying volume', '', INR2.format(lsNum(c.qualifyingVolume != null ? c.qualifyingVolume : qvol)), '', 'lsal__calc-row--total');
            $$('.lsal__calc').html(html);
          }
          function lsLegs(legs) {
            legs = legs || [];
            if (!legs.length) { $$('.lsal__legs').html('<div class="troi__loading">No legs yet.</div>'); return; }
            var html = '';
            legs.forEach(function(l, i) {
              var name = l.name || l.legName || ('Leg ' + (i + 1));
              var actual = lsNum(l.actualVolume != null ? l.actualVolume : (l.volume != null ? l.volume : l.legVolume));
              var counted = lsNum(l.volumeCounted != null ? l.volumeCounted : actual);
              var pct = (l.pctOfQualifying != null) ? Math.max(0, Math.min(100, lsNum(l.pctOfQualifying))) : 0;
              var strong = (l.isStrongest === true || l.strongest === true || l.isStrong === true);
              var capped = (l.isCapped === true);
              var redu = lsNum(l.reduction);
              var sub = pct.toFixed(1) + '% of qualifying';
              if (capped && redu > 0) sub += ' · capped −' + INR2.format(redu) + ' (counts ' + INR2.format(counted) + ')';
              html += '<div class="lsal__leg' + (strong ? ' lsal__leg--strong' : '') + '">' +
                '<span class="lsal__leg-ico"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg></span>' +
                '<div class="lsal__leg-body"><div class="lsal__leg-top"><span class="lsal__leg-name">' + lsEsc(name) + (strong ? ' <span class="lsal__leg-tag">· Strong</span>' : '') + '</span><span class="lsal__leg-vol">' + INR2.format(actual) + '</span></div>' +
                  '<div class="lsal__leg-track"><span class="lsal__leg-fill" style="width:' + pct + '%"></span></div>' +
                  '<div class="lsal__leg-sub">' + sub + '</div></div>' +
              '</div>';
            });
            $$('.lsal__legs').html(html);
          }
          function lsTiers(tiers) {
            tiers = tiers || [];
            if (!tiers.length) { $$('.lsal__tiers').html('<div class="troi__loading">No tier data.</div>'); return; }
            var html = '';
            tiers.forEach(function(t) {
              // Plan 2.0: `achieved` is PERMANENT (levels are never lost); `qualified`
              // reflects CURRENT BV. Show a level as attained on `achieved`, and flag it
              // when the volume has since slipped below the level's requirement.
              var got = (t.achieved === true), qual = (t.qualified === true);
              var cur = (t.isCurrent === true), nxt = (t.isNext === true);
              var lapsed = got && !qual;
              var cls = cur ? 'lsal__tier--current' : (nxt ? 'lsal__tier--next' : (got ? 'lsal__tier--done' : 'lsal__tier--locked'));
              if (lapsed) cls += ' lsal__tier--lapsed';
              var badge = cur ? '<span class="lsal__tier-badge">Current</span>' : (nxt ? '<span class="lsal__tier-badge">Next</span>' : '');
              var need = (nxt && t.needed != null && lsNum(t.needed) > 0) ? '<div class="lsal__tier-need">Need ' + INR2.format(lsNum(t.needed)) + ' more</div>' : '';
              var dur = (t.duration != null && lsNum(t.duration) > 0) ? ' · ' + lsNum(t.duration) + ' months' : '';
              var lapse = lapsed ? '<div class="lsal__tier-need lsal__tier-need--warn">Achieved — restore team BV to resume payment</div>' : '';
              html += '<div class="lsal__tier ' + cls + '">' +
                '<span class="lsal__tier-check">' + ((got || cur) ? '✓' : '') + '</span>' +
                '<div class="lsal__tier-body"><div class="lsal__tier-vol">' + INR2.format(lsNum(t.volume)) + ' team business' + dur + '</div>' + need + lapse + '</div>' +
                '<span class="lsal__tier-sal">' + INR2.format(lsNum(t.salary)) + '</span>' + badge +
              '</div>';
            });
            $$('.lsal__tiers').html(html);
          }
          // Plan 2.0 `standing` block — duration spent, maintenance shortfall, upgrade prompt.
          function lsStanding(s) {
            if (!s) { $$('.lsal__standing').css('display', 'none'); return; }
            $$('.lsal__standing').css('display', 'block');

            var payable = (s.payableThisMonth === true);
            $$('.ls-pay-pill')
              .removeClass('lsal__standing-pill--on lsal__standing-pill--off')
              .addClass(payable ? 'lsal__standing-pill--on' : 'lsal__standing-pill--off')
              .html(payable ? 'Paying this month' : 'Withheld this month');
            $$('.ls-reason').html(lsEsc(s.statusReason || (payable ? 'Qualified' : 'Not currently payable')));

            // monthsRemaining === null means the level pays indefinitely.
            var dur = lsNum(s.durationMonths), paid = lsNum(s.monthsPaid);
            if (s.monthsRemaining == null) {
              $$('.ls-months-txt').html('Unlimited duration');
              $$('.ls-months-pct').html('∞');
              $$('.ls-months-bar').css('width', '100%');
            } else if (dur > 0) {
              var left = lsNum(s.monthsRemaining);
              $$('.ls-months-txt').html(left + ' of ' + dur + ' months left');
              $$('.ls-months-pct').html(paid + '/' + dur + ' paid');
              $$('.ls-months-bar').css('width', Math.min(100, (paid / dur) * 100) + '%');
            } else {
              $$('.ls-months-txt').html('—');
              $$('.ls-months-pct').html('');
              $$('.ls-months-bar').css('width', '0%');
            }

            var short = lsNum(s.maintenanceShortfall);
            if (short > 0) {
              $$('.ls-shortfall').css('display', 'block').html(
                'Recover <b>' + INR2.format(short) + '</b> in team BV to resume payment. A withheld month does not count against your duration.'
              );
            } else { $$('.ls-shortfall').css('display', 'none'); }

            if (s.needsUpgrade === true) {
              $$('.ls-upgrade').css('display', 'block').html(
                'Duration completed at this level — reach the next team BV milestone to continue earning a salary.'
              );
            } else { $$('.ls-upgrade').css('display', 'none'); }
          }
          function lsRender(d) {
            $$('.ls-salary').html(INR2.format(lsNum(d.monthlySalary)));
            $$('.ls-qvol').html(INR2.format(lsNum(d.qualifyingVolume)));
            $$('.ls-rawvol').html(INR2.format(lsNum(d.rawTeamVolume)));
            $$('.ls-legs').html(parseInt(d.legCount, 10) || 0);
            $$('.ls-paid').html(INR2.format(lsNum(d.totalPaid)));
            var nt = d.nextTier || {};
            if (nt && nt.salary != null) {
              $$('.ls-next-salary').html(INR2.format(lsNum(nt.salary)) + '/mo');
              var qv = lsNum(d.qualifyingVolume), tv = lsNum(nt.volume);
              var prog = tv > 0 ? Math.min(100, (qv / tv) * 100) : 100;
              $$('.ls-next-pct').html(Math.round(prog) + '%');
              $$('.ls-next-bar').css('width', prog + '%');
              $$('.ls-next-needed').html((nt.needed != null && lsNum(nt.needed) > 0) ? ('Need ' + INR2.format(lsNum(nt.needed)) + ' more qualifying volume') : '');
            } else {
              $$('.ls-next-salary').html('Top tier');
              $$('.ls-next-pct').html('100%');
              $$('.ls-next-bar').css('width', '100%');
              $$('.ls-next-needed').html('You have reached the highest salary tier.');
            }
            lsStanding(d.standing);
            lsCalc(d.calculation, d.qualifyingVolume);
            lsLegs(d.legs);
            lsTiers(d.tiers);
          }
          app.methods.request(
            baseURL + 'earning.php',
            { getLeadershipStatus: 1, token: lsToken },
            'json',
            function() {},
            function(res) {
              if (res && res.status == 'success') { lsRender((res.data && res.data.monthlySalary != null) ? res.data : res); }
              else { $$('.lsal__calc, .lsal__legs, .lsal__tiers').html('<div class="troi__loading">Couldn\'t load leadership status.</div>'); }
            },
            function() { $$('.lsal__calc, .lsal__legs, .lsal__tiers').html('<div class="troi__loading">No internet connection.</div>'); }
          );
        })();
      }
    }
  },
  {
    path: '/my-team/',
    component: MyTeamPage,
    name: 'my-team',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(data) {
          if(data.isLoggedin == 'true') {
            app.dialog.close();
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          } else {
            app.dialog.close();
            app.views.main.router.navigate({name: 'Home'});
          }
        });
        //copy referral code
        $$('.copy-icon').off('click').on('click', function(e) {
          e.preventDefault();
          var text = $$('.referral-code').text();
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              app.toast.show({text: 'Copied!', closeTimeout: 1500});
            });
          } else {
            var tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            app.toast.show({text: 'Copied!', closeTimeout: 1500});
          }
        });
        $$('.invite-link-btn').off('click').on('click', function() {
          var shareLink = 'https://app.digitalmoneyexpress.com/#!/register/referral/' + $$(this).attr('data-referral');
          if (navigator.share) {
            navigator.share({
              title: 'Join DigiMoney Express',
              text: 'Use my referral code to join DigiMoney Express!',
              url: '' + shareLink
            }).catch(() => {});
          } else if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(shareLink).then(function() {
              app.toast.show({text: 'Invitation link copied to clipboard!', closeTimeout: 1500});
            });
          }
        });
        // ── Team levels + paginated members (getTeamLevels / getTeamMembers) ──
        var token = localStorage.getItem('authToken');
        var curLevel = 1, curPage = 1, totalPages = 1, loadingMembers = false;
        function mtEsc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
        function mtEmpty() {
          return '<div class="mt__empty"><div class="mt__empty-ico"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg></div><h3 class="mt__empty-title">No members at this level</h3><p class="mt__empty-sub">Share your referral code to grow your team.</p></div>';
        }
        function mtMemberCard(m) {
          var name = m.name || 'Member';
          var username = m.username || '';
          // active = status flag from backend, else fall back to "has an investment"
          var active = (m.status != null && m.status !== '')
            ? (m.status == '1' || m.status === 1 || m.status === true || String(m.status).toLowerCase() === 'active')
            : (parseFloat(m.selfInvestment) > 0);
          var chips = '<span class="mt__member-chip mt__member-chip--' + (active ? 'active' : 'inactive') + '"><span class="mt__chip-dot"></span>' + (active ? 'Active' : 'Inactive') + '</span>';
          if (m.phone) chips += '<span class="mt__member-chip"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.88-.88a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>' + mtEsc(m.phone) + '</span>';
          chips += '<span class="mt__member-chip"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>' + (parseInt(m.directCount, 10) || 0) + ' direct</span>';
          if (m.joinDate) chips += '<span class="mt__member-chip">' + mtEsc(m.joinDate) + '</span>';
          return '<div class="mt__member">' +
            '<img class="mt__member-avatar" src="https://ui-avatars.com/api/?background=201a0e&color=dfc288&length=2&rounded=true&bold=true&font-size=0.42&name=' + encodeURIComponent(name) + '" alt=""/>' +
            '<div class="mt__member-body">' +
              '<div class="mt__member-top"><span class="mt__member-name">' + mtEsc(name) + '</span>' +
                '<span class="mt__member-inv">' + INR2.format(parseFloat(m.selfInvestment) || 0) + '</span></div>' +
              (username ? '<div class="mt__member-uname">@' + mtEsc(username) + '</div>' : '') +
              (m.email ? '<div class="mt__member-email">' + mtEsc(m.email) + '</div>' : '') +
              '<div class="mt__member-meta">' + chips + '</div>' +
            '</div></div>';
        }
        function mtLoadMembers(reset) {
          if (loadingMembers) return;
          loadingMembers = true;
          if (reset) $$('.mt__members').html('<div class="mt__loading">Loading members…</div>');
          app.methods.request(
            baseURL + 'earning.php',
            { getTeamMembers: 1, level: curLevel, page: curPage, limit: 20, token: token },
            'json',
            function() {},
            function(res) {
              loadingMembers = false;
              var ok = res && res.status == 'success';
              var members = ok ? (res.members || (res.data && res.data.members) || []) : [];
              totalPages = ok ? (res.totalPages || (res.data && res.data.totalPages) || 1) : 1;
              var html = members.map(mtMemberCard).join('');
              if (reset) { $$('.mt__members').html(html || mtEmpty()); }
              else { $$('.mt__members').append(html); }
              $$('.mt__loadmore').css('display', curPage < totalPages ? '' : 'none');
            },
            function() {
              loadingMembers = false;
              if (reset) $$('.mt__members').html('<div class="mt__loading">Couldn\'t load members. Please try again.</div>');
            }
          );
        }
        function mtSetLevelStats() {
          var sel = document.getElementById('mtLevelSelect');
          if (!sel || sel.selectedIndex < 0) return;
          var opt = sel.options[sel.selectedIndex];
          $$('.mt-lvl-members').html(opt.getAttribute('data-count') || 0);
          $$('.mt-lvl-active').html(opt.getAttribute('data-active') || 0);
          $$('.mt-lvl-roi').html(INR2.format(parseFloat(opt.getAttribute('data-roi')) || 0));
          $$('.mt-lvl-volume').html(INR2.format(parseFloat(opt.getAttribute('data-volume')) || 0));
          $$('.mt__members-title').html(curLevel === 1 ? 'Direct Members · L1' : ('Level ' + curLevel + ' Members'));
        }
        function mtRenderLevels(levels, totals) {
          $$('.mt-total-members').html((totals && totals.members != null) ? totals.members : 0);
          $$('.mt-team-business').html(INR2.format((totals && totals.teamBusiness) || 0));
          $$('.mt-team-roi').html(INR2.format((totals && totals.todayRoi) || 0));
          var opts = '';
          levels.forEach(function(lv) {
            var lvRoi = (lv.todayRoi != null ? lv.todayRoi : (lv.dailyRoi != null ? lv.dailyRoi : 0));
            opts += '<option value="' + lv.level + '" data-count="' + (lv.memberCount || 0) + '" data-active="' + (lv.activeInvestors || 0) + '" data-roi="' + lvRoi + '" data-volume="' + (lv.levelVolume || 0) + '">' +
              'Level ' + lv.level + (lv.level == 1 ? ' · Direct Members' : '') + ' (' + (lv.memberCount || 0) + ')' +
              '</option>';
            if (lv.level == 1) $$('.mt-direct-members').html(lv.memberCount || 0);
          });
          var sel = document.getElementById('mtLevelSelect');
          if (sel) {
            sel.innerHTML = opts || '<option>No levels found</option>';
            if (sel.options.length && sel.selectedIndex < 0) sel.selectedIndex = 0;
          }
          var $sel = $('#mtLevelSelect');
          if ($sel.length && $.fn && $.fn.select2) {
            // styled dropdown (consistent with the rest of the app)
            if ($sel.hasClass('select2-hidden-accessible')) { try { $sel.select2('destroy'); } catch (e) {} }
            $sel.select2({ minimumResultsForSearch: -1 });
            $sel.val(String(curLevel)).trigger('change.select2');   // sync select2 display (no handler fire)
            $sel.off('change.mtlvl').on('change.mtlvl', function() {
              curLevel = parseInt($(this).val(), 10) || 1;
              curPage = 1;
              mtSetLevelStats();
              mtLoadMembers(true);
            });
          } else {
            // native fallback
            if (sel) sel.value = String(curLevel);
            $$('#mtLevelSelect').off('change').on('change', function() {
              curLevel = parseInt(this.value, 10) || 1;
              curPage = 1;
              mtSetLevelStats();
              mtLoadMembers(true);
            });
          }
          mtSetLevelStats();
          mtLoadMembers(true);
        }
        $$('.mt__loadmore').off('click').on('click', function() {
          if (curPage < totalPages) { curPage++; mtLoadMembers(false); }
        });
        // fetch team levels (L1–L20)
        app.dialog.progress('Loading Team...');
        app.methods.request(
          baseURL + 'earning.php',
          { getTeamLevels: 1, token: token },
          'json',
          function() {},
          function(res) {
            app.dialog.close();
            if (res && res.status == 'success') {
              var levels = res.levels || (res.data && res.data.levels) || [];
              var totals = res.totals || (res.data && res.data.totals) || {};
              mtRenderLevels(levels, totals);
            } else {
              var s1 = document.getElementById('mtLevelSelect'); if (s1) s1.innerHTML = '<option>Couldn\'t load levels</option>';
              app.toast.show({ text: (res && res.msg) || 'Failed to load team.', closeTimeout: 3000 });
            }
          },
          function() {
            app.dialog.close();
            var s2 = document.getElementById('mtLevelSelect'); if (s2) s2.innerHTML = '<option>No internet connection</option>';
            app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 });
          }
        );

        /* ── Genealogy tree ──────────────────────────────────────────────────────
           Children are fetched per-node, only when a node is opened, and cached —
           the whole downline is never pulled in one request. Depth is capped at
           MT_MAX_DEPTH so a deep leg can't recurse without bound.

           Backend contract (earning.php):
             getTeamTree=1 & token & memberID=<id>   → that member's DIRECT children
             getTeamTree=1 & token                   → the logged-in user's direct children
           Response: { status:'success', members:[ { memberID, name, username, level,
                       directCount, selfInvestment, status, joinDate } ] }

           Until that action exists the root still works, because level 1 is exactly
           `getTeamMembers(level=1)`; deeper nodes then report that they can't expand
           rather than failing silently. */
        var MT_MAX_DEPTH = 20;
        var mtTreeCache = {};            // parentKey -> normalised children
        var mtTreeLoading = {};          // parentKey -> true while in flight
        var mtTreeSupported = null;      // null = unknown, false = endpoint missing
        var mtRootName = 'You';

        function mtNodeId(m) {
          var id = m.memberID != null ? m.memberID
                 : (m.id != null ? m.id
                 : (m.userID != null ? m.userID : m.username));
          return id == null ? '' : String(id);
        }
        function mtNorm(m, depth) {
          var active = (m.status != null && m.status !== '')
            ? (m.status == '1' || m.status === 1 || m.status === true || String(m.status).toLowerCase() === 'active')
            : (parseFloat(m.selfInvestment) > 0);
          return {
            id: mtNodeId(m),
            name: m.name || 'Member',
            username: m.username || '',
            depth: parseInt(m.level, 10) || depth,
            directs: parseInt(m.directCount, 10) || 0,
            invested: parseFloat(m.selfInvestment) || 0,
            joinDate: m.joinDate || '',
            active: active
          };
        }
        // Resolve a node's direct children, preferring the tree endpoint and falling
        // back to the flat level-1 query for the root only.
        function mtFetchChildren(node, cb) {
          var key = node ? ('m:' + node.id) : 'root';
          if (mtTreeCache[key]) { cb(mtTreeCache[key]); return; }
          if (mtTreeLoading[key]) return;
          mtTreeLoading[key] = true;
          var depth = node ? node.depth + 1 : 1;

          function done(list) {
            mtTreeLoading[key] = false;
            mtTreeCache[key] = list;
            cb(list);
          }
          function fallbackRoot() {
            // Level 1 IS the root's direct line, so the tree's first tier works today.
            app.methods.request(
              baseURL + 'earning.php',
              { getTeamMembers: 1, level: 1, page: 1, limit: 100, token: token },
              'json',
              function() {},
              function(r2) {
                var ms = (r2 && r2.status == 'success')
                  ? (r2.members || (r2.data && r2.data.members) || []) : [];
                done(ms.map(function(m){ return mtNorm(m, 1); }));
              },
              function() { mtTreeLoading[key] = false; cb(null); }
            );
          }

          var params = { getTeamTree: 1, token: token };
          if (node) params.memberID = node.id;
          app.methods.request(
            baseURL + 'earning.php', params, 'json',
            function() {},
            function(res) {
              var ok = res && res.status == 'success';
              if (ok) {
                mtTreeSupported = true;
                var ms = res.members || (res.data && res.data.members) || [];
                done(ms.map(function(m){ return mtNorm(m, depth); }));
                return;
              }
              // Unknown action → endpoint not deployed yet.
              mtTreeSupported = false;
              if (!node) { fallbackRoot(); return; }
              mtTreeLoading[key] = false;
              cb(null);
            },
            function() {
              if (!node && mtTreeSupported !== true) { fallbackRoot(); return; }
              mtTreeLoading[key] = false;
              cb(null);
            }
          );
        }

        /* -- Drill-down renderer -------------------------------------------------
           Nesting cannot scale to 20 levels on a phone: each tier steals ~16px of
           width, so by L6 the name column is already crushed and by L20 there is
           nothing left. Instead we show ONE tier at a time at full width, with a
           breadcrumb spine for the path back. Depth then costs no horizontal space
           at all, and each step is still a single children-of-one-member fetch. */
        var mtPath = [];   // ancestors from the root down to the member being viewed

        function mtAvatar(name, root) {
          return 'https://ui-avatars.com/api/?background=' + (root ? '2a2110' : '201a0e') +
            '&color=' + (root ? 'f3da92' : 'dfc288') +
            '&length=2&rounded=true&bold=true&font-size=0.42&name=' + encodeURIComponent(name);
        }
        function mtSpinner(label) {
          return '<div class="mt__spin-wrap"><span class="mt__spin"></span>' +
            (label ? '<span class="mt__spin-txt">' + label + '</span>' : '') + '</div>';
        }
        // The member currently in focus; null means the logged-in user (the root).
        function mtCurrent() { return mtPath.length ? mtPath[mtPath.length - 1] : null; }

        function mtCrumbHTML() {
          var SEP = '<svg class="mt__crumb-sep" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="9 18 15 12 9 6"/></svg>';
          var html = '<button type="button" class="mt__crumb' + (mtPath.length ? '' : ' mt__crumb--on') +
            '" data-idx="-1"><img src="' + mtAvatar(mtRootName, true) + '" alt=""/><span>You</span></button>';
          // The trail is built from the members actually tapped through. If we landed on
          // someone deeper than the number of steps taken (a jump straight to a deep
          // member), the ancestors in between were never visited — say so rather than
          // implying a direct line. `ancestors[]` from the API would fill this in.
          var cur = mtCurrent();
          var gap = cur ? (cur.depth - mtPath.length) : 0;
          if (gap > 0) {
            html += SEP + '<span class="mt__crumb mt__crumb--gap" title="' + gap +
              ' level' + (gap === 1 ? '' : 's') + ' not shown">…</span>';
          }
          mtPath.forEach(function (n, i) {
            var last = (i === mtPath.length - 1);
            html += SEP +
              '<button type="button" class="mt__crumb' + (last ? ' mt__crumb--on' : '') + '" data-idx="' + i + '">' +
              '<img src="' + mtAvatar(n.name) + '" alt=""/>' +
              '<span>' + mtEsc(String(n.name).split(' ')[0]) + '</span>' +
              '<b class="mt__crumb-l">L' + n.depth + '</b></button>';
          });
          return '<div class="mt__crumbs-wrap"><div class="mt__crumbs">' + html + '</div></div>';
        }

        function mtFocusHTML() {
          var n = mtCurrent();
          if (!n) {
            return '<div class="mt__focus mt__focus--root">' +
              '<img class="mt__focus-av" src="' + mtAvatar(mtRootName, true) + '" alt=""/>' +
              '<div class="mt__focus-body">' +
                '<div class="mt__focus-name">' + mtEsc(mtRootName) + '<span class="mt__node-you">You</span></div>' +
                '<div class="mt__focus-meta mt__focus-directs">Your direct line</div>' +
              '</div></div>';
          }
          return '<div class="mt__focus">' +
            '<img class="mt__focus-av" src="' + mtAvatar(n.name) + '" alt=""/>' +
            '<span class="mt__focus-dot mt__focus-dot--' + (n.active ? 'on' : 'off') + '"></span>' +
            '<div class="mt__focus-body">' +
              '<div class="mt__focus-name">' + mtEsc(n.name) +
                '<span class="mt__lvl-chip">L' + n.depth + '</span></div>' +
              '<div class="mt__focus-meta">' + (n.username ? '@' + mtEsc(n.username) : '') +
                (n.joinDate ? (n.username ? ' \u00b7 ' : '') + mtEsc(n.joinDate) : '') + '</div>' +
            '</div>' +
            '<div class="mt__focus-inv"><span>' + INR2.format(n.invested) + '</span><small>invested</small></div>' +
          '</div>';
        }

        // A child row. Full width at every depth -- that is the whole point.
        function mtRowHTML(n) {
          var canOpen = n.directs > 0 && n.depth < MT_MAX_DEPTH;
          return '<button type="button" class="mt__row' + (canOpen ? ' mt__row--open' : '') +
              '" data-id="' + mtEsc(n.id) + '">' +
            '<span class="mt__row-avwrap">' +
              '<img class="mt__row-av" src="' + mtAvatar(n.name) + '" alt=""/>' +
              '<span class="mt__row-dot mt__row-dot--' + (n.active ? 'on' : 'off') + '"></span>' +
            '</span>' +
            '<span class="mt__row-body">' +
              '<span class="mt__row-name">' + mtEsc(n.name) + '</span>' +
              '<span class="mt__row-meta">' + (n.username ? '@' + mtEsc(n.username) : ('L' + n.depth)) +
                (n.directs ? ' \u00b7 ' + n.directs + ' direct' : '') + '</span>' +
            '</span>' +
            '<span class="mt__row-right">' +
              '<span class="mt__row-inv">' + INR2.format(n.invested) + '</span>' +
              (canOpen
                ? '<span class="mt__row-go"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"><polyline points="9 18 15 12 9 6"/></svg></span>'
                : '<span class="mt__row-go mt__row-go--leaf"></span>') +
            '</span>' +
          '</button>';
        }

        function mtRenderGen() {
          var $tree = $$('.mt__tree');
          if (!$tree.length) return;
          var cur = mtCurrent();
          $$('.mt__gen-up').css('display', mtPath.length ? '' : 'none');
          $tree.html(mtCrumbHTML() + mtFocusHTML() +
            '<div class="mt__gen-head"><span class="mt__gen-head-t">Direct Members</span>' +
            '<span class="mt__gen-head-n"></span></div>' +
            '<div class="mt__gen-list">' + mtSpinner('Loading members') + '</div>');

          mtFetchChildren(cur, function (list) {
            var $list = $$('.mt__gen-list');
            if (list == null) {
              $list.html('<div class="mt__tree-load mt__tree-load--err">' +
                (mtTreeSupported === false
                  ? 'Deeper levels are not available yet.'
                  : 'Could not load this line. Tap Back and try again.') + '</div>');
              return;
            }
            $$('.mt__gen-head-n').html(list.length ? (list.length + '') : '');
            if (!cur) $$('.mt__focus-directs').html(list.length + ' direct member' + (list.length === 1 ? '' : 's'));
            $list.html(list.length
              ? list.map(mtRowHTML).join('')
              : '<div class="mt__tree-load">No members introduced yet.</div>');
          });
        }

        function mtDrill(id) {
          var cur = mtCurrent();
          var key = cur ? ('m:' + cur.id) : 'root';
          var kids = mtTreeCache[key] || [];
          for (var i = 0; i < kids.length; i++) {
            if (String(kids[i].id) === String(id)) {
              if (kids[i].depth >= MT_MAX_DEPTH) return;
              mtPath.push(kids[i]);
              mtRenderGen();
              return;
            }
          }
        }
        // idx -1 = back to the root; otherwise keep the path up to and including idx.
        function mtGoTo(idx) {
          if (idx < 0) mtPath = [];
          else mtPath = mtPath.slice(0, idx + 1);
          mtRenderGen();
        }

        $(document).off('click', '.mt__tree .mt__row--open')
          .on('click', '.mt__tree .mt__row--open', function () { mtDrill($(this).attr('data-id')); });
        $(document).off('click', '.mt__tree .mt__crumb')
          .on('click', '.mt__tree .mt__crumb', function () { mtGoTo(parseInt($(this).attr('data-idx'), 10)); });
        $$('.mt__gen-up').off('click').on('click', function () { mtGoTo(mtPath.length - 2); });

        // View switch -- the tree builds lazily on first open, not on page load.
        $$('.mt__view-tab').off('click').on('click', function () {
          var view = $$(this).attr('data-view');
          $$('.mt__view-tab').removeClass('mt__view-tab--on');
          $$(this).addClass('mt__view-tab--on');
          $$('.mt__view--list').css('display', view === 'list' ? '' : 'none');
          $$('.mt__view--tree').css('display', view === 'tree' ? '' : 'none');
          if (view === 'tree' && !$$('.mt__tree').attr('data-ready')) {
            $$('.mt__tree').attr('data-ready', '1');
            mtRenderGen();
          }
        });
        app.methods.getUserData(function (u) {
          if (u && u.name) {
            mtRootName = u.name;
            if ($$('.mt__tree').attr('data-ready') && !mtPath.length) mtRenderGen();
          }
        });
      }
    }
  },
  {
    path: '/returns/',
    component: ReturnPage,
    name: 'returns',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        app.dialog.progress('Loading...');
        //check if logged in or not
        app.methods.getUserData(
          function(data) {
            if(data.isLoggedin == 'true') {
              app.dialog.close();
              function rtEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
              function rtEmpty() {
                $$('.rt__list').html(
                  '<div class="rt__empty">' +
                    '<div class="rt__empty-ico"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg></div>' +
                    '<h3 class="rt__empty-title">No profits yet</h3>' +
                    '<p class="rt__empty-sub">Your daily ROI payouts will appear here once your investment starts earning.</p>' +
                  '</div>');
              }
              var rtAll = [];        // full history
              var rtFilter = 'all';  // all | return | refund
              function rtRowHtml(row) {
                var st = String(row.status);
                var sk = st === '1' ? 'success' : (st === '0' ? 'pending' : 'failed');
                var sl = st === '1' ? 'Success' : (st === '0' ? 'Pending' : 'Failed');
                var isReturn = String(row.type) === '1';
                var title = isReturn ? 'Daily Profit Credited' : 'Principal Refund';
                var ico = isReturn
                  ? '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>'
                  : '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 0 0-4-4H4"/></svg>';
                var amtCls = st === '1' ? 'rt__row-amt' : 'rt__row-amt rt__row-amt--muted';
                return '<div class="rt__row rt__row--' + (isReturn ? 'return' : 'refund') + '">' +
                  '<span class="rt__row-ico rt__row-ico--' + (isReturn ? 'return' : 'refund') + '">' + ico + '</span>' +
                  '<div class="rt__row-body"><div class="rt__row-title">' + title + '</div>' +
                    '<div class="rt__row-meta"><span class="rt__row-ref">' + rtEsc(row.investID) + '</span>' +
                    (row.roi != null && row.roi !== '' ? '<span class="rt__row-roi">' + rtEsc(row.roi) + '% ROI</span>' : '') + '</div></div>' +
                  '<div class="rt__row-right"><div class="' + amtCls + '">' + (st === '1' ? '+' : '') + INR2.format(parseFloat(row.amount) || 0) + '</div>' +
                    '<span class="rt__row-status rt__row-status--' + sk + '"><span class="rt__row-status-dot"></span>' + sl + '</span></div>' +
                '</div>';
              }
              function rtRender() {
                var items = rtAll.filter(function(it) {
                  if (rtFilter === 'return') return String(it.type) === '1';
                  if (rtFilter === 'refund') return String(it.type) !== '1';
                  return true;
                });
                if (!items.length) {
                  $$('.rt__list').html('<div class="rt__empty"><div class="rt__empty-ico"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg></div><h3 class="rt__empty-title">Nothing here</h3><p class="rt__empty-sub">No ' + (rtFilter === 'refund' ? 'refunds' : 'profit payouts') + ' to show in this filter yet.</p></div>');
                  return;
                }
                // group by date (preserving API order)
                var html = '', groups = [], idx = {};
                for (var i = 0; i < items.length; i++) {
                  var item = items[i];
                  var dkey = String(item.date || '').split(' ')[0].split('T')[0] || 'Earlier';
                  if (idx[dkey] === undefined) { idx[dkey] = groups.length; groups.push({ key: dkey, items: [], sum: 0 }); }
                  groups[idx[dkey]].items.push(item);
                  if (String(item.status) === '1') groups[idx[dkey]].sum += parseFloat(item.amount) || 0;
                }
                for (var g = 0; g < groups.length; g++) {
                  var grp = groups[g];
                  html += '<div class="rt__group"><div class="rt__group-date">' + rtEsc(grp.key) +
                    (grp.sum > 0 ? '<span class="rt__group-sum">+' + INR2.format(grp.sum) + '</span>' : '') + '</div>';
                  for (var r = 0; r < grp.items.length; r++) html += rtRowHtml(grp.items[r]);
                  html += '</div>';
                }
                $$('.rt__list').html(html);
              }
              // segmented filter
              $$('.rt__filter').off('click').on('click', function() {
                rtFilter = $$(this).attr('data-rt');
                $$('.rt__filter').removeClass('rt__filter--on');
                $$(this).addClass('rt__filter--on');
                $$('.rt__filters').attr('data-active', rtFilter);
                rtRender();
              });
              //get return history
              $.post(baseURL+"invest.php", {returnHistory:true,token:localStorage.getItem('authToken')}, function() {
                app.dialog.close();
              })
              .done(function(data) {
                app.dialog.close();
                var hist = (data && data.status == 'success') ? data.returnHistory : null;
                if (!hist || !hist.length) { rtEmpty(); return; }
                rtAll = hist;

                // ── summary ──
                var total = 0, payouts = 0, lastDate = '';
                for (var s = 0; s < hist.length; s++) {
                  var it = hist[s];
                  if (String(it.status) === '1' && String(it.type) === '1') { total += parseFloat(it.amount) || 0; payouts++; if (!lastDate) lastDate = it.date; }
                }
                $$('.rt-total').html(INR2.format(total));
                $$('.rt-count').html(payouts);
                // last payout: show just the date portion (first token) to keep it compact
                $$('.rt-last').html(lastDate ? rtEsc(String(lastDate).split(' ')[0].split('T')[0]) : '—');

                rtRender();
              })
              .fail(function() {
                app.dialog.close();
                $$('.rt__list').html('<div class="rt__empty"><h3 class="rt__empty-title">Couldn\'t load profits</h3><p class="rt__empty-sub">Something went wrong. Please pull back and try again.</p></div>');
              });
            } else {
              app.dialog.close();
              app.views.main.router.navigate({name: 'Home'});
            }
        });
      }
    }
  },
  {
    path: '/invest-withdraw/',
    component: InvestWithdrawPage,
    name: 'invest-withdraw',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        // Live plan limits are read from the API, never hard-coded. Withdrawal days and
        // ROI payout days are TWO INDEPENDENT settings — the days money is credited and
        // the days a member may request a payout can differ.
        var wdFeePct = 5, wdMin = 10, wdIsWithdrawDay = true, wdDaysLabel = 'Mon–Fri';
        // Requesting on a non-withdrawal day is rejected server-side; gate the form so
        // the member never hits that error.
        function wdDayGate() {
          if (wdIsWithdrawDay) return false;
          $$('.wd__body').css('display', 'none');
          $$('.wd__gate').css('display', 'block');
          $$('.wd__gate-cta').css('display', 'none');
          $$('.wd__gate-title').html('Withdrawals Closed Today');
          $$('.wd__gate-sub').html(
            'Withdrawal requests are processed on <b>' + wdDaysLabel + '</b> only. ' +
            'Please come back on the next working day — your balance is unaffected.'
          );
          return true;
        }
        if (window.planConfig) {
          window.planConfig.get(function (cfg) {
            wdFeePct = cfg.withdrawFeePct;
            wdMin = cfg.minWithdraw;
            wdDaysLabel = cfg.withdrawDaysLabel;
            wdIsWithdrawDay = window.planConfig.isWithdrawDay();
            $$('input[name="amount"]').attr('min', wdMin);
            $$('.wd-min-amt').html(INR2.format(wdMin));
            $$('.wd-fee-pct').html(wdFeePct + '%');
            $$('.wd__withdraw-days').html(cfg.withdrawDaysLabel);
            $$('.wd__payout-days').html(cfg.payoutDaysLabel);
            // hand the live fee to the component's fee preview
            if (window.wdSetFee) window.wdSetFee(wdFeePct);
            wdDayGate();
          });
        }

        // ── KYC gate: DISABLED for now — withdrawals are allowed without an approved KYC.
        //    `kycBlocked` stays false so the withdrawal flow proceeds. Re-enable the block
        //    below (and the KYC UI in index.html / settings.f7.html) to require KYC again.
        var kycBlocked = false;
        /*
        app.methods.request(baseURL + 'kyc.php', { kycStatus: 1, token: localStorage.getItem('authToken') }, 'json',
          function() {},
          function(res) {
            if (res && res.status === 'success' && res.canWithdraw === true) return; // verified → allow
            kycBlocked = true;
            var st = res ? res.kycStatus : '';
            $$('.wd__body').css('display', 'none');
            $$('.wd__gate').css('display', 'block');
            $$('.wd__gate-cta').attr('href', '/kyc/').css('display', 'inline-flex')
              .html('<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3"><circle cx="12" cy="12" r="9"/><path d="M9 12l2 2 4-4"/></svg> Complete KYC');
            if (st === 'pending') {
              $$('.wd__gate-title').html('KYC Under Review');
              $$('.wd__gate-sub').html('Your identity verification is being reviewed. Withdrawals unlock once it is approved.');
              $$('.wd__gate-cta').css('display', 'none');
            } else if (st === 'rejected') {
              $$('.wd__gate-title').html('KYC Rejected');
              $$('.wd__gate-sub').html('Your KYC was not approved. Please resubmit your documents to enable withdrawals.');
            } else {
              $$('.wd__gate-title').html('Complete KYC to Withdraw');
              $$('.wd__gate-sub').html('Verify your identity to unlock withdrawals — it only takes a minute.');
            }
          },
          function() {}
        );
        */

        // ── Withdrawal method selector (Bank/UPI = India, USDT = Global) ──
        var wdIsIN = false;                 // set once we know the user's country
        var WD_USD_INR_FALLBACK = 95;       // used if live FX is unavailable
        var wdRate = null;                  // cached USD→INR rate
        function wdRenderINR(amount) {
          var rate = wdRate || WD_USD_INR_FALLBACK;
          $$('.wd-usdInrRate').html(rate.toFixed(2));
          $$('.wd-payableINR').html('₹' + (amount * rate).toLocaleString('en-IN', { maximumFractionDigits: 0 }));
        }
        function wdRefreshINR(amount) {
          if (wdRate != null) { wdRenderINR(amount); return; }
          $.getJSON('https://open.er-api.com/v6/latest/USD', function(d) {
            wdRate = (d && d.rates && d.rates.INR) ? d.rates.INR : WD_USD_INR_FALLBACK;
            wdRenderINR(amount);
          }).fail(function() { wdRate = WD_USD_INR_FALLBACK; wdRenderINR(amount); });
        }
        // ── Saved payout accounts (beneficiaries) per method ──
        var wdToken = localStorage.getItem('authToken');
        var wdBenes = { bank: [], upi: [], crypto: [] };   // saved accounts per method
        var wdSel = { bank: '', upi: '', crypto: '' };       // selected beneficiary id per method
        var wdBenesLoaded = false;
        var wdAddNet = 'bep20';                              // network chosen in the crypto add form
        var wdCanWithdraw = false;                           // current source has withdrawable balance
        var wdInvest = [];                                   // active investments (ROI withdrawal)
        // Principal can also be returned from COMPLETED investments (status 2), which are
        // excluded from wdInvest — keep a separate list so the capital stays reachable.
        var wdPrincipalList = [];
        // Principal withdrawal is built and working, but held back in the UI for now —
        // the tab stays disabled on every plan, Silver included. Flip this to true to
        // release it; nothing else needs changing.
        var WD_PRINCIPAL_ENABLED = false;
        var wdSource = 'investment';                         // 'investment' | 'commission'
        var wdCommission = 0;                                // withdrawable network-commission balance
        function wdEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
        var WD_LABEL = { bank:'Bank Account', upi:'UPI ID', crypto:'USDT Wallet' };
        var WD_ICON = {
          bank:'<svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 21 7 3 7"/><line x1="6" y1="10" x2="6" y2="17"/><line x1="10" y1="10" x2="10" y2="17"/><line x1="14" y1="10" x2="14" y2="17"/><line x1="18" y1="10" x2="18" y2="17"/><line x1="4" y1="20" x2="20" y2="20"/></svg>',
          upi:'<svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 10h20"/></svg>',
          crypto:'<svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="7" y1="8.2" x2="17" y2="8.2"/><line x1="12" y1="8.2" x2="12" y2="16.4"/><line x1="9" y1="11.3" x2="15" y2="11.3"/></svg>'
        };
        function wdNorm(d) { return { bank: (d && d.bank) || [], upi: (d && d.upi) || [], crypto: (d && d.crypto) || [] }; }
        function wdBeneTitle(method, b) {
          if (method === 'bank') return wdEsc((b.bankName || 'Bank') + ' · ' + (b.accountNumberMasked || b.accountNumber || ''));
          if (method === 'upi') return wdEsc(b.upiId || '');
          return wdEsc((b.network ? String(b.network).toUpperCase() : 'USDT') + ' · ' + (b.addressMasked || b.address || ''));
        }
        function wdBeneSub(method, b) {
          if (method === 'bank') return wdEsc((b.beneficiaryName || '') + (b.ifsc ? ' · ' + b.ifsc : ''));
          if (method === 'upi') return wdEsc(b.beneficiaryName || 'UPI payout');
          return wdEsc(b.label || 'USDT payout wallet');
        }
        var WD_CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
        var WD_TRASH = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>';
        function wdSyncHidden() {
          var method = $$('#wdMethod').val();
          $$('#wdBeneficiaryID').val(wdSel[method] || '');
          if (method === 'crypto') {
            var b = (wdBenes.crypto || []).filter(function(x){ return String(x.id) === String(wdSel.crypto); })[0];
            $$('#wdNetwork').val(b ? (b.network || '') : '');
          } else { $$('#wdNetwork').val(''); }
        }
        // Returns the first validation error message, or '' when the request is valid.
        function wdValidate() {
          var isComm = (wdSource === 'commission');
          var isPrin = (wdSource === 'principal');
          if (!wdCanWithdraw) {
            if (isComm) return 'You don\'t have enough network commission to withdraw.';
            if (isPrin) return 'The capital for this investment is not available to return right now.';
            return 'This investment has no withdrawable balance right now.';
          }
          if (!isComm && !$$('#investmentSelect').val()) return 'Please select an investment.';
          var amt = parseFloat($$('#amount').val()) || 0;
          var maxA = parseFloat($$('input[name="amount"]').attr('max')) || 0;
          // Principal is all-or-nothing — the server rejects any partial amount.
          if (isPrin) {
            if (!(maxA > 0)) return 'This investment has no principal to return.';
            if (Math.abs(amt - maxA) > 0.005) return 'The principal must be withdrawn in full — ' + INR2.format(maxA) + '.';
            var method0 = $$('#wdMethod').val();
            if (!wdSel[method0]) return 'Please add & select a payout ' + WD_LABEL[method0].toLowerCase() + ' first.';
            return '';
          }
          if (amt < wdMin) return 'Enter an amount of at least ' + INR2.format(wdMin) + '.';
          if (maxA > 0 && amt > maxA) return 'You can withdraw up to ' + INR2.format(maxA) + (isComm ? ' of commission.' : ' from this investment.');
          var method = $$('#wdMethod').val();
          if (!wdSel[method]) return 'Please add & select a payout ' + WD_LABEL[method].toLowerCase() + ' first.';
          return '';
        }
        function wdUpdateSubmit() {
          // Keep the button interactive once an active, withdrawable investment is loaded;
          // every required field is checked on click (wdValidate) so the user always gets feedback.
          $$('.withdrawMoney')[wdCanWithdraw ? 'removeClass' : 'addClass']('disabled');
        }
        var WD_PLUS = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
        function wdAddBtn(method) { return '<button type="button" class="wd__bene-add-btn">' + WD_PLUS + 'Add ' + WD_LABEL[method] + '</button>'; }
        function wdRenderPayout() {
          var method = $$('#wdMethod').val();
          $$('.wd__payout-title').html('Payout ' + WD_LABEL[method]);
          $$('.wd__bene-form-wrap').empty();
          if (!wdBenesLoaded) { $$('.wd__bene-list').html('<div class="wd__bene-empty"><p class="wd__bene-empty-txt">Loading saved accounts…</p></div>'); return; }
          var list = wdBenes[method] || [];
          if (!list.length) {
            $$('.wd__bene-list').html(
              '<div class="wd__bene-empty"><div class="wd__bene-empty-ico">' + WD_ICON[method] + '</div>' +
              '<p class="wd__bene-empty-txt">No saved <b>' + WD_LABEL[method].toLowerCase() + '</b> yet.<br>Add one to withdraw with this method.</p>' +
              wdAddBtn(method) + '</div>');
            wdSyncHidden(); wdUpdateSubmit(); return;
          }
          // ensure a valid selection
          if (!wdSel[method] || !list.some(function(b){ return String(b.id) === String(wdSel[method]); })) {
            var def = list.filter(function(b){ return b.isDefault; })[0] || list[0];
            wdSel[method] = def.id;
          }
          var html = '';
          list.forEach(function(b) {
            var on = String(b.id) === String(wdSel[method]);
            html += '<label class="wd__bene' + (on ? ' wd__bene--on' : '') + '" data-id="' + wdEsc(b.id) + '">' +
              '<input type="radio" class="wd__bene-radio" name="wdBeneSel" value="' + wdEsc(b.id) + '"' + (on ? ' checked' : '') + '>' +
              '<span class="wd__bene-ico">' + WD_ICON[method] + '</span>' +
              '<span class="wd__bene-main"><span class="wd__bene-title">' + wdBeneTitle(method, b) + '</span>' +
              '<span class="wd__bene-sub">' + wdBeneSub(method, b) + '</span></span>' +
              '<span class="wd__bene-check">' + WD_CHECK + '</span>' +
              '<button type="button" class="wd__bene-del" data-id="' + wdEsc(b.id) + '">' + WD_TRASH + '</button>' +
            '</label>';
          });
          html += wdAddBtn(method);
          $$('.wd__bene-list').html(html);
          wdSyncHidden(); wdUpdateSubmit();
        }
        function wdInput(id, label, attrs) { return '<div class="wd__field"><label class="wd__field-lbl">' + label + '</label><div class="wd__input"><input id="' + id + '" autocomplete="off" ' + (attrs||'') + '></div></div>'; }
        function wdOpenAddForm(method) {
          var title = '<p class="wd__bene-form-title">' + WD_ICON[method] + ' New ' + WD_LABEL[method] + '</p>';
          var body = '';
          if (method === 'bank') {
            body = wdInput('wbName', 'Beneficiary Name', 'type="text" placeholder="Full name on the account"') +
              wdInput('wbAccount', 'Account Number', 'type="text" inputmode="numeric" placeholder="Enter account number"') +
              wdInput('wbCAccount', 'Confirm Account Number', 'type="text" inputmode="numeric" placeholder="Re-enter account number"') +
              '<div class="wd__bene-row">' + wdInput('wbIfsc', 'IFSC Code', 'type="text" maxlength="11" style="text-transform:uppercase" placeholder="e.g. HDFC0001234"') + wdInput('wbBank', 'Bank Name', 'type="text" placeholder="Auto-filled from IFSC"') + '</div>';
          } else if (method === 'upi') {
            body = wdInput('wuName', 'Account Holder Name (Optional)', 'type="text" placeholder="Name on the UPI account"') +
              wdInput('wuUpi', 'UPI ID', 'type="text" placeholder="yourname@bank"');
          } else {
            wdAddNet = 'bep20';
            body = '<label class="wd__field-lbl">Network</label><div class="wd__net-tabs wd__net-tabs--sm">' +
              // '<!-- TRC-20 tab hidden — re-enable when TRC-20 is available -->' +
              // '<button type="button" class="wd__net-tab" data-net="trc20">TRC-20 · Tron</button>' +
              '<button type="button" class="wd__net-tab wd__net-tab--on" data-net="bep20">BEP-20 · BSC</button></div>' +
              '<div style="height:13px"></div>' +
              wdInput('wcAddr', 'USDT Wallet Address', 'type="text" placeholder="Paste your USDT wallet address"') +
              wdInput('wcLabel', 'Label (Optional)', 'type="text" placeholder="e.g. Binance, Trust Wallet"');
          }
          var actions = '<div class="wd__bene-form-actions"><button type="button" class="wd__bene-cancel">Cancel</button>' +
            '<button type="button" class="wd__bene-save" data-method="' + method + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><polyline points="20 6 9 17 4 12"/></svg>Save Account</button></div>';
          $$('.wd__bene-add-btn').css('display', 'none');   // hide the Add button while the form is open
          $$('.wd__bene-form-wrap').html('<div class="wd__bene-form">' + title + body + actions + '</div>');
          // Bring the form into view by scrolling ONLY the page-content container.
          // Native element.scrollIntoView() also scrolls the window/viewport, which pushes
          // F7's absolutely-positioned navbar off-screen (looks like the navbar hides).
          var pcEl = $$('.wd__content')[0];
          var fwEl = $$('.wd__bene-form-wrap')[0];
          if (pcEl && fwEl) {
            var delta = fwEl.getBoundingClientRect().top - pcEl.getBoundingClientRect().top;
            var target = Math.max(0, pcEl.scrollTop + delta - 16);
            if (pcEl.scrollTo) { try { pcEl.scrollTo({ top: target, behavior: 'smooth' }); } catch (err) { pcEl.scrollTop = target; } }
            else { pcEl.scrollTop = target; }
          }
          // IFSC autofill for the bank form
          if (method === 'bank') {
            $$('#wbIfsc').off('keyup').on('keyup', function() {
              if (($$(this).val() || '').length === 11) {
                app.preloader.show();
                $.getJSON('https://ifsc.razorpay.com/' + $$(this).val().toUpperCase())
                  .done(function(d) { app.preloader.hide(); if (d && d.BANK) $$('#wbBank').val(d.BANK); })
                  .fail(function() { app.preloader.hide(); app.toast.show({ text: 'Invalid IFSC code!', closeTimeout: 2500 }); });
              }
            });
          }
        }
        function wdSaveBene(method) {
          var p = { addBeneficiary: 1, token: wdToken, method: method };
          if (method === 'bank') {
            var name = ($$('#wbName').val()||'').trim(), acc = ($$('#wbAccount').val()||'').trim(), cacc = ($$('#wbCAccount').val()||'').trim(),
                ifsc = ($$('#wbIfsc').val()||'').trim().toUpperCase(), bank = ($$('#wbBank').val()||'').trim();
            if (!name) return app.toast.show({ text:'Enter the beneficiary name.', closeTimeout:2500 });
            if (!acc) return app.toast.show({ text:'Enter the account number.', closeTimeout:2500 });
            if (acc !== cacc) return app.toast.show({ text:'Account numbers do not match.', closeTimeout:2500 });
            if (ifsc.length !== 11) return app.toast.show({ text:'Enter a valid 11-character IFSC code.', closeTimeout:2500 });
            if (!bank) return app.toast.show({ text:'Enter the bank name.', closeTimeout:2500 });
            p.beneficiaryName = name; p.accountNumber = acc; p.ifsc = ifsc; p.bankName = bank;
          } else if (method === 'upi') {
            var upi = ($$('#wuUpi').val()||'').trim();
            if (!/^[a-zA-Z0-9.\-_]{2,}@[a-zA-Z]{2,}$/.test(upi)) return app.toast.show({ text:'Enter a valid UPI ID (e.g. name@bank).', closeTimeout:2500 });
            p.upiId = upi; p.beneficiaryName = ($$('#wuName').val()||'').trim();
          } else {
            var addr = ($$('#wcAddr').val()||'').trim();
            if (addr.length < 20) return app.toast.show({ text:'Enter a valid USDT wallet address.', closeTimeout:2500 });
            p.network = wdAddNet; p.address = addr; p.label = ($$('#wcLabel').val()||'').trim();
          }
          app.methods.request(baseURL + 'invest.php', p, 'json',
            function() { app.dialog.progress('Saving…'); },
            function(res) {
              app.dialog.close();
              if (res && res.status === 'success') {
                app.toast.show({ text: res.msg || 'Payout account saved.', closeTimeout: 2500 });
                if (res.data && (res.data.bank || res.data.upi || res.data.crypto)) wdBenes = wdNorm(res.data);
                else if (res.beneficiary) { wdBenes[method] = wdBenes[method] || []; wdBenes[method].push(res.beneficiary); }
                wdBenesLoaded = true;
                var nb = res.beneficiary || (wdBenes[method][wdBenes[method].length - 1]);
                if (nb) wdSel[method] = nb.id;
                $$('.wd__bene-form-wrap').empty();
                wdRenderPayout();
              } else { app.toast.show({ text: (res && res.msg) || 'Could not save account.', closeTimeout: 3000 }); }
            },
            function() { app.dialog.close(); app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 }); }
          );
        }
        function wdDeleteBene(method, id) {
          app.dialog.confirm('Remove this saved payout account?', 'Remove Account', function() {
            app.methods.request(baseURL + 'invest.php', { deleteBeneficiary: 1, beneficiaryID: id, token: wdToken }, 'json',
              function() { app.dialog.progress('Removing…'); },
              function(res) {
                app.dialog.close();
                if (res && res.status === 'success') {
                  wdBenes[method] = (wdBenes[method] || []).filter(function(b){ return String(b.id) !== String(id); });
                  if (String(wdSel[method]) === String(id)) wdSel[method] = '';
                  wdRenderPayout();
                } else { app.toast.show({ text: (res && res.msg) || 'Could not remove account.', closeTimeout: 3000 }); }
              },
              function() { app.dialog.close(); app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 }); }
            );
          });
        }
        function wdLoadBenes() {
          app.methods.request(baseURL + 'invest.php', { getBeneficiaries: 1, token: wdToken }, 'json',
            function() {},
            function(res) {
              if (res && res.status === 'success' && res.data) wdBenes = wdNorm(res.data);
              wdBenesLoaded = true;
              wdRenderPayout();
            },
            function() { wdBenesLoaded = true; wdRenderPayout(); }
          );
        }
        function wdSelectMethod(method) {
          $$('.wd__method').removeClass('wd__method--on');
          $$('.wd__method[data-method="'+method+'"]').addClass('wd__method--on');
          $$('#wdMethod').val(method);
          // INR conversion only for India users withdrawing via Bank or UPI
          if (wdIsIN && (method === 'bank' || method === 'upi')) {
            $$('.wd__inr').css('display', '');
            wdRefreshINR(parseFloat($$('#amount').val()) || 0);
          } else {
            $$('.wd__inr').css('display', 'none');
          }
          wdRenderPayout();
        }
        function wdOnAmount() {
          var m = $$('#wdMethod').val();
          if (wdIsIN && (m === 'bank' || m === 'upi')) wdRefreshINR(parseFloat($$('#amount').val()) || 0);
          wdUpdateSubmit();
        }
        $$('.wd__method').off('click').on('click', function() { wdSelectMethod($$(this).attr('data-method')); });
        $$('#amount').off('input').on('input', wdOnAmount);
        $$('.wd__amount-max').off('click').on('click', function() {
          var mx = parseFloat($$('input[name="amount"]').attr('max')) || 0;
          if (mx > 0) {
            $$('#amount').val(mx);
            wdOnAmount();
            $$('#amount')[0].dispatchEvent(new Event('input'));
          }
        });
        // ── payout account interactions (cards/buttons are re-rendered → delegate via jQuery) ──
        $(document).off('click', '.wd__bene-add-btn').on('click', '.wd__bene-add-btn', function() { wdOpenAddForm($$('#wdMethod').val()); });
        $(document).off('click', '.wd__bene-del').on('click', '.wd__bene-del', function(e) {
          e.preventDefault(); e.stopPropagation();
          wdDeleteBene($$('#wdMethod').val(), $(this).attr('data-id'));
        });
        $(document).off('click', '.wd__bene').on('click', '.wd__bene', function(e) {
          if ($(e.target).closest('.wd__bene-del').length) return; // ignore delete taps
          var method = $$('#wdMethod').val();
          wdSel[method] = $(this).attr('data-id');
          $('.wd__bene').removeClass('wd__bene--on');
          $(this).addClass('wd__bene--on');
          wdSyncHidden(); wdUpdateSubmit();
        });
        $(document).off('click', '.wd__bene-cancel').on('click', '.wd__bene-cancel', function() { wdRenderPayout(); });
        $(document).off('click', '.wd__bene-save').on('click', '.wd__bene-save', function() { wdSaveBene($(this).attr('data-method')); });
        $(document).off('click', '.wd__bene-form .wd__net-tab').on('click', '.wd__bene-form .wd__net-tab', function() {
          $('.wd__bene-form .wd__net-tab').removeClass('wd__net-tab--on');
          $(this).addClass('wd__net-tab--on');
          wdAddNet = $(this).attr('data-net') || 'bep20';
        });

        // ── Bank/UPI gating DISABLED — only Crypto (BEP-20) is available for now.
        // Re-enable the IN gating and bank/upi default when Bank/UPI withdrawals are restored.
        app.methods.getUserData(function(u) {
          var isIN = (String((u && u.country) || localStorage.getItem('country') || '').toUpperCase() === 'IN');
          wdIsIN = isIN;
          // $$('.wd__method[data-scope="IN"]').css('display', isIN ? '' : 'none');
          // wdSelectMethod(isIN ? 'bank' : 'crypto');
          wdSelectMethod('crypto');
        });

        app.dialog.progress('Loading...');
        function wdShowNothing() {
          $$('.wd__body').css('display', 'none');
          $$('.wd__gate').css('display', 'block');
          $$('.wd__gate-title').html('Nothing to Withdraw');
          $$('.wd__gate-sub').html('You don\'t have a withdrawable investment balance or network commission yet. Start an investment and grow your team to earn.');
          $$('.wd__gate-cta').css('display', 'inline-flex');
        }
        function wdApplyInvestment(item) {
          var maxW = parseFloat(item.maxWithdrawal); if (isNaN(maxW)) maxW = 0;
          var limit = parseFloat(item.withdrawalLimit); if (isNaN(limit)) limit = maxW;
          var balance = maxW > 0 ? maxW : limit;
          $$('.wallet--amount').html(INR2.format(balance));
          $$('input[name="amount"]').attr('max', maxW);
          $$('input[name="wallet"]').val(isNaN(parseFloat(item.withdrawalLimit)) ? maxW : item.withdrawalLimit);
          // Plan 2.0: `canWithdrawRoi` already combines the plan rule (roiWithdrawable)
          // with cycle completion — prefer it over evaluating the plan rule ourselves.
          // `isWeekend` is deprecated and no longer gates anything.
          var planLocked = (item.canWithdrawRoi === false);
          var planNm = item.planName || item.planCode || 'this plan';
          var capLbl = !isNaN(parseFloat(item.capMultiple)) ? (parseFloat(parseFloat(item.capMultiple).toFixed(2)) + '×') : 'its';
          // The row's own isWithdrawDay is authoritative when it disagrees with the
          // cached schedule (e.g. an admin changed the days mid-session).
          if (item.isWithdrawDay === false) {
            wdCanWithdraw = false;
            $$('.w-timetxt').html('');
            $$('.wd-balST').css('color', '').html('Withdrawal requests are accepted on <b>' + wdDaysLabel + '</b> only.');
            wdUpdateSubmit();
            return;
          }
          if (planLocked) {
            wdCanWithdraw = false;
            $$('.w-timetxt').html('');
            $$('.wd-balST').css('color', '').html(
              'On the <b>' + planNm + '</b>, returns stay locked until the investment completes its ' +
              capLbl + ' cycle. ROI and principal are released together at that point.'
            );
          } else if (+item.maxWithdrawal >= wdMin) {
            wdCanWithdraw = true;
            $$('.w-timetxt').html('');
            $$('.wd-balST').css('color', '#dfc288').html('You can withdraw up to ' + INR2.format(item.maxWithdrawal) + ' from this investment.');
          } else {
            wdCanWithdraw = false;
            $$('.w-timetxt').html('');
            $$('.wd-balST').css('color', '').html('This investment has no withdrawable balance yet (minimum ' + INR2.format(wdMin) + ').');
          }
          wdUpdateSubmit();
        }
        function wdPickInvestment(id) {
          var item = wdInvest.filter(function(x){ return String(x.investID) === String(id); })[0];
          if (item) wdApplyInvestment(item);
        }
        // ── Principal (capital return) ─────────────────────────────────────────
        // A separate flow from ROI withdrawal: `wallet` holds accrued ROI only, the
        // principal is not part of it. Full amount only — a partial value is rejected.
        function wdPrincipalOf(id) {
          return wdPrincipalList.filter(function (x) { return String(x.investID) === String(id); })[0] || null;
        }
        function wdApplyPrincipal() {
          var item = wdPrincipalOf($$('#investmentSelect').val());
          var amt = item ? (parseFloat(item.principalAmount) || 0) : 0;
          var feePct = item ? (parseFloat(item.principalFeePct) || 0) : 0;
          var fee = item ? (parseFloat(item.principalFee) || 0) : 0;

          $$('.wallet--amount').html(INR2.format(amt));
          $$('.wd-prin-amount').html(INR2.format(amt));
          $$('input[name="amount"]').attr('max', amt);
          $$('input[name="wallet"]').val(amt);
          // The amount is fixed — prefill it and keep the member from editing it.
          $$('#amount').val(amt > 0 ? amt : '');
          $$('.w-timetxt').html('');

          if (fee > 0 || feePct > 0) {
            $$('.wd-prin-fee-row').css('display', 'flex');
            $$('.wd-prin-feepct').html(feePct > 0 ? ('(' + feePct + '%)') : '');
            $$('.wd-prin-fee').html('−' + INR2.format(fee));
          } else {
            $$('.wd-prin-fee-row').css('display', 'none');
          }

          if (!item) {
            wdCanWithdraw = false;
            $$('.wd-balST').css('color', '').html('Select an investment to return its capital.');
          } else if (item.principalWithdrawn === true) {
            wdCanWithdraw = false;
            $$('.wd-prin-note').addClass('wd__prin-note--warn')
              .html('The principal for this investment has already been withdrawn or is awaiting approval.');
            $$('.wd-balST').css('color', '').html('This investment\'s capital has already been requested.');
          } else if (item.canWithdrawPrincipal === false) {
            wdCanWithdraw = false;
            var pNm = item.planName || item.planCode || 'this plan';
            var pCap = !isNaN(parseFloat(item.capMultiple)) ? (parseFloat(parseFloat(item.capMultiple).toFixed(2)) + '×') : 'its';
            $$('.wd-prin-note').addClass('wd__prin-note--warn')
              .html('On the <b>' + pNm + '</b>, the principal stays locked until the investment completes its ' + pCap + ' return cycle.');
            $$('.wd-balST').css('color', '').html('Capital is locked until this investment completes.');
          } else {
            wdCanWithdraw = true;
            var warn = fee > 0
              ? 'The principal must be withdrawn in full. An early-exit charge of <b>' + INR2.format(fee) +
                '</b> applies because the return cycle has not completed — this is not recoverable.'
              : 'The principal must be withdrawn in full. Returning your capital ends this investment\'s earnings.';
            $$('.wd-prin-note')[fee > 0 ? 'addClass' : 'removeClass']('wd__prin-note--warn').html(warn);
            $$('.wd-balST').css('color', '#dfc288').html('You can return ' + INR2.format(amt) + ' of capital from this investment.');
          }
          wdUpdateSubmit();
        }
        function wdApplyCommission() {
          var bal = wdCommission;
          $$('.wallet--amount').html(INR2.format(bal));
          $$('input[name="amount"]').attr('max', bal);
          $$('input[name="wallet"]').val(bal);
          $$('.wd-commission-bal').html(INR2.format(bal));
          $$('.w-timetxt').html('');
          if (bal >= wdMin) {
            wdCanWithdraw = true;
            $$('.wd-balST').css('color', '#dfc288').html('You can withdraw up to ' + INR2.format(bal) + ' of network commission.');
          } else {
            wdCanWithdraw = false;
            $$('.wd-balST').css('color', '').html('You need at least ' + INR2.format(wdMin) + ' in commission to withdraw.');
          }
          wdUpdateSubmit();
        }
        // The two investment sources have different eligible sets — ROI comes from active
        // investments, principal from any investment whose capital is released (including
        // completed ones) — so the dropdown is rebuilt whenever the source changes.
        function wdFillInvestSelect(list, labelValue) {
          var $sel = $$('#investmentSelect');
          $sel.empty();
          list.forEach(function(item) {
            $sel.append('<option value="' + item.investID + '">' + item.investID + ' · ' + INR.format(labelValue(item)) + '</option>');
          });
          if ($.fn && $.fn.select2 && $('#investmentSelect').data('select2')) {
            $('#investmentSelect').trigger('change.select2');
          }
        }
        function wdApplySource() {
          $$('#wdType').val(wdSource);
          // Principal is a fixed, full-amount return — lock the amount field for it.
          var isPrin = (wdSource === 'principal');
          $$('.wd__inv-field').css('display', wdSource === 'commission' ? 'none' : '');
          $$('.wd__comm-field').css('display', wdSource === 'commission' ? '' : 'none');
          $$('.wd__prin-field').css('display', isPrin ? '' : 'none');
          $$('#amount').prop('readonly', isPrin);
          $$('.wd__amount-max').css('display', isPrin ? 'none' : '');
          $$('.wd-prin-note').removeClass('wd__prin-note--warn');

          if (wdSource === 'commission') {
            wdApplyCommission();
          } else if (isPrin) {
            wdFillInvestSelect(wdPrincipalList, function(it){ return parseFloat(it.principalAmount) || 0; });
            wdApplyPrincipal();
          } else {
            wdFillInvestSelect(wdInvest, function(it){ return it.wallet; });
            wdPickInvestment($$('#investmentSelect').val());
          }

          var m = $$('#wdMethod').val();
          if (wdIsIN && (m === 'bank' || m === 'upi')) wdRefreshINR(parseFloat($$('#amount').val()) || 0);
        }
        $$('.wd__src-tab').off('click').on('click', function() {
          if ($$(this).hasClass('wd__src-tab--disabled')) return;
          if ($$(this).hasClass('wd__src-tab--on')) return; // already active
          wdSource = $$(this).attr('data-src');
          $$('.wd__src-tab').removeClass('wd__src-tab--on');
          $$(this).addClass('wd__src-tab--on');
          $$('#amount').val('');   // reset the entered amount when switching source
          wdApplySource();
        });
        // Network-commission balance lives in earning.php (NOT invest.php)
        function wdLoadCommission(cb) {
          app.methods.request(baseURL + 'earning.php', { getEarnings: true, token: wdToken }, 'json',
            function() {},
            function(res) {
              var d = (res && res.data) || {};
              // currentCommBal = withdrawable commission balance (NOT totalCommission, which is lifetime earned)
              var c = parseFloat(d.currentCommBal);
              if (isNaN(c)) c = parseFloat(d.commissionBalance);
              if (isNaN(c)) c = 0;
              wdCommission = c;
              $$('.wd-commission-bal').html(INR2.format(wdCommission));
              if (cb) cb();
            },
            function() { if (cb) cb(); }
          );
        }
        //get subscription details + commission balance, then render
        app.methods.getUserDataInvest(function(data) {
          if (kycBlocked) { app.dialog.close(); return; } // KYC gate takes precedence
          var wdAll = (data && data.status == 'success') ? (data.data || []) : [];
          wdInvest = wdAll.filter(function(it){ return String(it.status) === '1'; });
          // A completed investment (status 2) still has capital to return.
          wdPrincipalList = wdAll.filter(function(it){
            return it.canWithdrawPrincipal === true && it.principalWithdrawn !== true;
          });
          wdLoadCommission(function() {
            app.dialog.close();
            var hasInv = wdInvest.length > 0;
            var hasComm = wdCommission >= wdMin;
            var hasPrin = WD_PRINCIPAL_ENABLED && wdPrincipalList.length > 0;
            if (!hasInv && !hasComm && !hasPrin) { wdShowNothing(); return; }
            // A closed withdrawal day outranks everything below it.
            if (wdDayGate()) return;
            $$('.wd__body').css('display', 'block');
            $$('.wd__gate').css('display', 'none');
            $$('.wd-commission-bal').html(INR2.format(wdCommission));
            if (hasInv || hasPrin) {
              $('#investmentSelect').select2({ minimumResultsForSearch: -1 });
              $('#investmentSelect').off('change.wd').on('change.wd', function() {
                if (wdSource === 'principal') wdApplyPrincipal();
                else wdPickInvestment($$('#investmentSelect').val());
              });
            }
            // Each tab is offered only when it has something to act on.
            $$('.wd__src-tab[data-src="investment"]')[hasInv ? 'removeClass' : 'addClass']('wd__src-tab--disabled');
            $$('.wd__src-tab[data-src="principal"]')[hasPrin ? 'removeClass' : 'addClass']('wd__src-tab--disabled');
            $$('.wd__src-tab[data-src="commission"]')[hasComm ? 'removeClass' : 'addClass']('wd__src-tab--disabled');
            // default to whichever source is available (never principal while it's held back)
            wdSource = hasInv ? 'investment' : (hasComm ? 'commission' : (hasPrin ? 'principal' : 'investment'));
            $$('.wd__src-tab').removeClass('wd__src-tab--on');
            $$('.wd__src-tab[data-src="' + wdSource + '"]').addClass('wd__src-tab--on');
            wdApplySource();
            wdLoadBenes();   // load saved payout accounts for all methods
          });
        });
        //submit withdrawal request
        $$('.withdrawMoney').off('click').on('click', function() {
          if ($$(this).hasClass('disabled')) return;
          var err = wdValidate();
          if (err) { app.toast.show({ text: err, closeTimeout: 3000 }); return; }
          wdSyncHidden();
          // Returning capital ends the investment's earnings and any early-exit charge
          // is not recoverable — always confirm before submitting.
          if (wdSource === 'principal') {
            var pItem = wdPrincipalOf($$('#investmentSelect').val());
            var pAmt = pItem ? (parseFloat(pItem.principalAmount) || 0) : 0;
            var pFee = pItem ? (parseFloat(pItem.principalFee) || 0) : 0;
            var body = 'You are returning <b>' + INR2.format(pAmt) + '</b> of capital.<br><br>' +
              (pFee > 0
                ? 'An early-exit charge of <b>' + INR2.format(pFee) + '</b> applies because the return cycle has not completed. This charge is not recoverable.<br><br>'
                : '') +
              'This ends the investment\'s earnings and cannot be undone. Continue?';
            app.dialog.confirm(body, 'Return Your Capital?', function () { withdrawMoney(); });
            return;
          }
          withdrawMoney();
        });
        function withdrawMoney() {
          var formdata = $('#investWithFrm').serialize();
          var data = formdata+'&withdrawRequest=true&token='+localStorage.getItem('authToken');
          // Bank/UPI payouts settle in INR — send the FX rate and the INR amount alongside
          var wMethod = $$('#wdMethod').val();
          if (wMethod === 'bank' || wMethod === 'upi') {
            var rate = wdRate || WD_USD_INR_FALLBACK;
            var amt = parseFloat($$('#amount').val()) || 0;
            data += '&usdToInrRate=' + rate.toFixed(2) + '&amountInInr=' + (amt * rate).toFixed(2);
          }
          app.methods.request(
            baseURL+'invest.php',
            data,
            'json',
            function() { app.dialog.progress('Loading...'); $$('.button').addClass('disabled'); },
            function(data) {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              if(data.status == 'success') {
                app.popup.open('.sheet-loan--applied');
                var isPrinReq = (wdSource === 'principal');
                $$('.sheet-loan--applied__title').html(
                  INR2.format(data.amount) + (isPrinReq ? ' Capital Return Requested!' : ' Withdrawal Requested!')
                );
                // The server returns the combined fee plus the early-exit portion of it —
                // show the breakdown so the net figure is never a surprise.
                var netTxt = '';
                if (data.netAmount != null) {
                  netTxt = '<br><br>You will receive <b>' + INR2.format(data.netAmount) + '</b>' +
                    (data.fee != null ? ' after ' + INR2.format(data.fee) + ' in fees' : '') +
                    (parseFloat(data.earlyExitFee) > 0 ? ' (including an early-exit charge of ' + INR2.format(data.earlyExitFee) + ')' : '') + '.';
                }
                $$('.sheet-loan--applied__text').html(
                  (data.msg || 'Your withdrawal will be sent to your selected destination once we verify the request.') + netTxt
                );
                var view = app.views.current;
                view.router.navigate('/transaction/investment/'); // redirect to transaction history
              }
              else if (data.code === 'locked') {
                // Plan 2.0: an informational state (e.g. Diamond mid-cycle), not a failure —
                // the returns exist, they are simply not released until the cycle completes.
                app.dialog.alert(data.msg, 'Returns Locked');
                $$('.wd-balST').css('color', '').html(data.msg);
                wdCanWithdraw = false;
                wdUpdateSubmit();
              }
              else {
                app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
              }
            },
            function() {
              $$('.button').removeClass('disabled');
              app.dialog.close();
              app.toast.show({
                text: 'No internet connection!',
                closeTimeout: 3000,
              });
            }
          );
        }
      }
    }
  },
  {
    path: '/kyc/',
    component: KycPage,
    name: 'kyc',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        var token = localStorage.getItem('authToken');
        var DOC_LABELS = { national_id:'National ID', passport:'Passport', driving_license:'Driving License', residence_permit:'Residence Permit', voter_id:'Voter ID', ssn:'SSN', other:'Other' };
        function kEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

        function statusBanner(state, remarks) {
          var tick = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2"><polyline points="20 6 9 17 4 12"/></svg>';
          var meta = {
            approved: { cls:'approved',
              ico:'<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
              badge:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>',
              t:'Identity Verified', s:'Your identity is verified. Withdrawals are now enabled on your account.',
              steps:['done','done','done'] },
            pending: { cls:'pending',
              ico:'<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>',
              badge:'<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><circle cx="12" cy="12" r="9"/><polyline points="12 8 12 12 15 14"/></svg>',
              t:'Under Review', s:'Your documents are being reviewed. This usually takes 24–48 hours — we\'ll notify you once done.',
              steps:['done','active','pending'] },
            rejected: { cls:'rejected',
              ico:'<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="12" r="9"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>',
              badge:'<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
              t:'Verification Failed', s:'Your submission was not approved. Please review the reason below and resubmit your documents.',
              steps:['error','pending','pending'] },
            none: { cls:'none',
              ico:'<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
              badge:'<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
              t:'Verify Your Identity', s:'Complete a quick verification to unlock withdrawals. It only takes a minute.',
              steps:['active','pending','pending'] }
          };
          var m = meta[state] || meta.none;
          var labels = ['Submit', 'Review', 'Verified'];
          var nums = ['1', '2', tick];
          var steps = '';
          for (var i = 0; i < 3; i++) {
            var ss = m.steps[i];
            var inner = ss === 'done' ? tick : (ss === 'error' ? '!' : nums[i]);
            steps += '<div class="kyc__step kyc__step--' + ss + '"><span class="kyc__step-dot">' + inner + '</span><span class="kyc__step-lbl">' + labels[i] + '</span></div>';
          }
          var remarkHtml = (state === 'rejected' && remarks)
            ? '<div class="kyc__remark"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="13"/><circle cx="12" cy="16" r="1" fill="currentColor" stroke="none"/></svg><span><b>Reason for rejection</b>' + kEsc(remarks) + '</span></div>'
            : '';
          $$('.kyc__status').html(
            '<div class="kyc__hero kyc__hero--' + m.cls + '">' +
              '<span class="kyc__hero-glow"></span>' +
              '<div class="kyc__hero-ico">' + m.ico + '<span class="kyc__hero-badge">' + m.badge + '</span></div>' +
              '<h2 class="kyc__hero-title">' + m.t + '</h2>' +
              '<p class="kyc__hero-sub">' + m.s + '</p>' +
              '<div class="kyc__steps">' + steps + '</div>' +
              remarkHtml +
            '</div>');
        }
        function upload(id, sideLabel) {
          return '<div class="kyc__upload"><label class="kyc__upload-box">' +
            '<input type="file" id="' + id + '" accept="image/*,.pdf" style="display:none;">' +
            (sideLabel ? '<span class="kyc__upload-side">' + sideLabel + '</span>' : '') +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>' +
            '<span class="kyc__upload-txt">Tap to upload</span><span class="kyc__upload-name"></span></label></div>';
        }
        function typeSelect(id, types) {
          var opts = (types || []).map(function(t){ return '<option value="' + t + '">' + (DOC_LABELS[t] || t) + '</option>'; }).join('');
          return '<div class="kyc__field"><label class="kyc__label">Document Type</label><div class="kyc__select-wrap"><select class="kyc__select" id="' + id + '">' + opts + '</select><svg class="kyc__select-chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="6 9 12 15 18 9"/></svg></div></div>';
        }
        function docCard(slot, req, isIN) {
          var sides = req.sides || 1;
          var html = '<div class="kyc__doc"><div class="kyc__doc-head"><span class="kyc__doc-ico"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M15 8h3M15 13h3M7 16h10"/></svg></span>' +
            '<span class="kyc__doc-title">' + kEsc(req.label) + '</span>' + (req.required ? '<span class="kyc__doc-req">Required</span>' : '<span class="kyc__doc-opt">Optional</span>') + '</div>';
          if (!isIN && req.types) html += typeSelect(slot + 'Type', req.types);
          html += '<div class="kyc__field"><label class="kyc__label">' + kEsc(req.numberLabel || 'Document Number') + '</label><input type="text" class="kyc__input" id="' + slot + 'Number" placeholder="Enter ' + kEsc(req.numberLabel || 'number') + '" autocomplete="off"></div>';
          html += '<div class="kyc__uploads">' + upload(slot + 'Front', sides > 1 ? 'Front' : '') + (sides > 1 ? upload(slot + 'Back', 'Back') : '') + '</div>';
          return html + '</div>';
        }
        function bindUploads() {
          $$('.kyc__upload-box input[type="file"]').off('change').on('change', function() {
            var box = $$(this).parent();
            var f = this.files && this.files[0];
            if (!f) return;
            box.addClass('has-file');
            box.find('.kyc__upload-txt').html(f.type === 'application/pdf' ? 'PDF ready ✓' : 'Selected ✓');
            box.find('.kyc__upload-name').html(f.name.length > 16 ? f.name.slice(0, 14) + '…' : f.name);
          });
        }
        function bindSubmit(d) {
          $$('.kycSubmit').off('click').on('click', function() {
            var isIN = (String(d.country).toUpperCase() === 'IN');
            var name = ($$('#kycFullName').val() || '').trim();
            if (!name) { app.toast.show({ text: 'Please enter your full name.', closeTimeout: 2500 }); return; }
            var d1num = ($$('#doc1Number').val() || '').trim();
            if (!d1num) { app.toast.show({ text: 'Please enter your document number.', closeTimeout: 2500 }); return; }
            var d1f = $$('#doc1Front')[0];
            if (!d1f || !d1f.files[0]) { app.toast.show({ text: 'Please upload the front of your primary document.', closeTimeout: 2500 }); return; }
            var fd = new FormData();
            fd.append('submitKyc', true); fd.append('token', token); fd.append('fullName', name);
            fd.append('doc1Number', d1num);
            if (!isIN && $$('#doc1Type').length) fd.append('doc1Type', $$('#doc1Type').val() || '');
            fd.append('doc1Front', d1f.files[0]);
            var d1b = $$('#doc1Back')[0]; if (d1b && d1b.files[0]) fd.append('doc1Back', d1b.files[0]);
            // secondary document
            if ($$('#doc2Number').length) {
              var d2num = ($$('#doc2Number').val() || '').trim();
              var d2fEl = $$('#doc2Front')[0]; var d2file = d2fEl && d2fEl.files[0];
              var req2 = !!(d.requirement && d.requirement.doc2 && d.requirement.doc2.required);
              if (isIN || req2) {
                if (!d2num) { app.toast.show({ text: 'Please enter your secondary document number.', closeTimeout: 2500 }); return; }
                if (!d2file) { app.toast.show({ text: 'Please upload your secondary document.', closeTimeout: 2500 }); return; }
              }
              if (d2num) fd.append('doc2Number', d2num);
              if (!isIN && $$('#doc2Type').length) fd.append('doc2Type', $$('#doc2Type').val() || '');
              if (d2file) fd.append('doc2Front', d2file);
              var d2b = $$('#doc2Back')[0]; if (d2b && d2b.files[0]) fd.append('doc2Back', d2b.files[0]);
            }
            app.methods.post(baseURL + 'kyc.php', fd, 'json',
              function() { app.dialog.progress('Submitting…'); $$('.kycSubmit').addClass('disabled'); },
              function(res) {
                app.dialog.close(); $$('.kycSubmit').removeClass('disabled');
                if (res && res.status == 'success') { app.toast.show({ text: res.msg || 'KYC submitted.', closeTimeout: 3000 }); load(); }
                else { app.toast.show({ text: (res && res.msg) || 'Submission failed.', closeTimeout: 3500 }); }
              },
              function() { app.dialog.close(); $$('.kycSubmit').removeClass('disabled'); app.toast.show({ text: 'No internet connection!', closeTimeout: 3000 }); }
            );
          });
        }
        function renderForm(d) {
          var isIN = (String(d.country).toUpperCase() === 'IN');
          var req = d.requirement || {};
          var html = '<div class="kyc__sec-title">Identity Details</div>' +
            '<div class="kyc__field"><label class="kyc__label">Full Name (as on document)</label><input type="text" class="kyc__input" id="kycFullName" placeholder="Your full legal name" autocomplete="off"></div>' +
            (req.doc1 ? docCard('doc1', req.doc1, isIN) : '') +
            (req.doc2 ? docCard('doc2', req.doc2, isIN) : '') +
            '<div class="kyc__note"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="11"/><circle cx="12" cy="8" r="1" fill="currentColor" stroke="none"/></svg><span>Upload clear, full-frame photos of your document(s). Accepted formats: <b>JPG, PNG, WEBP, PDF</b>. Make sure every detail is readable.</span></div>' +
            '<button type="button" class="kyc__submit kycSubmit"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>Submit for Verification</button>' +
            '<div class="kyc__secure"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Your documents are encrypted and used only for verification</div>';
          $$('.kyc__body').html(html);
          if (d.submission && d.submission.fullName) $$('#kycFullName').val(d.submission.fullName);
          bindUploads(); bindSubmit(d);
        }
        function thumb(label, url) {
          if (!url) return '';
          var isPdf = /\.pdf($|\?)/i.test(url);
          var inner = isPdf ? '<div class="kyc__sub-pdf"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></div>' : '<img src="' + url + '" alt="">';
          return '<div class="kyc__sub-thumb"><a href="' + url + '" class="external" target="_system">' + inner + '</a><div class="kyc__sub-thumb-lbl">' + label + '</div></div>';
        }
        function renderSubmitted(d) {
          var s = d.submission || {};
          function docBlock(title, doc) {
            if (!doc) return '';
            var thumbs = thumb('Front', doc.front) + thumb('Back', doc.back);
            return '<div class="kyc__sec-title">' + title + '</div><div class="kyc__sub-card">' +
              (doc.type ? '<div class="kyc__sub-row"><span class="kyc__sub-lbl">Type</span><span class="kyc__sub-val">' + (DOC_LABELS[doc.type] || doc.type) + '</span></div>' : '') +
              (doc.number ? '<div class="kyc__sub-row"><span class="kyc__sub-lbl">Number</span><span class="kyc__sub-val">' + kEsc(doc.number) + '</span></div>' : '') +
              (thumbs ? '<div class="kyc__sub-thumbs">' + thumbs + '</div>' : '') + '</div>';
          }
          $$('.kyc__body').html('<div class="kyc__sec-title">Submitted Details</div><div class="kyc__sub-card">' +
            '<div class="kyc__sub-row"><span class="kyc__sub-lbl">Full Name</span><span class="kyc__sub-val">' + kEsc(s.fullName || '—') + '</span></div>' +
            (s.submittedAt ? '<div class="kyc__sub-row"><span class="kyc__sub-lbl">Submitted</span><span class="kyc__sub-val">' + kEsc(s.submittedAt) + '</span></div>' : '') +
            (s.reviewedAt ? '<div class="kyc__sub-row"><span class="kyc__sub-lbl">Reviewed</span><span class="kyc__sub-val">' + kEsc(s.reviewedAt) + '</span></div>' : '') + '</div>' +
            docBlock('Primary Document', s.doc1) +
            ((s.doc2 && (s.doc2.number || s.doc2.front)) ? docBlock('Secondary Document', s.doc2) : ''));
        }
        function load() {
          $$('.kyc__status').html('<div class="kyc__loading">Loading your KYC status…</div>');
          $$('.kyc__body').html('');
          app.methods.request(baseURL + 'kyc.php', { kycStatus: 1, token: token }, 'json',
            function() {},
            function(res) {
              if (!res || res.status !== 'success') { $$('.kyc__status').html('<div class="kyc__loading">Couldn\'t load KYC status.</div>'); return; }
              var state = res.kycStatus || 'not_submitted';
              statusBanner(state === 'not_submitted' ? 'none' : state, res.remarks);
              if (state === 'approved' || state === 'pending') renderSubmitted(res);
              else renderForm(res);
            },
            function() { $$('.kyc__status').html('<div class="kyc__loading">No internet connection.</div>'); }
          );
        }
        app.dialog.progress('Loading...');
        app.methods.getUserData(function(u) {
          app.dialog.close();
          if (u.isLoggedin != 'true') { app.views.main.router.navigate({ name: 'Home' }); return; }
          load();
        });
      }
    }
  },
  {
    path: '/pin/',
    component: PinPage,
    name: 'pin',
    on: {
      pageInit: function(e, page) {
        var app = this.app;
        function esc(s) {
          return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
            return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
          });
        }
        // require login
        app.methods.getUserData(function(data) {
          if (data.isLoggedin != 'true') {
            app.views.main.router.navigate({ name: 'Home' });
            return;
          }
          loadPins();
        });
        function loadPins() {
          app.methods.request(
            baseURL + 'pin.php',
            { getPins: true, token: localStorage.getItem('authToken') },
            'json',
            function() {
              $$('.pin__list').html('<div class="pin__loading">Loading your PINs…</div>');
            },
            function(data) {
              renderPins(data);
            },
            function() {
              $$('.pin__list').html('<div class="pin__loading">Couldn\'t load your PINs. Please check your connection and try again.</div>');
            }
          );
        }
        function renderPins(data) {
          var pins = (data && data.status == 'success' && data.pins) ? data.pins : (data && data.pins ? data.pins : []);
          if (!Array.isArray(pins)) pins = [];
          var total = pins.length, active = 0, redeemed = 0, html = '';
          for (var i = 0; i < pins.length; i++) {
            var p = pins[i];
            var code = p.pin || p.code || p.pinCode || '';
            var isRedeemed = (p.status == 'redeemed') || (p.isRedeemed == '1' || p.isRedeemed === true) ||
                             (!!(p.redeemedBy || p.redeemedByName || p.redeemerName || p.usedBy));
            var redeemer = p.redeemedBy || p.redeemedByName || p.redeemerName || p.usedBy || '';
            var amount = (p.amount != null && p.amount !== '') ? INR2.format(p.amount) : '';
            if (isRedeemed) redeemed++; else active++;
            html +=
              '<div class="pin__card ' + (isRedeemed ? 'pin__card--redeemed' : 'pin__card--active') + '" data-status="' + (isRedeemed ? 'redeemed' : 'active') + '">' +
                '<div class="pin__card-head">' +
                  '<span class="pin__status pin__status--' + (isRedeemed ? 'redeemed' : 'active') + '">' +
                    '<span class="pin__status-dot"></span>' + (isRedeemed ? 'Redeemed' : 'Active') + '</span>' +
                    (amount ? '<span class="pin__amount">' + amount + '</span>' : '') +
                '</div>' +
                '<div class="pin__code-box">' +
                  '<span class="pin__code-label">PIN</span>' +
                  '<span class="pin__code">' + esc(code) + '</span>' +
                  '<button type="button" class="pin__copy" data-pin="' + esc(code) + '" aria-label="Copy PIN">' +
                    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>' +
                  '</button>' +
                '</div>' +
                ((isRedeemed && redeemer) ?
                  '<div class="pin__redeemed-by">' +
                    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>' +
                    'Redeemed by <b>' + esc(redeemer) + '</b>' +
                  '</div>' : '') +
              '</div>';
          }
          $$('.pin__total').html(total);
          $$('.pin__active').html(active);
          $$('.pin__redeemed').html(redeemed);
          $$('.pin__filter-count[data-count="all"]').html(total);
          $$('.pin__filter-count[data-count="active"]').html(active);
          $$('.pin__filter-count[data-count="redeemed"]').html(redeemed);
          if (total === 0) {
            $$('.pin__list').html('');
            $$('.pin__filter').css('display', 'none');
            $$('.pin__none').css('display', 'none');
            $$('.pin__empty').css('display', 'block');
          } else {
            $$('.pin__empty').css('display', 'none');
            $$('.pin__filter').css('display', 'flex');
            $$('.pin__list').html(html);
            // re-apply the currently selected filter
            var current = $$('.pin__filter-tab--on').attr('data-filter') || 'all';
            applyFilter(current);
          }
        }
        function applyFilter(filter) {
          var cards = $$('.pin__card');
          var shown = 0;
          for (var c = 0; c < cards.length; c++) {
            var el = cards[c];
            var match = (filter === 'all') || (el.getAttribute('data-status') === filter);
            el.style.display = match ? '' : 'none';
            if (match) shown++;
          }
          $$('.pin__none').css('display', (cards.length > 0 && shown === 0) ? 'block' : 'none');
        }
        // filter tabs (static elements — bind directly)
        $$('.pin__filter-tab').off('click').on('click', function() {
          $$('.pin__filter-tab').removeClass('pin__filter-tab--on');
          $$(this).addClass('pin__filter-tab--on');
          applyFilter(this.getAttribute('data-filter'));
        });
        // copy PIN (cards are injected dynamically — jQuery delegation)
        $(document).off('click', '.pin__copy');
        $(document).on('click', '.pin__copy', function() {
          var pin = this.getAttribute('data-pin');
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(pin).then(function() {
              app.toast.show({ text: 'PIN copied!', closeTimeout: 1500 });
            });
          } else {
            var tmp = document.createElement('input');
            tmp.value = pin; document.body.appendChild(tmp); tmp.select();
            document.execCommand('copy'); document.body.removeChild(tmp);
            app.toast.show({ text: 'PIN copied!', closeTimeout: 1500 });
          }
        });
      }
    }
  },
  {
    path: '/fund-wallet/',
    component: FundWalletPage,
    name: 'fund-wallet',
  },
  {
    path: '/settings/',
    component: SettingsPage,
    name: 'settings',
  },
  {
    path: '(.*)',
    component: NotFoundPage,
    on: {
      pageInit: function() {
        $$('.url').html(window.location);
      }
    }
  },
];

export default routes;